<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 716.59 1018.09"
    >
        <defs>
            <clipPath id="clip-path">
                <path
                    class="cls-1"
                    d="M313.94,191.55c-6,.88-12.6,2.54-17.2,6.1C285,206.74,274.14,217,263.11,227a10.38,10.38,0,0,0-2.89,5.92c-1,7.62-1.71,15.28-2.26,22.94-1.64,22.84-3.28,45.68-4.58,68.55-.21,3.8,1.31,7.7,2.06,11.72,9.11-4.93,16.77-10.36,25.29-13.43,24.55-8.86,50.23-12.23,76.23-12.23a284.58,284.58,0,0,1,38.91,2.71c17.86,2.45,35.51,6.34,51.57,15.13,4.31,2.36,8.28,5.37,12.37,8.06,4.35-7,3.94-14.54,3.4-21.83-1.77-24.17-3.67-48.33-6-72.45-.57-5.77.77-12.23-5.3-16.93a299.49,299.49,0,0,1-24.2-21.11c-7.14-6.85-15.25-11.73-25-12.56-17.91-1.52-35.89-2.83-53.85-3h-1.47c-11.15,0-22.38,1.44-33.44,3.09"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28"
                x1="-196.8"
                y1="1051.76"
                x2="-195.8"
                y2="1051.76"
                gradientTransform="matrix(0, 147.93, 147.93, 0, -155226.66, 29300.75)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#fff" />
                <stop offset="1" stop-color="#a3a2a2" />
            </linearGradient>
            <clipPath id="clip-path-2">
                <path
                    class="cls-1"
                    d="M271.06,801.47c.22,4.62,2,6.87,6.13,7.58,9.5,1.64,19,3.56,28.56,4.56,17.27,1.82,34.63,4.55,51.88,4.14,23.83-.56,47.62-3.46,71.37-5.85,5-.5,10.69-2.06,14.3-5.17,2.39-2.05,1.63-7.76,2.29-11.83.05-.33.16-.65.18-1,1-17.18,2.08-34.35,3.18-52.68-29.61,15-60.25,17.66-91.06,17.64s-61.51-2.85-90.61-17.66c1.36,20.88,2.83,40.55,3.78,60.25"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-2"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 76.57, 76.57, 0, -80173.89, 15809.96)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-3">
                <path
                    class="cls-1"
                    d="M248.17,372.22a6.9,6.9,0,0,1,.92,2.83q3.82,18.6,7.62,37.21c4,19.6,9.69,38.88,10.36,59.09.92,27.62,2.27,55.22,3.05,82.84.46,16.42.4,32.87.16,49.3-.15,9.86.18,20-2,29.48-3,12.75-8,25-12.47,37.41-1.57,4.29-4.34,4.66-8.42,2-2.23-1.47-4.33-3.12-6.87-5,0,6-.65,11.74.16,17.25,1.12,7.61,3.64,15,5,22.59.67,3.86,2.32,8.31-1.81,11.71-.51.43-.35,1.84-.29,2.79.48,6.67.76,13.36,1.59,20,1.84,14.56,3.19,29.25,6.26,43.56,1.95,9.12,9.44,15.12,17.74,20.63.1-1.67.23-2.46.18-3.25-.71-12.19-1.07-24.42-2.25-36.57-2.43-24.88.85-49.39,4-74,1.84-14.42,4.54-28.85,4.85-43.32.63-29,.23-58-.4-87q-1-46.19-3.41-92.35c-.59-11.22-2.9-22.4-5.06-33.48-3.34-17.19-7.27-34.25-10.84-51.39-1.67-8.06-3.07-16.17-4.75-25.05-3.77,4.25-7.24,7.52-3.22,12.66"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-3"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 446.36, 446.36, 0, -469200.88, 88202.35)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-4">
                <path
                    class="cls-1"
                    d="M455.42,409c-2.82,13.67-7.49,27.11-8.92,40.9-2.88,27.76-5,55.67-5.81,83.57-1,32.67-.08,65.4-.45,98.11-.29,24.88,4.27,49.25,6.83,73.84,1.33,12.79,3.11,25.63,3.08,38.45,0,16.37-1.66,32.73-2.63,49.1-.25,4.21-.57,8.41-.93,13.59,8.71-6.32,17.13-12.34,18.67-22.35,3.22-20.75,5.1-41.72,7.2-62.64.29-2.87-2.11-6-1.95-8.89a73.29,73.29,0,0,1,4.42-22.15c2.64-7,1.25-15.57,1.67-24.42-2.56,2.25-4.11,3.76-5.81,5.08-5.79,4.48-8.6,3.7-11.18-3.05-.95-2.49-1.89-5-2.75-7.52-3.15-9.32-7.39-18.44-9.09-28-1.91-10.79-2.06-22-2-33,.12-21.43.83-42.86,1.46-64.29q1-33.9,2.32-67.8a99.51,99.51,0,0,1,1.6-14.92c3.38-17.69,7-35.35,10.58-53,1.84-9,2.86-18.37,6.36-26.69,2.45-5.82,1-8.83-3.16-13.47-3.29,17.22-6.19,33.44-9.51,49.57"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-4"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 447.13, 447.13, 0, -469812.48, 88354.12)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-5">
                <path
                    class="cls-1"
                    d="M252.87,231.57c-1.48.63-3.42,1.86-3.76,3.2-6,22.88-8.58,46.26-10,69.82-.9,14.86-2,29.71-2.92,44.56-.4,6.31-1.18,12.83,6.73,15.62a5.22,5.22,0,0,1,1.41,1.14c3.77-5.3,7.13-10.14,7.26-17.53.11-6.6.87-13.15.85-19.95-.05-22.88,1.92-45.78,3.32-68.65.58-9.5,1.67-19,2.56-28.81-2.21.2-4,0-5.45.6"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-5"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 134.95, 134.95, 0, -141684.78, 26788.54)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-6">
                <path
                    class="cls-1"
                    d="M458.13,231.13c.83,10.35,1.77,20.79,2.5,31.25,1.4,20.15,2.84,40.31,3.86,60.48.22,4.18-1.42,8.43-2,12.68a17,17,0,0,0,.21,5.12c.78,4.53,1.71,9,2.63,13.55.3,1.52.39,3.25,1.19,4.47,1.63,2.46,3.68,4.64,5.54,6.94a36.53,36.53,0,0,1,5.4-3.53c2.91-1.27,3.14-3.39,2.94-6.09-1-13.49-2.13-27-2.76-40.48-1.16-25-2.93-50-8.91-74.41-2.12-8.66-1.87-8.72-10.05-10.31h0c-.11,0-.25.16-.53.34"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-6"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 134.83, 134.83, 0, -141334.06, 26764.31)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-7">
                <path
                    class="cls-1"
                    d="M466.38,799.92c-.53.64-1,1.3-1.55,1.94-6.87,8.11-14.42,14.7-26.06,14.77-3.13,0-6.32,2.41-9.34,4-1.94,1-3.51,3.41-5.45,3.68-15.67,2.19-31.34,4.89-47.1,5.76a395.4,395.4,0,0,1-78.07-3.89c-3.68-.53-8.43-1.43-10.45-3.95-3.53-4.4-7.77-5.56-12.57-5.8a26.28,26.28,0,0,1-17.45-7.59c-2.63-2.52-5-5.25-7.78-8.13-.33,1-.54,1.32-.51,1.61a6.61,6.61,0,0,0,.44,1.94c5.49,12.17,14.68,20.57,27.71,23,32.08,5.87,64.43,9.9,97.14,7.22,19.46-1.59,38.91-3.57,58.24-6.24C450.4,825.87,462,816.41,467.76,799a9.91,9.91,0,0,0-1.38.88"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-7"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 36.24, 36.24, 0, -37753.01, 7930.35)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-8">
                <path
                    class="cls-1"
                    d="M245.43,227.28c-4.22,10.43-6.13,22-14.68,30.36-.76.74-.7,2.49-.73,3.78-.39,13.9-.89,27.8-1,41.7-.17,18.88,0,37.77,0,56.6,5.34.49,5.61.41,5.82-3.29,1.06-18.88,1.63-37.79,3.19-56.62,1.35-16.29,3.86-32.48,5.71-48.72,1-8.63,5.41-16.87,3-26.29-.55,1-1,1.74-1.3,2.48"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-8"
                x1="-196.8"
                y1="1051.76"
                x2="-195.8"
                y2="1051.76"
                gradientTransform="matrix(0, 135.13, 135.13, 0, -141890.37, 26819.17)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-9">
                <path
                    class="cls-1"
                    d="M477.88,292.25c2.23,22.4,3,44.95,4.46,67.72l4.18.23c.4-8,1.15-15.54,1.08-23-.21-23.44-.8-46.87-1.07-70.31-.06-4.89.34-9.59-4.41-12.89-1.22-.85-1.78-2.79-2.42-4.32-3.27-7.84-6.47-15.72-9.69-23.58,2,22.19,5.67,44.11,7.87,66.18"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-9"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 134.13, 134.13, 0, -140596.5, 26623.36)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-10">
                <path
                    class="cls-1"
                    d="M235.05,523.86c.58,21.06,1.1,42.13,1.77,63.2.7,22.39,1.65,44.78,2.28,67.18.21,7.31,1.8,13.48,9.89,16.48-.73-8.74-1.51-17.21-2.13-25.69-1.65-22.48-3.43-44.95-4.75-67.44-1-16.85-1.41-33.74-1.87-50.61-.1-3.63-1.53-5.11-5-5.24a19.15,19.15,0,0,0-.18,2.12"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-10"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 148.98, 148.98, 0, -156446.77, 29840.55)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-11">
                <path
                    class="cls-1"
                    d="M475.69,527.46c-.25,6.51-.73,13-1,19.53-.77,20.72-1.3,41.46-2.27,62.18-.51,10.83-1.75,21.62-2.65,32.44q-1.19,14.19-2.34,28.39l1.81,1c2.44-3.3,5.69-6.29,7.07-10s.89-7.91,1.05-11.91c1.06-27.41,2.26-54.82,3-82.24.42-15,.08-30,.08-45.14-3.17.1-4.68,2.15-4.81,5.72"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-11"
                x1="-196.8"
                y1="1051.76"
                x2="-195.8"
                y2="1051.76"
                gradientTransform="matrix(0, 149.28, 149.28, 0, -156530.6, 29899.65)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-12">
                <rect
                    class="cls-1"
                    x="415.18"
                    y="186.1"
                    width="53"
                    height="42.9"
                />
            </clipPath>
            <clipPath id="clip-path-13">
                <rect
                    class="cls-1"
                    x="248.81"
                    y="186.18"
                    width="52.73"
                    height="43.36"
                />
            </clipPath>
            <clipPath id="clip-path-14">
                <path
                    class="cls-1"
                    d="M230.18,688.88a269.41,269.41,0,0,0,2,30.48c1.75,12.54,4.64,24.91,7,37.36q2.94,15.51,5.79,31l1.48.16c.72-1.61,2.2-3.31,2-4.84-1.74-16.59-3.35-33.21-5.87-49.7-.85-5.6,2.09-12.54-4.36-16.85-.47-.31-.31-1.58-.42-2.41-1.1-8.41-.16-16.64.67-25.08,1.08-10.95,1.94-22.74-5.56-32.71-1.32-1.76-1.74-4.2-2.87-7.06,0,13.81-.25,26.73.08,39.63"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-12"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 138.66, 138.66, 0, -145593.84, 27936.79)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-15">
                <path
                    class="cls-1"
                    d="M478.63,667.5a89.48,89.48,0,0,0,.31,27.51c1.32,7.86,3.08,17.32-4.06,24.49-.37.38-.27,1.27-.33,1.94-.69,8.66-1.17,17.34-2.09,26-1.17,11.11-2.42,22.23-4.23,33.25-.54,3.32-.53,5.45,3.44,7.41,2.66-16.37,5.18-32.51,7.93-48.6,1.77-10.34,5-20.56,5.61-30.94,1-17.72.48-35.53.58-53.3a13.22,13.22,0,0,0-.32-2c-3,4.7-6.15,9.33-6.84,14.31"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-13"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 134.89, 134.89, 0, -141391.17, 27198.82)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-16">
                <path
                    class="cls-1"
                    d="M476.57,388.4c-.33,4.59-1,9.18-.95,13.77q.3,55.53.81,111.07c0,2.32,0,4.64,0,7,4.38.37,5.06-1.8,5.06-5.2,0-40.21.07-80.41,0-120.61,0-2.15-1.69-4.29-2.59-6.44l-2.29.42"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-14"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 132.29, 132.29, 0, -138655.79, 26422.09)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-17">
                <path
                    class="cls-1"
                    d="M236.71,388.37c-.59,2-1.68,4.07-1.69,6.11-.08,40.2,0,80.4-.08,120.61,0,3.46.9,5.42,5.09,5.46,0-1.15,0-2,0-2.8.28-40,.61-80,.76-120,0-3.11-1.25-6.22-1.92-9.33h-2.16"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-15"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 132.19, 132.19, 0, -138788.6, 26402.29)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-18">
                <path
                    class="cls-1"
                    d="M276.3,812c3.59,2.37,7.34,4.65,11.33,5.21,16.36,2.29,32.74,5,49.21,5.81a402.54,402.54,0,0,0,88.51-5c5.31-.92,10.91-1.68,15.67-7.22-55.5,11.56-110,11.5-164.72,1.19"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-16"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 12.76, 12.76, 0, -13063.04, 3322.2)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-19">
                <path
                    class="cls-1"
                    d="M483.49,392.65V518.06c1.49-4.7,3.23-9.14,4.25-13.74a37.77,37.77,0,0,0,.94-11.25c-.55-6.54-2.61-13-2.65-19.53-.15-25.47.27-51,.4-76.42a24.23,24.23,0,0,0-.95-4.75l-2,.28"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-17"
                x1="-196.8"
                y1="1051.76"
                x2="-195.8"
                y2="1051.76"
                gradientTransform="matrix(0, 125.69, 125.69, 0, -131711.32, 25128.48)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-20">
                <path
                    class="cls-1"
                    d="M230,397.62c0,27.32.06,54.63.06,81.95,0,2,.15,4.22-.67,5.9a23.37,23.37,0,0,0-1,18.46c1.59,4.54,3.64,8.8,3.11,13.76a11.57,11.57,0,0,0,1.57.56V392.88l-2.24-.53a33.17,33.17,0,0,0-.83,5.27"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-18"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 125.89, 125.89, 0, -132178.6, 25167.98)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-21">
                <path
                    class="cls-1"
                    d="M475.67,376.72c0,5.61,2.61,10.77,7.29,12.81,6.86,3,14.5,4.16,21.81,6.11l2-2.34c-1.44-2.88-2.15-6.88-4.48-8.42a189,189,0,0,0-21.82-12,3.94,3.94,0,0,0-1.73-.45c-1.92,0-3.1,1.84-3.09,4.26"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-19"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 23.18, 23.18, 0, -23883.67, 4933.37)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-22">
                <path
                    class="cls-1"
                    d="M234.59,373.35a72.66,72.66,0,0,0-10.41,4.89,70.08,70.08,0,0,0-11.8,8.22c-1.43,1.32-1.44,4.44-1.54,6.77,0,.58,2.11,1.26,3.33,1.94,5.49-1.41,10.66-2.71,15.81-4.08,6.54-1.73,9.15-7.06,10.73-12.76.94-3.4-.67-5.54-3.45-5.54a7.35,7.35,0,0,0-2.67.56"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-20"
                x1="-196.8"
                y1="1051.77"
                x2="-195.8"
                y2="1051.77"
                gradientTransform="matrix(0, 22.38, 22.38, 0, -23311.6, 4777.01)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-23">
                <path
                    class="cls-1"
                    d="M231.46,520.66V625c4.53-2.78,5-7,4.52-11.74s-.77-9.32-.87-14c-.48-22.26-.83-44.52-1.32-66.78-.09-4-.66-8-1-11.95l-1.32.09"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-21"
                x1="-196.8"
                y1="1051.76"
                x2="-195.8"
                y2="1051.76"
                gradientTransform="matrix(0, 104.45, 104.45, 0, -109624, 21076.6)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-24">
                <path
                    class="cls-1"
                    d="M482.77,523.38c-.75,29.77-1.39,59.55-2.28,89.32-.15,5.17.09,9.81,4.1,12.48V520.7l-1.36,0a18.4,18.4,0,0,0-.46,2.72"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-22"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 104.52, 104.52, 0, -109447.35, 21090.18)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-25">
                <path
                    class="cls-1"
                    d="M275.44,185.54c-7.77,3.21-12,10.12-17.21,16.08,13.55-9.18,26.42-19.77,45.25-16.47,1.46-3.67,3.24-8.12,5.43-13.61-12,5-22.72,9.55-33.47,14"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-23"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 30.07, 30.07, 0, -31345.18, 6089.75)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-26">
                <path
                    class="cls-1"
                    d="M413,185.16c18.38-3.34,31,7.11,44.59,16.36-5-10.61-20.78-19.86-50.14-29.57,2.24,5.32,4.08,9.7,5.55,13.21"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-24"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 29.57, 29.57, 0, -30665.47, 5990.84)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-27">
                <path
                    class="cls-1"
                    d="M433.27,180.1c12.39,4.51,22.49,11.92,28.34,23.88,5.4,11.06,10,22.53,14.9,33.81,2.3,5.25,4.64,10.49,7,15.73l1.71-.61c-1.25-4.33-2-8.86-3.83-12.94-4-9-8.28-17.84-12.73-26.6-3.6-7.08-6.8-14.57-11.6-20.79-8.33-10.83-21.08-14.71-33.62-18.46-1.8-.54-3.69-.76-5.55-1.13a87.13,87.13,0,0,0,15.42,7.11"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-25"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 80.53, 80.53, 0, -84243.37, 16020.67)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-28">
                <path
                    class="cls-1"
                    d="M279.25,178.92c-11.06,4-20,10.8-25.35,21.48-7,14.16-13.71,28.5-20.3,42.88-1.25,2.72-1.35,6-2,8.95l1.26.47a51,51,0,0,0,2.43-4.55c5.22-12.43,10.15-25,15.63-37.32,6.57-14.79,16.95-25.74,32.77-31,5.17-1.7,10.13-4,15.19-6-.16-.48-.33-.95-.5-1.43-6.38,2.16-12.82,4.2-19.15,6.5"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-26"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 80.28, 80.28, 0, -84173.1, 15972.09)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-29">
                <rect
                    class="cls-1"
                    x="440.71"
                    y="787.34"
                    width="29.22"
                    height="27.24"
                />
            </clipPath>
            <clipPath id="clip-path-30">
                <rect
                    class="cls-1"
                    x="246.23"
                    y="788.1"
                    width="29.51"
                    height="26.19"
                />
            </clipPath>
            <clipPath id="clip-path-31">
                <path
                    class="cls-1"
                    d="M478.65,660.32c6.27-7.73,5.57-16.16,7-24.18-9.32,5.91-6.59,14.88-7,24.18"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-27"
                x1="-196.8"
                y1="1051.71"
                x2="-195.8"
                y2="1051.71"
                gradientTransform="matrix(0, 24.18, 24.18, 0, -24946.66, 5394.24)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-32">
                <path
                    class="cls-1"
                    d="M237.41,659.29c.06-8.24,1.82-17-6.61-23.23,1,8.28.87,16.51,6.61,23.23"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_28-28"
                x1="-196.8"
                y1="1051.79"
                x2="-195.8"
                y2="1051.79"
                gradientTransform="matrix(0, 23.23, 23.23, 0, -24203.12, 5208.64)"
                xlink:href="#Degradado_sin_nombre_28"
            />
            <clipPath id="clip-path-33">
                <path
                    class="cls-1"
                    d="M117.39,226.19h.09v-.14ZM112,187.64a19.5,19.5,0,0,0,1.62,3.83c5.62,8,10,16.51,11.43,26.36,1.12,7.7.11,8.91-7.58,8.37a26.54,26.54,0,0,0-.1,4.27c1.64,13.42,3.59,26.8,5,40.24q4.68,45.12,8.81,90.3c.34,3.66,1.59,5.15,5,5.2,11.3.15,19.46,5.87,26.3,14.33,14.29,17.7,24.73,37.65,34.27,58.12,3.38,7.24,7,14.6,8.81,22.31A369.68,369.68,0,0,1,214.47,540c.22,19.9-.64,39.85-1.9,59.72-.81,12.62-3.14,25.15-4.95,37.7-1.21,8.36-5.66,15.21-10.7,21.76-5.41,7-10.93,13.95-15.92,21.27-7.2,10.58-16.45,10.93-27.87,7.28-3.08-1-6-2.34-9.09-3.54V795.11a5.4,5.4,0,0,1-.81-3.41c-.34-34.36-.73-68.72-.93-103.08,0-3.82-1.32-5.85-4.58-7.92-10.12-6.42-19.94-13.34-29.8-20.16-3.45-2.39-6.7-5.07-10-7.61,2.51,4.78,6.15,8.72,8,13.38,8.79,22.46,10.4,44.74-3.31,66.21-.76,1.19-.65,3.3-.24,4.79,1.42,5.07,4.09,10,4.6,15.07,1.85,18.29,3.07,36.65,4.34,55,.25,3.6,1.32,4.25,4.67,3.16,7.14-2.31,14.39-4.28,21.61-6.34,4.55-1.29,9.77-4.83,11.84,3.21.06.24.47.37.67.59q4.66,5,9.3,10.06l-.12-.17c3.1,1,3.14-1.13,3.33-3.23,1.34-14.8,2.55-29.62,4.15-44.4.7-6.43,1.23-13.16,3.57-19.07,5.74-14.57,12.68-28.67,18.78-43.11,7.13-16.89,14.72-33.66,20.61-51,9.67-28.43,11.39-58.16,12.32-88,1-32.21-1.89-64.21-4.4-96.23-.77-9.77-3-19.43-4.83-29.09-.44-2.33-1.86-4.46-3.3-7.77-.71,4.42-1.18,7.31-1.89,11.68-1.67-2.73-2.66-4.19-3.5-5.73C193,421.56,181.88,401.18,171,380.69c-5.41-10.14-10.84-20.31-15.46-30.82-2-4.57-3.42-10.33-2.46-15,.82-4,1.33-7.56.54-11.46-.76-3.7-1.48-7.42-2.17-11.13-4.38-23.44-8.57-46.92-13.16-70.32-2.86-14.58-6.22-29.12-14.07-42-2.92-4.81-6.82-9-10.28-13.52L112,187.64"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_40"
                x1="-196.8"
                y1="1051.76"
                x2="-195.8"
                y2="1051.76"
                gradientTransform="matrix(0, 631.72, 631.72, 0, -664249.15, 124507.28)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#fff" />
                <stop offset="1" stop-color="#a2a2a1" />
            </linearGradient>
            <clipPath id="clip-path-34">
                <path
                    class="cls-1"
                    d="M125.16,525c-1.33-1.72-2-4-3.43-5.59-4.7-5-5.22-11.54-.37-16.53,2.16-2.22,2.81-8.78,6.8-5.93s5.72,8.64,8.45,13.15l-.87.81c-.47,1.75-1,3.48-1.4,5.23a62.21,62.21,0,0,1-2.05,8c-.63,1.58-2.19,2.78-3.33,4.15a23.53,23.53,0,0,1-3.8-3.27M53.78,368.26c-3.26.46-4.27,1.54-4.07,4.71.44,7,.62,14,.87,21.07,1.07,30.13,2.18,60.26,3.16,90.39.48,14.74.71,29.48,1.09,44.22a14.12,14.12,0,0,0,.44,2.35c27.59-1,55-2,82.66,2.37-1.16-22.84-2.34-45.19-3.42-67.55-1.43-29.6-2.87-59.19-4.13-88.79-.54-12.76,1.69-10.34-11.46-11.26q-10.28-.72-20.58-.71a317.36,317.36,0,0,0-44.56,3.2"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_40-2"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 168.32, 168.32, 0, -176936.28, 33490.02)"
                xlink:href="#Degradado_sin_nombre_40"
            />
            <clipPath id="clip-path-35">
                <path
                    class="cls-1"
                    d="M55,532.23c0,2.51-.05,4.14,0,5.76q1.47,38.64,3,77.28a91.06,91.06,0,0,0,.73,11,5.64,5.64,0,0,0,3,3.8c16.75,6.06,31.29,15.77,44.74,27.15a180.59,180.59,0,0,0,34.46,23.13V655.94l-1.81-.22c-.53,2.9-.89,5.84-1.68,8.66-.4,1.41-1.39,3.31-2.52,3.66a4.86,4.86,0,0,1-4.23-1.48c-2.12-2.78-3.68-6-5.54-9a12.07,12.07,0,0,1,.93-14.43c.92-1.14,1.5-2.57,2.49-3.63s2.29-2.4,3.36-2.33a6.29,6.29,0,0,1,3.84,2.43,59.23,59.23,0,0,1,3.89,6.38c0-12.24.14-24.39,0-36.54-.34-23.12-1-46.24-1.19-69.36,0-4.21-1.46-5.48-5.42-5.71-8.66-.5-17.3-1.88-26-2-7.15-.14-14.3-.18-21.48-.18-10.07,0-20.21.08-30.5.08"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_40-3"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 148.18, 148.18, 0, -155752.2, 29694.02)"
                xlink:href="#Degradado_sin_nombre_40"
            />
            <clipPath id="clip-path-36">
                <path
                    class="cls-1"
                    d="M68.89,201.92c-11.09,1.25-21.7-2.77-24-8.77-3.09-8.06-1.14-23,3.37-25.84-4.68-.3-6.77,1.27-6.53,6.57.47,10.21.11,20.46.11,30.69v33.12c17.41.45,33.35,3.94,46.1,16.1s19,27.27,18.67,44.83a55.48,55.48,0,0,1-13.12,35C80.45,349.43,63,355.69,43,355.4v12.17c29-3.29,57.74-6.25,86.8-2.53-.9-12-1.69-23.51-2.64-35-1-11.82-1.78-23.67-3.19-35.44-2.6-21.71-5.62-43.36-8.31-65.06-.14-1.07,1.21-2.32,1.87-3.48l-.1.15c-7-4.08-14.07-8.18-20.66-12,0,5.39,0,11.69,0,18,0,5.86.88,11.82.07,17.54-.56,3.87,0,6.49,2.26,9.5C126.12,295,106.33,348.46,62.51,358c-4,.87-8.11,1-12.17,1.44,36-6,58.81-26,58.83-62.87,0-37.1-23.06-57-59.16-62.5a46.08,46.08,0,0,1,23.34,4.65c7.3,3.74,14,8.61,21.78,13.48,0-4.89.1-9.78,0-14.67-.24-9.66-.58-19.33-.93-29-.31-8.36-.72-16.72-1.05-25.08-.16-4,1.6-5.22,5.29-3.47.8.38,1.67.63,2.51.94l.88-1.38-10.69-8.14-1.32,1v14.25C78,184.05,78.13,175.3,79.18,166.37h-6c3.11,11.24,1.93,31.46-1.88,33.87,3.22-9.08,2.1-31.06-2.38-34.44Z"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_40-4"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 201.77, 201.77, 0, -212126.44, 39873.86)"
                xlink:href="#Degradado_sin_nombre_40"
            />
            <clipPath id="clip-path-37">
                <path
                    class="cls-1"
                    d="M62.7,755.74c.12,2.13.11,4.15.38,6.13,3,21.81,6,43.61,8.89,65.43.52,3.92,2.5,5.57,6.29,5.41,3.16-.14,6.33-.37,9.5-.39,1.19,0,2.38,0,3.58.07,6.22.19,12.39.38,17.26-5.44,1.24-1.49,4.32-1.44,6.56-2.09,8.11-2.35,10-5.67,8.29-14.39-2.74.65-5.52,1.19-8.21,2-3.63,1.06-5,0-5.34-3.93-1.42-18.65-2.94-37.29-4.89-55.9-.57-5.43-2.67-10.71-4.38-17.22C89.34,747,76.69,752.52,62.7,755.74"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_40-5"
                x1="-196.8"
                y1="1051.76"
                x2="-195.8"
                y2="1051.76"
                gradientTransform="matrix(0, 97.32, 97.32, 0, -102263.12, 19887.82)"
                xlink:href="#Degradado_sin_nombre_40"
            />
            <clipPath id="clip-path-38">
                <path
                    class="cls-1"
                    d="M139.53,540.19c.54,16.72,1.21,33.43,1.65,50.15.5,19.24.76,38.49,1.21,57.73q.36,15.3,1.07,30.59c.06,1.28.73,3.2,1.68,3.67,3.81,1.87,7.84,3.3,12.52,5.18-2.85-50.81-5.64-100.65-8.45-150.65l-9.44-1.41c-.1,1.82-.29,3.28-.24,4.74"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_40-6"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 152.06, 152.06, 0, -159777.47, 30460)"
                xlink:href="#Degradado_sin_nombre_40"
            />
            <clipPath id="clip-path-39">
                <path
                    class="cls-1"
                    d="M132.33,367.91a11.75,11.75,0,0,0-.2,1.89q1.5,32.32,3,64.64c1.4,30.07,2.88,60.14,4.14,90.22.46,10.79-.85,9.07,9.93,10.13-.6-8.92-1.22-17.39-1.72-25.87q-1.53-26-3-52.07-2.22-41.07-4.3-82.16c-.29-5.78-.69-6.83-5.77-6.83-.63,0-1.34,0-2.13.05"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_40-7"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 166.93, 166.93, 0, -175425.3, 33218.87)"
                xlink:href="#Degradado_sin_nombre_40"
            />
            <clipPath id="clip-path-40">
                <path
                    class="cls-1"
                    d="M42.84,374.24c.68,13.2,1.35,26.4,1.74,39.61.85,28.28,1.51,56.58,2.28,84.87.28,10,.66,20.08,1,30.11a17.36,17.36,0,0,0,.44,2.42h5.12c-1.85-54.3-3.67-108-5.49-161.5a9.85,9.85,0,0,0-1.62-.14c-2.92,0-3.63,1.72-3.49,4.63"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_40-8"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 161.64, 161.64, 0, -169961.81, 32181)"
                xlink:href="#Degradado_sin_nombre_40"
            />
            <clipPath id="clip-path-41">
                <path
                    class="cls-1"
                    d="M48.69,533.75c0,10.18-.22,19.86.05,29.53.5,18.38,1.29,36.76,1.93,55.13.14,4.16,1.92,7.12,5.94,9.15-.68-21.34-1.34-42.21-2-63.09q-.44-13-1-26.06c-.11-2.61-.4-5.11-2.83-5.11a6.2,6.2,0,0,0-2.1.45"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_40-9"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 94.26, 94.26, 0, -99083.05, 19083.06)"
                xlink:href="#Degradado_sin_nombre_40"
            />
            <clipPath id="clip-path-42">
                <rect
                    class="cls-1"
                    x="95.52"
                    y="181.51"
                    width="27.63"
                    height="42.97"
                />
            </clipPath>
            <clipPath id="clip-path-43">
                <path
                    class="cls-1"
                    d="M151.28,386.89c-5.17,3.17-3.84,8-4.11,12.75-.3,5.4,1.59,7.42,6.72,7.78,4.17.3,11.62-1.92,13-4.94,2.12-4.68-.3-8.47-3.49-11.58-1.93-1.88-4.52-3.08-6.79-4.61-1.3-.88-2.56-1.81-3.86-2.72-.42,1-.57,2.78-1.46,3.32"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_40-10"
                x1="-196.8"
                y1="1051.76"
                x2="-195.8"
                y2="1051.76"
                gradientTransform="matrix(0, 23.88, 23.88, 0, -24961.3, 5083.65)"
                xlink:href="#Degradado_sin_nombre_40"
            />
            <clipPath id="clip-path-44">
                <rect
                    class="cls-1"
                    x="47.8"
                    y="169.27"
                    width="16.69"
                    height="28.74"
                />
            </clipPath>
            <clipPath id="clip-path-45">
                <rect
                    class="cls-1"
                    x="125.45"
                    y="804.52"
                    width="22.95"
                    height="14.05"
                />
            </clipPath>
            <clipPath id="clip-path-46">
                <rect
                    class="cls-1"
                    x="124.49"
                    y="815.52"
                    width="24.04"
                    height="8.09"
                />
            </clipPath>
            <clipPath id="clip-path-47">
                <rect
                    class="cls-1"
                    x="97.86"
                    y="205.41"
                    width="21.97"
                    height="11.58"
                />
            </clipPath>
            <clipPath id="clip-path-48">
                <path
                    class="cls-1"
                    d="M58.2,632.22c1,1.61,1.59,4.27,2.92,4.68,7.06,2.17,14.29,3.79,21.47,5.59l.51-.68L59.41,631l-1.21,1.18"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_51"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 11.45, 11.45, 0, -11973.97, 2884.77)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#fff" />
                <stop offset="1" stop-color="#c4c4c3" />
            </linearGradient>
            <clipPath id="clip-path-49">
                <rect
                    class="cls-1"
                    x="50.87"
                    y="177.62"
                    width="10.76"
                    height="8.07"
                />
            </clipPath>
            <clipPath id="clip-path-50">
                <path
                    class="cls-1"
                    d="M159.21,817.89l-.05,0,.18.15-.13-.18h0m-8.56,3.72,8.51-3.7-8.51-7.33Z"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_40-11"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 11.02, 11.02, 0, -11438.93, 2979.98)"
                xlink:href="#Degradado_sin_nombre_40"
            />
            <clipPath id="clip-path-51">
                <path
                    class="cls-1"
                    d="M566.08,810.2l.11.09c0-.08,0-.17,0-.26l-.09.17m33.07-583.91h.1l-.09-.13v.13m2.38-38.19c-9.6,9-15.24,20.57-18,33-6.59,29.11-12.19,58.44-18.09,87.7a183.77,183.77,0,0,0-3.09,19.61c-.26,2.93,2.17,6.26,1.53,9-1.87,7.89-3.6,16.12-7.3,23.2-13.47,25.76-27.72,51.1-41.68,76.6-1.72,3.14-3.49,6.26-5.93,10.63-.76-4.42-1.26-7.36-1.77-10.29a16.45,16.45,0,0,0-3.5,6.83c-6.52,27.33-7.35,55.36-8.6,83.15-1.15,25.86.46,51.89,1.76,77.79,1,19.56,4.37,39,11.69,57.2,10.91,27.08,23.28,53.56,34.69,80.44a75,75,0,0,1,5.65,19.58c2.18,17.4,3.45,34.91,5.29,52.36.13,1.21,2,2.25,3,3.36l-.09.14,8.8-12.08c.19,2.15.27,3,.34,3.76a10.71,10.71,0,0,0,1-1.92c1.92-6.39,2.52-6.72,8.78-4.88,8.16,2.41,16.37,4.65,24.47,7.25,3.5,1.12,4.7.59,5-3.34,1.22-18.35,2.48-36.71,4.33-55,.52-5.11,3.25-10,4.67-15a6.49,6.49,0,0,0-.49-4.76c-4.8-7.38-8.18-15.15-9.07-24.06-1.8-18.15.23-35.37,11.2-50.65,1.15-1.59,2.42-3.08,3.63-4.63-14.13,10-28.35,19.3-42.38,28.89a7.8,7.8,0,0,0-2.76,5.57c-.5,28.33-.8,56.66-1.11,85-.07,6,0,12.07,0,18.11v4.79h-.82V684.1c-3.32,1.35-6.3,2.84-9.44,3.79-11.66,3.56-19.7,2.61-25.6-4.94-5.56-7.11-11.09-14.25-16.32-21.61-4.6-6.47-9.72-12.54-11.54-20.81-5.21-23.63-6.53-47.68-7.62-71.68a433.15,433.15,0,0,1,3.87-79.16c1.47-10.56,2.61-21.44,6.07-31.41a287.91,287.91,0,0,1,37.94-72.6c7.77-10.93,17.06-19.82,31.88-19.77,1.12,0,3.12-2.05,3.23-3.28,1.56-16.64,2.62-33.33,4.29-50,1.91-18.94,4.33-37.83,6.51-56.74,1.14-9.88,2.24-19.76,3.36-29.64-7.94.32-8.79-.89-7.61-8.88,1.46-9.88,6-18.28,11.61-26.28.7-1,.73-2.44,1.08-3.68h-.45a2.87,2.87,0,0,0-2.25.66"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_51-2"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 630.92, 630.92, 0, -663011.82, 124351.08)"
                xlink:href="#Degradado_sin_nombre_51"
            />
            <clipPath id="clip-path-52">
                <path
                    class="cls-1"
                    d="M584.63,526.27c-1.36-5.21-2.34-10.51-3.79-17.39,1.61-3.05,3.64-7.34,6.16-11.32.49-.78,3.87-1,4.22-.42,2.77,4.5,8,7.95,7.09,14.12a18,18,0,0,1-2.87,7.21c-1.6,2.33-4.73,3.55-4.34,7.28.08.71-2,2.17-3.27,2.34h-.19c-1,0-2.79-1-3-1.83m5-159.6c-1.15,0-3.1,2.39-3.2,3.77-.86,11.67-1.47,23.37-2,35.06-.84,19.39-1.5,38.8-2.34,58.19-.37,8.52-1.08,17-1.46,25.53-.67,14.63-1.2,29.27-1.8,44.19,27.69-4.56,55-3.3,83.78-2.39,0-11.07-.15-21.91,0-32.74.32-19.09.7-38.18,1.35-57.26.77-22.57,1.81-45.13,2.82-67.69.15-3.19-.48-4.83-4.2-5.07-9-.58-17.93-2.22-26.92-2.36-2.66,0-5.31-.06-8-.06-12.7,0-25.41.42-38.12.83"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_51-3"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 167.56, 167.56, 0, -175611.33, 33341.89)"
                xlink:href="#Degradado_sin_nombre_51"
            />
            <clipPath id="clip-path-53">
                <path
                    class="cls-1"
                    d="M636.41,531.69c-17.86.6-35.69,1.9-53.54,2.77-3.78.19-4.53,1.94-4.58,5.42-.27,21.77-.76,43.53-1.22,65.3,0,2.33-.49,4.66-.5,7-.06,11.27,0,22.54,0,34.62a77.52,77.52,0,0,1,4.2-6.84c.91-1.2,2.45-2.83,3.59-2.74,1.39.11,2.73,1.74,3.93,2.87a28.4,28.4,0,0,1,2.06,2.74c4.75,5.66,4.13,12.9-1.38,17.86-1.09,1-1.52,2.68-2.51,3.82a51.28,51.28,0,0,1-4.09,3.83c-1.05-1.43-2.52-2.72-3.08-4.33-1.16-3.32-1.82-6.81-2.69-10.23l-1.34.33v27.33c10.18-6.68,20.09-12,28.62-19.05,15.67-12.92,31.57-25.18,50.86-32.33a5.77,5.77,0,0,0,3-4.18c1.42-29.57,2.63-59.15,3.85-88.73a41.78,41.78,0,0,0-.23-4.31c-7.6-.38-14.86-1.19-22-1.19-1,0-1.94,0-2.91,0"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_51-4"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 149.8, 149.8, 0, -156931.18, 30011.52)"
                xlink:href="#Degradado_sin_nombre_51"
            />
            <clipPath id="clip-path-54">
                <path
                    class="cls-1"
                    d="M599.17,226.18h0m38.15-59.82c.77,14.39-.94,17.61-11,20.19v-14.3l-1.3-.85-10,8.34.88,1.06c6.84-2.85,7.77-2.21,7.43,5.25-.17,3.51-.46,7-.62,10.52-.68,14.88-1.43,29.75-1.94,44.63-.12,3.72.57,7.47.87,11,7.47-4.72,14.14-9.77,21.51-13.38,9.91-4.84,19.9-6,23.37-4-25.33,6-30.1,8.08-38.61,15.69-11,9.85-18.92,22-20.06,36.57-3.3,42.1,18.32,64.81,58.74,71.83a9.28,9.28,0,0,1-3,.44c-18.91-1.48-34.3-9.79-45.63-24.85-17.34-23.06-17-52.76.14-76.06a10.12,10.12,0,0,0,2.25-5.23c.19-8.13,0-16.27,0-24.4,0-5.23,0-10.47,0-14.9l-21,12.43-.08-.11c.66,1,1.88,2,1.85,3a83.42,83.42,0,0,1-1,8.44c-2.57,20.05-5.32,40.07-7.64,60.14-1.6,14-2.67,28-3.86,41.94-.72,8.41-1.2,16.83-1.73,24.44,15.06,0,29.75-.37,44.41.11,14.08.46,28.14,1.81,42.34,2.78V355.63c-40.45.28-62.11-27.82-63.7-56.38a55.59,55.59,0,0,1,9.59-34.69c13.11-19.45,32.41-26.79,55.3-26.83v-6.31c0-19.12-.23-38.25.14-57.37.11-5.57-2.15-6.93-7.21-6.78,5.19,2.88,7.31,17.57,4,25.81-2.5,6.3-15.12,10.83-23.95,8.44,0-10.48,0-21-.06-31.58,0-1.28-.74-2.55-1.15-3.82-.87,1.18-2.49,2.35-2.49,3.53,0,10.21-1.81,20.51,1.14,30.58-3.91-2.13-5.25-24.39-1.88-34.21l-6,.34"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_51-5"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 201.03, 201.03, 0, -210801.07, 39728.07)"
                xlink:href="#Degradado_sin_nombre_51"
            />
            <clipPath id="clip-path-55">
                <path
                    class="cls-1"
                    d="M611.59,751.48c-2,19.26-3.46,38.58-5,57.88-.23,3-1.66,3.83-4.17,3.35-3.09-.59-6.13-1.46-9.59-2.31-1,9.82.72,12.17,9.35,14.9,3.7,1.16,7,3.52,10.56,5.19a15.65,15.65,0,0,0,5.4,1.83c6.83.34,13.69.48,20.53.47,3.72,0,5.43-2,5.91-5.91,2.12-17.21,4.55-34.38,6.84-51.58.88-6.55,1.67-13.11,2.48-19.58-14.38-3.16-26.72-8.92-38-20.08-1.65,5.86-3.82,10.77-4.33,15.84"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_51-6"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 97.15, 97.15, 0, -101554.94, 19854.7)"
                xlink:href="#Degradado_sin_nombre_51"
            />
            <clipPath id="clip-path-56">
                <path
                    class="cls-1"
                    d="M567.24,536.88c-2.8,50-5.59,99.87-8.44,150.63,4.32-1.69,7.87-2.72,11-4.48a6.86,6.86,0,0,0,3.19-4.7q1.28-29.62,2-59.26c.58-24,.9-47.93,1.39-71.9.07-3.78.45-7.55.72-11.77l-9.89,1.48"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_51-7"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 152.11, 152.11, 0, -159415.15, 30470.62)"
                xlink:href="#Degradado_sin_nombre_51"
            />
            <clipPath id="clip-path-57">
                <path
                    class="cls-1"
                    d="M576.32,374.65c-.1,3.18-.1,6.37-.28,9.55q-2.41,42.06-4.89,84.12c-.87,14.69-2,29.36-2.73,44.06-.36,7.27-.06,14.58-.06,22.3l8.58-1.15c2.58-55.55,5.13-110.65,7.68-165.77l-2.34,0c-5.71,0-5.78.71-6,6.91"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_51-8"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 166.94, 166.94, 0, -175004.33, 33221.52)"
                xlink:href="#Degradado_sin_nombre_51"
            />
            <clipPath id="clip-path-58">
                <path
                    class="cls-1"
                    d="M663.1,531.29h5.45c1.61-53.64,3.22-107.12,4.83-160.95l-4.85-1.15c-1.82,54.31-3.62,108.1-5.43,162.1"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_51-9"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 162.11, 162.11, 0, -169828.33, 32271.63)"
                xlink:href="#Degradado_sin_nombre_51"
            />
            <clipPath id="clip-path-59">
                <path
                    class="cls-1"
                    d="M662.91,539.6c-.62,16.71-1.51,33.41-1.92,50.12-.32,12.48-.07,25-.07,37.45l.77.66c1.38-3,3.72-6,4-9.12,1-13,1.57-26,2-39.05.38-12.39.31-24.78.5-37.18,0-2.91.3-5.82.46-8.73-.88,0-1.62-.08-2.23-.08-3.16,0-3.24.93-3.43,5.93"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_51-10"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 94.16, 94.16, 0, -98371.53, 19064.82)"
                xlink:href="#Degradado_sin_nombre_51"
            />
            <clipPath id="clip-path-60">
                <rect
                    class="cls-1"
                    x="593.36"
                    y="181.35"
                    width="27.74"
                    height="43.17"
                />
            </clipPath>
            <clipPath id="clip-path-61">
                <path
                    class="cls-1"
                    d="M559.45,386.31c-5.57,1.63-8.26,6-10.18,10.79-1.29,3.25-.2,6.07,3.21,7.9a18.11,18.11,0,0,0,12.92,1.86c2.67-.55,3.87-1.31,3.75-4-.25-5.73,2-12-4.18-16.35-.82-.57-.87-2.26-1.14-3-1.46,1-2.78,2.39-4.38,2.86"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_51-11"
                x1="-196.8"
                y1="1051.78"
                x2="-195.8"
                y2="1051.78"
                gradientTransform="matrix(0, 23.86, 23.86, 0, -24536.8, 5079.26)"
                xlink:href="#Degradado_sin_nombre_51"
            />
            <clipPath id="clip-path-62">
                <rect
                    class="cls-1"
                    x="651.97"
                    y="169.26"
                    width="17.88"
                    height="28.87"
                />
            </clipPath>
            <clipPath id="clip-path-63">
                <rect
                    class="cls-1"
                    x="568.13"
                    y="804.66"
                    width="22.99"
                    height="14.11"
                />
            </clipPath>
            <clipPath id="clip-path-64">
                <rect
                    class="cls-1"
                    x="568.19"
                    y="815.5"
                    width="24.2"
                    height="8.14"
                />
            </clipPath>
            <clipPath id="clip-path-65">
                <rect
                    class="cls-1"
                    x="596.34"
                    y="205.5"
                    width="21.97"
                    height="11.65"
                />
            </clipPath>
            <clipPath id="clip-path-66">
                <rect
                    class="cls-1"
                    x="654.94"
                    y="177.61"
                    width="10.75"
                    height="8.08"
                />
            </clipPath>
            <clipPath id="clip-path-67">
                <path
                    class="cls-1"
                    d="M557,818.35l.14-.12,0,0Zm.14-.12,8.91,3.16v-11l-8.91,7.84m8.91-7.84.11-.1-.11-.09Z"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_51-12"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 11.2, 11.2, 0, -11215.18, 3013.81)"
                xlink:href="#Degradado_sin_nombre_51"
            />
            <clipPath id="clip-path-68">
                <rect
                    class="cls-1"
                    x="337.88"
                    y="671.08"
                    width="40.58"
                    height="2.5"
                />
            </clipPath>
            <clipPath id="clip-path-69">
                <rect
                    class="cls-1"
                    x="99.18"
                    y="194.37"
                    width="13.23"
                    height="8.39"
                />
            </clipPath>
            <clipPath id="clip-path-70">
                <rect
                    class="cls-1"
                    x="604.18"
                    y="194.31"
                    width="13.19"
                    height="8.58"
                />
            </clipPath>
            <clipPath id="clip-path-71">
                <path
                    class="cls-1"
                    d="M349.05,847.9c-18.11.35-36.21.56-54.31,1.12-13.88.43-27.76,1.06-41.61,2.06-7.66.55-14.11,4-19.51,10.84,2.73,0,4.54,0,6.34,0,10.87.36,21.88-.22,32.56,1.38,14.15,2.13,15.22,3.59,19,16.89,2.26,8,0,10.73-8.44,11-7.37.2-14.76,0-22.13.35a20.45,20.45,0,0,0-7.94,2.17c-7.31,3.69-14.43,4.77-21.9.38-2-1.16-4.54-1.32-8.41-2.37.68,7.58.7,13.93,2,20,1,4.91,4.56,7.78,10.23,7.81,21.45.13,42.9.75,64.35.74,42.58,0,85.16-.32,127.75-.51,18.11-.08,36.22-.28,54.33-.24,4.85,0,8.62-1.83,9.56-6.39,1.39-6.7,1.72-13.63,2.65-21.84-4.33,1.49-7.1,2.1-9.55,3.34-5.94,3-12.12,3.67-17.74.27-5.37-3.25-10.86-3.64-16.75-3.51s-11.75,0-17.61-.27c-6.32-.34-8-2.41-7.73-8.41.55-10.2,5.52-17.22,15.5-18.47,12.89-1.61,26-1.61,39-2.3,1.18-.07,2.36-.17,4-.28-7.22-8.6-16.44-11.1-26.38-11.46q-34.67-1.26-69.34-2.13c-8.1-.21-16.21,0-24.32,0,5,3,8.07,7,8,12.73s-3.33,9.5-8.13,12.55h61.47a63.51,63.51,0,0,0-2.76,6.32c-1.78,5.9-3.28,11.9-5.11,17.79s-5,8.05-11.11,8.09c-8.33,0-16.67,0-25,0q-34.15,0-68.29,0c-6.53,0-9.37-2-11.51-8.26-.76-2.2-1.14-4.53-1.83-6.75-1.74-5.64-3.56-11.25-5.47-17.25H355c-12.23-7.57-12.28-17.3-.43-25.34l-3.67,0-1.8,0"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_61"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 72.37, 72.37, 0, -75753.1, 15089.42)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#fff" />
                <stop offset="1" stop-color="#bfbfbf" />
            </linearGradient>
            <clipPath id="clip-path-72">
                <path
                    class="cls-1"
                    d="M237.4,852.18c-2.22,1.14-4.11,2.91-6.34,4-4.27,2.09-9.22,3.19-12.9,6-4,3-2.54,7.2,1.9,9.2,1.29.58,2.86,3,2.58,4.14-.69,2.85-2.38,5.46-3.62,8.08,0,1.71.38,3.65-.07,5.37-1.9,7.25-5.47,14.37-5.81,21.66-.73,15.51.17,31.1.39,46,8.36-1.63,15.63-3,22.86-4.51,1.71-.36,4-.87,4.79-2.1,3.37-5.44,8.33-5.92,13.94-5.61,4.85.27,9.73.06,14.59.06q97.13,0,194.26.09c2.62,0,6.45.53,7.63,2.25,3.6,5.22,8.47,5.62,13.94,6,3.4.22,6.77,1.5,10.08,2.53a60,60,0,0,1,6.29,2.82c.59-10.92.91-20.94,1.73-30.93,1-12.65-1.89-24.52-5.93-36.32-.82-2.41-.12-5.33-.12-8-.21.19-.42.38-.64.56-1.58-3.44-3.17-6.88-4.84-10.49,3.77-2,8.53-1.77,7.7-7.27-.74-4.93-4.51-6.32-8.34-7.55s-7.71-2.05-12.46-3.27c2.31,2.66,4.08,4.44,5.54,6.43,10.28,14.05,10.85,30.29,9.5,46.57-.9,10.76-5,13.53-16,13.58q-24.4.12-48.81.11-96.12,0-192.25-.13c-10.2,0-14.9-4.72-15.16-15a139.26,139.26,0,0,1,.12-16.09c.89-9.67,2-19.59,8.41-27.37,4.11-5,9.57-8.85,15.46-14.16-3.46,1.38-6.06,2.2-8.46,3.42"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_61-2"
                x1="-196.8"
                y1="1051.76"
                x2="-195.8"
                y2="1051.76"
                gradientTransform="matrix(0, 109.38, 109.38, 0, -114677.67, 22373.71)"
                xlink:href="#Degradado_sin_nombre_61"
            />
            <clipPath id="clip-path-73">
                <path
                    class="cls-1"
                    d="M464.22,945.74q-106.1.06-212.17,0c-4,0-7.1,1.26-8.78,6.1,76.74-3.36,152.94-3.23,229.78-.06-2.21-4.49-4.88-6-8.82-6h0"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_61-3"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 6.11, 6.11, 0, -6071.53, 2148.83)"
                xlink:href="#Degradado_sin_nombre_61"
            />
            <clipPath id="clip-path-74">
                <rect
                    class="cls-1"
                    x="223.92"
                    y="863.47"
                    width="50.54"
                    height="31.09"
                />
            </clipPath>
            <clipPath id="clip-path-75">
                <rect
                    class="cls-1"
                    x="441.19"
                    y="863.46"
                    width="51.83"
                    height="31.46"
                />
            </clipPath>
            <clipPath id="clip-path-76">
                <path
                    class="cls-1"
                    d="M308.17,981.17a504.21,504.21,0,0,0,100.17,0Z"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_61-4"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 2.49, 2.49, 0, -2257.87, 1470.69)"
                xlink:href="#Degradado_sin_nombre_61"
            />
            <clipPath id="clip-path-77">
                <rect
                    class="cls-1"
                    x="425.5"
                    y="868.2"
                    width="10.26"
                    height="21.12"
                />
            </clipPath>
            <clipPath id="clip-path-78">
                <rect
                    class="cls-1"
                    x="280.33"
                    y="868.52"
                    width="10.23"
                    height="20.77"
                />
            </clipPath>
            <clipPath id="clip-path-79">
                <path
                    class="cls-1"
                    d="M383.35,986.1c10.34.34,20.78,1.83,30.75-1.83L414,983l-30.63,3.14"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_61-5"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 3.73, 3.73, 0, -3523.08, 1716.79)"
                xlink:href="#Degradado_sin_nombre_61"
            />
            <clipPath id="clip-path-80">
                <path
                    class="cls-1"
                    d="M301.72,984.27c9.86,3.38,20.12,2.37,30.33,1.77l-30.21-3.1-.12,1.33"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_61-6"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 3.73, 3.73, 0, -3600.97, 1716.03)"
                xlink:href="#Degradado_sin_nombre_61"
            />
            <clipPath id="clip-path-81">
                <rect
                    class="cls-1"
                    x="236.36"
                    y="873.17"
                    width="12.71"
                    height="12.85"
                />
            </clipPath>
            <clipPath id="clip-path-82">
                <rect
                    class="cls-1"
                    x="466.91"
                    y="873.18"
                    width="12.67"
                    height="12.84"
                />
            </clipPath>
            <clipPath id="clip-path-83">
                <path
                    class="cls-1"
                    d="M480,61.2c-12.93-1.37-26.36-2.82-39.8-4.18-3.65-.37-7.38-.17-11-.82-1.48-.26-3.53-1.83-3.89-3.19-1.49-5.61-2.39-11.38-3.6-17.07-.8-3.75,1-5,4.36-4.66,15.42,1.63,30.85,3.19,46.25,5.09a11.49,11.49,0,0,1,10.32,8.94c.93,3.54,2.07,7,2.83,10.6.69,3.19.41,5.76-2.72,5.76A10.3,10.3,0,0,1,480,61.2m-249.1-4.72c1.11-4.68,2.11-9.48,4.05-13.84,2.8-6.27,9.22-6.63,14.95-7.31,12.91-1.53,25.87-2.68,38.81-4,5.44-.55,6.43.24,5.65,5.52-.84,5.59-2,11.14-3.29,16.64a4.25,4.25,0,0,1-2.83,2.71c-17.57,1.68-35.16,3.16-52.75,4.69a7,7,0,0,1-2.42.52c-2.35,0-2.84-2.1-2.17-4.93m27.32-27.24c-10.08,1.25-20.07,3.25-30.06,5.13-3.71.7-6.92,2.22-7.16,7-1,19.55-2.23,39.09-3.15,58.64-.32,6.94,2.47,12.85,6.69,18.41a77.26,77.26,0,0,1,7.6,13.35c4.34,9,8.39,18.08,12.71,27.45l5.34-3.38c-6.68-9.46-4.73-20.12-5.31-30.61-5.89-.14-9.85-3.31-11.09-8.55-1.57-6.58-2.08-13.41-3-20.14-.42-3,.69-4.81,4-5,16.5-.94,33-2.09,49.51-2.75,3.55-.14,6.38,2.33,6.18,6.48-.19,3.78-.77,7.54-1.18,11.31a11,11,0,0,0,2-4.71q7-30.74,14-61.46c1.54-6.73,6.54-11.19,13.43-11.23q39.48-.2,79,0c7.12,0,12.05,4.52,13.68,11.59,4.44,19.31,8.83,38.62,13.28,58.13,3.58-10.38,3.59-10.62,14.91-10.24,12.87.43,25.73,1.18,38.57,2.07,7.25.5,7.76,1.36,7.6,8.6,0,2,0,4-.16,6-.77,11.76-5.18,18.21-14,20.14-.21,10.54,1,21-5.09,30.41l4.92,3.13c3.2-6.44,6.29-12.7,9.42-18.94,3.64-7.25,6.71-14.89,11.16-21.62,3.92-5.92,7.1-11.77,6.73-18.91-.84-16-2.14-32-2.86-48.08-.8-18,.74-16.24-16.22-18.92-23.54-3.71-47.45-6.51-71.24-6.9-21.36-.35-42.72-.87-64.09-.87-28.7,0-57.39.93-86,4.46"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_61-7"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 134.41, 134.41, 0, -141009.04, 26476.71)"
                xlink:href="#Degradado_sin_nombre_61"
            />
            <clipPath id="clip-path-84">
                <path
                    class="cls-1"
                    d="M378.8,108.9c-9.18.56-18.32.31-27.45.06-5.24-.14-10.47-.28-15.7-.27-15.58,0-31.17,0-47,0-3.81,10.46-7.57,20.76-11.32,31.06l-1.55-.56c3.29-9.3,6.57-18.61,10.29-29.14a70.6,70.6,0,0,1-39.94,15.36c1,8.43,1.73,16.5,2.94,24.51.52,3.38,2.83,4.83,6.64,4.3a129.49,129.49,0,0,1,15.51-1c22.12-.43,44.23-1,66.34-1,21.11-.05,42.22.35,63.32.73,20.26.36,40.52,1,60.78,1.25,1.85,0,4.64-2,5.44-3.72,3.63-8,2.19-16.61,2.31-25.17-14.46-.86-26.79-5.88-38.94-14.89,3.69,10.5,6.91,19.63,10.12,28.77l-1.53.51c-3.75-10.25-7.5-20.51-11.31-30.9h-5.24c-9,0-18-.28-27-.28-5.59,0-11.18.1-16.76.45"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_61-8"
                x1="-196.8"
                y1="1051.77"
                x2="-195.8"
                y2="1051.77"
                gradientTransform="matrix(0, 45.89, 45.89, 0, -47907.34, 9139.59)"
                xlink:href="#Degradado_sin_nombre_61"
            />
            <clipPath id="clip-path-85">
                <path
                    class="cls-1"
                    d="M406.19,58.56c0,4.18.15,7.85,0,11.5s1.71,8-4.59,10.15c10.32.53,12.87,2.42,16,11,1.88,5.18,3.69,10.39,5.52,15.59l1.34-.42c-3.59-16-7.18-31.95-10.82-48.18l-7.38.38"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_61-9"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 48.6, 48.6, 0, -50698.3, 9621.86)"
                xlink:href="#Degradado_sin_nombre_61"
            />
            <clipPath id="clip-path-86">
                <path
                    class="cls-1"
                    d="M302.9,58.49c-3.59,16.1-7.11,31.91-10.64,47.72l1.45.36c1.61-4.85,3.44-9.64,4.76-14.56,2.15-8,7.08-12.09,15.12-11.72C307,74,312.43,65.6,309.66,58.49Z"
                />
            </clipPath>
            <linearGradient
                id="Degradado_sin_nombre_61-10"
                x1="-196.8"
                y1="1051.75"
                x2="-195.8"
                y2="1051.75"
                gradientTransform="matrix(0, 48.07, 48.07, 0, -50256.66, 9518.95)"
                xlink:href="#Degradado_sin_nombre_61"
            />
            <clipPath id="clip-path-87">
                <rect
                    class="cls-1"
                    x="231.91"
                    y="90.61"
                    width="35.72"
                    height="17.08"
                />
            </clipPath>
            <clipPath id="clip-path-88">
                <rect
                    class="cls-1"
                    x="449.02"
                    y="90.61"
                    width="35.26"
                    height="16.44"
                />
            </clipPath>
            <clipPath id="clip-path-89">
                <rect
                    class="cls-1"
                    x="438.91"
                    y="97.5"
                    width="11.38"
                    height="12.05"
                />
            </clipPath>
            <clipPath id="clip-path-90">
                <rect
                    class="cls-1"
                    x="266.12"
                    y="98.4"
                    width="11.58"
                    height="11.14"
                />
            </clipPath>
            <clipPath id="clip-path-91">
                <rect
                    class="cls-1"
                    x="259.89"
                    y="91.75"
                    width="24.11"
                    height="2.54"
                />
            </clipPath>
            <clipPath id="clip-path-92">
                <rect
                    class="cls-1"
                    x="433.75"
                    y="91.68"
                    width="22.47"
                    height="2.54"
                />
            </clipPath>
            <clipPath id="clip-path-93">
                <rect
                    class="cls-1"
                    x="258.14"
                    y="112.5"
                    width="15.17"
                    height="9.64"
                />
            </clipPath>
            <clipPath id="clip-path-94">
                <rect
                    class="cls-1"
                    x="443.15"
                    y="112.55"
                    width="15.17"
                    height="9.46"
                />
            </clipPath>
            <clipPath id="clip-path-95">
                <rect
                    class="cls-1"
                    x="239.5"
                    y="117.5"
                    width="18.69"
                    height="5.06"
                />
            </clipPath>
            <clipPath id="clip-path-96">
                <rect
                    class="cls-1"
                    x="457.56"
                    y="99.63"
                    width="20.77"
                    height="19.93"
                />
            </clipPath>
            <clipPath id="clip-path-97">
                <rect
                    class="cls-1"
                    x="238.19"
                    y="99.63"
                    width="20.76"
                    height="19.96"
                />
            </clipPath>
            <clipPath id="clip-path-98">
                <rect
                    class="cls-1"
                    x="426.44"
                    y="50.65"
                    width="55.93"
                    height="9.39"
                />
            </clipPath>
            <clipPath id="clip-path-99">
                <rect
                    class="cls-1"
                    x="424.3"
                    y="39.21"
                    width="54.41"
                    height="7.22"
                />
            </clipPath>
            <clipPath id="clip-path-100">
                <rect
                    class="cls-1"
                    x="425.55"
                    y="45.14"
                    width="54.84"
                    height="7.13"
                />
            </clipPath>
            <clipPath id="clip-path-101">
                <rect
                    class="cls-1"
                    x="423.5"
                    y="32.92"
                    width="49.32"
                    height="6.28"
                />
            </clipPath>
            <clipPath id="clip-path-102">
                <rect
                    class="cls-1"
                    x="234.47"
                    y="50.58"
                    width="55.63"
                    height="9.42"
                />
            </clipPath>
            <clipPath id="clip-path-103">
                <rect
                    class="cls-1"
                    x="237.5"
                    y="38.18"
                    width="55.1"
                    height="8.41"
                />
            </clipPath>
            <clipPath id="clip-path-104">
                <rect
                    class="cls-1"
                    x="236.12"
                    y="45.14"
                    width="54.69"
                    height="7.13"
                />
            </clipPath>
            <clipPath id="clip-path-105">
                <rect
                    class="cls-1"
                    x="243.7"
                    y="32.89"
                    width="49.29"
                    height="6.33"
                />
            </clipPath>
        </defs>
        <title>Recurso 5</title>
        <g id="Capa_2" data-name="Capa 2">
            <g id="Capa_1-2" data-name="Capa 1">
                <path
                    class="cls-2"
                    d="M227.84,393.86c-4.26.92-8,2.07-11.76,2.41-2.24.21-6.48-.61-6.57-1.37-.38-3.06-.63-7.4,1.16-9.21,3.9-3.93,8.93-6.86,13.79-9.69,2.51-1.46,3.5-2.9,3.44-5.8-.42-19.59-.92-39.18-.89-58.78,0-16.92.16-33.88,1.36-50.74.55-7.81,3-15.72,5.93-23.08,4.58-11.61,10.11-22.86,15.52-34.12C256.29,190,267,181.31,280.93,176c10.62-4,21.49-5.22,32.69-5.86,16.83-1,33.6-3.85,50.41-3.92,13.42-.06,26.83,4,40.28,4.16A90.94,90.94,0,0,1,442,179c12.25,5.64,20.46,14.94,25.62,27.45,4.39,10.62,10.14,20.68,14.54,31.29,2.65,6.39,4.94,13.28,5.49,20.09,1.09,13.5.85,27.11,1.19,40.67.25,9.88.82,19.75.77,29.63-.06,13.05-.29,26.13-1.08,39.15-.34,5.62,1.57,8.42,6.57,10.54a32.06,32.06,0,0,1,9.72,6.83c1.68,1.67,2.48,4.6,2.88,7.09.58,3.56-1.36,5.43-5.06,4.82-4.75-.79-9.47-1.74-14.58-2.69-.07,1.65-.22,3.25-.22,4.85-.05,26.5-.26,53,0,79.5.06,5.67,2.43,11.28,2.84,17,.27,3.85-1,7.84-1.68,11.73-.68,3.68-2.24,7.31-2.26,11q-.21,42.51.07,85,.24,41.49.85,83a211.93,211.93,0,0,1-5.82,52.63c-4,16.67-6,33.83-9.24,50.69-2.47,12.69-7.47,24.49-18,32.55a37,37,0,0,1-16.75,7.32c-22.83,3-45.76,5.33-68.7,7.42-23.14,2.11-46-1.58-69-3.88-11.85-1.19-24.14-1.79-34.14-8.5-6.61-4.44-13.2-10.89-16.44-18C240.87,787,239,766,236,745.36a111.73,111.73,0,0,0-3.15-15.18c-3.44-11.71-4-23.71-4-35.76q0-50.56.33-101.13c.14-26.15.66-52.3.46-78.44,0-5.11-3.09-10.12-3.81-15.31-.55-4,.18-8.22.71-12.3s2.17-8,2.17-12.06c0-26.15-.38-52.3-.64-78.44,0-.83-.11-1.66-.2-2.88M439.16,651.79c0-35.28.12-70.12,0-104.95s2.17-69.52,5.9-104.43a22.08,22.08,0,0,0-3-1.29c-4.17-1.17-8.32-2.47-12.56-3.31-29.09-5.79-58.63-3.93-88-4.64-13.65-.33-27.39,1.29-41,2.81-9.82,1.09-19.5,3.49-29.26,5.3,8.11,70.84,6.5,140.66,6.38,210.58,53.85,13.87,107.48,13.82,161.6-.07M255.44,336.15c9.11-4.93,16.77-10.36,25.29-13.43,24.55-8.86,50.23-12.23,76.23-12.23a284.58,284.58,0,0,1,38.91,2.71c17.86,2.45,35.51,6.34,51.57,15.13,4.32,2.36,8.28,5.37,12.37,8.06,4.35-7,3.94-14.54,3.4-21.83-1.77-24.17-3.67-48.33-6-72.45-.57-5.77.77-12.23-5.3-16.93a301.35,301.35,0,0,1-24.21-21.11c-7.13-6.85-15.24-11.73-25-12.56-17.91-1.52-35.89-2.83-53.85-3-11.63-.14-23.36,1.36-34.91,3.08-6,.88-12.6,2.54-17.2,6.1C285,206.74,274.14,217,263.11,227a10.38,10.38,0,0,0-2.89,5.92c-1,7.62-1.71,15.28-2.26,22.94-1.64,22.84-3.28,45.68-4.58,68.55-.21,3.8,1.31,7.7,2.06,11.72m75.48,88c2.74-7.59,8.15-10,15.78-9.58a245.32,245.32,0,0,0,25.15,0c6.49-.28,10.78,2.53,12.88,8.25,1.31,3.6,3.46,4.1,6.74,4.24,15.34.67,30.76.84,45.42,6.52,5.33,2.06,6.11,1.35,7.37-4.36,4.17-18.9,8.5-37.76,12.47-56.71a24.53,24.53,0,0,0-.28-10.3c-1.75-7.45-8.69-9.39-14.58-11.65-27.75-10.67-57-12.81-86.26-13-14.8-.11-29.67,1.93-44.41,3.74a146.34,146.34,0,0,0-41.44,11.19c-9.28,4.1-12.49,10.73-10.21,20.69q2.35,10.23,4.64,20.49c2.76,12.38,5.38,24.79,8.34,37.12.35,1.48,2.42,2.54,3.69,3.8,1-1.23,2.07-2.44,3.07-3.69,2.38-3,4.14-7,7.21-8.89,14.79-9,29.48-7.62,44.42,2.13M449,741.24c-29.61,15-60.25,17.66-91.06,17.64s-61.51-2.85-90.61-17.66c1.36,20.88,2.83,40.55,3.78,60.25.22,4.62,2,6.87,6.13,7.58,9.5,1.64,19,3.56,28.56,4.56,17.27,1.82,34.63,4.55,51.88,4.14,23.83-.56,47.62-3.46,71.37-5.85,5-.5,10.69-2.06,14.3-5.17,2.39-2.05,1.63-7.76,2.29-11.83.05-.33.16-.65.18-1,1-17.18,2.08-34.35,3.18-52.68M240.5,667.39c0,6-.65,11.74.15,17.25,1.12,7.6,3.65,15,5,22.59.67,3.86,2.32,8.31-1.81,11.71-.51.43-.35,1.84-.29,2.79.48,6.67.76,13.36,1.59,20,1.84,14.56,3.19,29.25,6.26,43.56,2,9.12,9.44,15.12,17.74,20.63.1-1.67.23-2.46.18-3.25-.71-12.19-1.07-24.42-2.25-36.57-2.43-24.89.85-49.4,4-74,1.84-14.42,4.54-28.85,4.85-43.32.63-29,.23-58-.4-87q-1-46.19-3.41-92.35c-.59-11.22-2.9-22.4-5.06-33.48-3.34-17.19-7.27-34.25-10.84-51.39-1.67-8.06-3.07-16.17-4.75-25.05-3.77,4.25-7.24,7.52-3.22,12.66a6.85,6.85,0,0,1,.92,2.83q3.82,18.6,7.62,37.21c4,19.6,9.69,38.88,10.36,59.09.92,27.62,2.27,55.22,3.05,82.84.46,16.42.4,32.87.16,49.3-.15,9.86.18,20-2,29.48-3,12.75-8,25-12.47,37.41-1.57,4.29-4.34,4.66-8.42,2-2.23-1.47-4.33-3.12-6.87-5m224.43-308c-3.29,17.22-6.19,33.44-9.51,49.57-2.82,13.67-7.49,27.11-8.92,40.9-2.88,27.76-5,55.67-5.81,83.57-1,32.67-.08,65.4-.45,98.11-.29,24.88,4.27,49.25,6.83,73.84,1.33,12.79,3.11,25.63,3.08,38.45,0,16.37-1.66,32.74-2.63,49.1-.25,4.21-.57,8.41-.93,13.59,8.71-6.32,17.12-12.34,18.67-22.35,3.22-20.75,5.1-41.72,7.2-62.64.29-2.87-2.11-6-1.95-8.89a73.29,73.29,0,0,1,4.42-22.15c2.64-7,1.25-15.58,1.67-24.42-2.56,2.25-4.11,3.76-5.81,5.08-5.79,4.48-8.6,3.7-11.18-3.05-.95-2.49-1.89-5-2.75-7.52-3.15-9.32-7.39-18.44-9.09-28-1.91-10.79-2.06-22-2-33,.11-21.43.83-42.86,1.46-64.29q1-33.9,2.32-67.8a99.51,99.51,0,0,1,1.6-14.92c3.38-17.69,7-35.35,10.58-53,1.84-9,2.86-18.37,6.36-26.69,2.45-5.82,1-8.83-3.16-13.47M328.32,430.37c.12.38.23.76.35,1.13,1.28.09,2.56.25,3.84.27,23.63.35,47.28.12,70.86,1.26,12.07.58,24.09,3.27,36,5.62,7.14,1.41,7.29,2,8.89-5.41,3.55-16.46,7-33,10.12-49.51,2-10.64,4-21.36,4.79-32.13a20.26,20.26,0,0,0-4.53-13.17c-3.29-3.92-8.45-6.47-13.15-9-18.93-10-39.68-14.34-60.6-16-21.78-1.69-43.83-2.27-65.6,1.57-17.09,3-34.23,6.18-49.53,14.94-6.06,3.48-13.69,6.15-15.48,13.95a44.19,44.19,0,0,0-.69,16.83c3.13,18.59,6.9,37.07,10.64,55.55,1.61,7.94,3.75,15.78,5.38,22.53l58.8-8.2c-2.79-.79-4.61-1.8-6.39-1.74-14.19.51-28.35,1.22-41.9,6.31-6.71,2.51-8.18,1.54-9.74-5.4-4.36-19.37-9.36-38.63-12.73-58.17-2.38-13.81-1.53-22.32,15.91-27.75,19.9-6.19,40.07-10.7,60.79-11.55,18-.74,36.07.1,54.1.73,20,.71,39.24,5.77,58.07,12.28a22.14,22.14,0,0,1,9,5.8c5.12,5.76,4.7,13.15,3.29,20-4.17,20.09-9.05,40-13.25,60.12-1,4.88-3.49,5.79-7.37,4.52-11.34-3.7-22.79-6.28-34.84-6.3-24,0-47.92-.43-71.88-.57-1.05,0-2.11.93-3.16,1.43M439.14,653.66c-54.25,13.83-107.91,13.69-162,.06-3.33,29.14-6.56,57.31-9.8,85.58,13.95,6.51,27.67,12.13,42.6,13.76,16.09,1.76,32.22,3.87,48.37,4.34,12.29.36,24.66-1.42,37-2.6a149.4,149.4,0,0,0,49.93-13.72c2.54-1.2,3.53-2.55,3.16-5.3-.76-5.8-1.32-11.62-2-17.43-2.39-21.22-4.78-42.44-7.28-64.69M267.39,524.13c-.88-21.23-1.65-40.94-2.54-60.64a63.71,63.71,0,0,0-1.23-9.93c-3.38-16.49-6.95-32.95-10.32-49.45-1.46-7.16-3.37-9.24-11.29-10.81q0,56.16.05,112.16c0,1.18.49,2.88,1.34,3.44,7.5,4.93,15.13,9.65,24,15.23M473.74,392.66a74.27,74.27,0,0,0-7.42,3.87c-1.17.78-2.52,2.16-2.72,3.44-4.06,26-12.83,51.22-12.85,77.95,0,14.86-1.08,29.72-1.7,45.47,2.46-1.2,4.14-1.83,5.64-2.77,5.53-3.45,10.95-7.08,16.51-10.47,2.57-1.56,3.41-3.48,3.37-6.52-.38-29.17-.59-58.34-.82-87.51-.06-7.54,0-15.08,0-23.46M242.29,537.76c1.36,28.46,2.61,55.68,4,82.88.18,3.55,3.17,4.6,6.56,2.28,4.68-3.2,9.23-6.61,13.7-10.1a4.81,4.81,0,0,0,1.73-3.29q0-31.6-.22-63.22c0-.82-.66-2.21-1.27-2.38-7.7-2-15.45-3.92-24.49-6.17m205.2,6.77c0,20,.37,40.2-.22,60.39-.18,6.41,3.4,9,7.48,11.71s8.77,4.85,13.21,7.17c.27.14.85-.32,2.3-.93,1.19-27.87,2.4-56.1,3.65-85.17l-26.42,6.83M258.32,231c-2.21.21-4,0-5.45.61s-3.42,1.86-3.76,3.2c-6,22.88-8.58,46.26-10,69.82-.9,14.86-2,29.71-2.92,44.56-.4,6.31-1.18,12.83,6.73,15.62a5.22,5.22,0,0,1,1.41,1.14c3.77-5.3,7.13-10.14,7.26-17.53.11-6.6.87-13.15.85-19.95-.05-22.88,1.92-45.78,3.32-68.65.58-9.5,1.67-19,2.56-28.82M472.06,365.62a36.53,36.53,0,0,1,5.4-3.53c2.91-1.27,3.14-3.39,2.94-6.09-1-13.49-2.13-27-2.76-40.48-1.16-25-2.93-50-8.91-74.41-2.12-8.66-1.87-8.72-10.05-10.31-.11,0-.25.14-.55.33.83,10.35,1.77,20.79,2.5,31.25,1.4,20.15,2.84,40.31,3.86,60.48.22,4.18-1.42,8.43-2,12.68a17,17,0,0,0,.21,5.12c.78,4.53,1.71,9,2.63,13.55.3,1.52.39,3.25,1.19,4.47,1.63,2.46,3.68,4.64,5.54,6.94M467.76,799a9.91,9.91,0,0,0-1.38.88c-.53.64-1,1.3-1.55,1.94-6.87,8.12-14.42,14.7-26.06,14.77-3.13,0-6.32,2.41-9.34,4-1.94,1-3.51,3.41-5.45,3.68-15.67,2.19-31.34,4.89-47.1,5.76a395.4,395.4,0,0,1-78.07-3.89c-3.68-.53-8.43-1.43-10.45-3.95-3.53-4.4-7.77-5.56-12.57-5.8a26.28,26.28,0,0,1-17.45-7.59c-2.63-2.52-5-5.25-7.78-8.13-.33,1-.54,1.32-.51,1.61a6.61,6.61,0,0,0,.44,1.94c5.49,12.17,14.68,20.57,27.71,23,32.08,5.87,64.43,9.9,97.14,7.22,19.46-1.59,38.91-3.57,58.24-6.24,16.81-2.32,28.42-11.78,34.18-29.15m-221-574.24c-.55,1-1,1.74-1.3,2.48-4.22,10.43-6.13,22-14.68,30.36-.76.74-.7,2.49-.73,3.78-.39,13.9-.89,27.8-1,41.7-.17,18.88,0,37.77,0,56.6,5.35.49,5.62.41,5.83-3.29,1.06-18.88,1.63-37.79,3.19-56.62,1.35-16.29,3.86-32.48,5.71-48.72,1-8.63,5.41-16.87,3-26.29M486.52,360.2c.4-8,1.15-15.54,1.08-23-.21-23.44-.8-46.87-1.07-70.31-.06-4.89.34-9.59-4.41-12.89-1.22-.85-1.78-2.79-2.42-4.32-3.27-7.84-6.47-15.72-9.69-23.58,2,22.19,5.67,44.11,7.87,66.18,2.23,22.4,3,44.95,4.46,67.72l4.18.23M249,670.72c-.73-8.74-1.51-17.21-2.13-25.69-1.65-22.48-3.43-44.95-4.75-67.44-1-16.85-1.41-33.74-1.87-50.61-.1-3.63-1.53-5.11-5-5.24a19.15,19.15,0,0,0-.18,2.12c.58,21.06,1.1,42.13,1.77,63.2.7,22.39,1.65,44.78,2.28,67.18.21,7.31,1.8,13.48,9.89,16.48M467.46,670l1.81,1c2.44-3.3,5.69-6.29,7.07-10s.89-7.91,1.05-11.91c1.06-27.41,2.26-54.82,3-82.24.42-15,.08-30,.08-45.14-3.17.1-4.68,2.15-4.82,5.72-.24,6.51-.72,13-1,19.53-.77,20.72-1.3,41.46-2.27,62.18-.51,10.83-1.75,21.62-2.65,32.44q-1.19,14.19-2.34,28.39m.72-446.5c-1.1-2.88-2-5.87-3.36-8.68-4.1-8.63-11.17-14.69-19.05-19.37-7.66-4.56-15.62-9.25-25-9.35-1.84,0-3.71,1.42-5.57,2.18.87,1.67,1.36,3.73,2.65,4.94,5.12,4.8,10.48,9.35,15.75,14,7.53,6.61,14.84,13.51,22.74,19.65,2.4,1.87,6.4,1.91,9.72,2.15.54,0,1.31-3.28,2.14-5.5M249.6,229.13a12.18,12.18,0,0,0,12.52-3.83,68.45,68.45,0,0,1,5.17-4.75c10.82-9.46,21.68-18.88,32.46-28.39,2.79-2.47,2.33-4.83-1.37-5.63a17.94,17.94,0,0,0-8.3.3c-13.16,3.64-24.72,10.25-33.71,20.59-5.18,6-9.35,12.75-6.77,21.71M230.1,649.25c0,13.81-.25,26.73.08,39.63a269.41,269.41,0,0,0,2,30.48c1.75,12.54,4.65,24.91,7,37.36q2.94,15.51,5.79,31l1.48.16c.72-1.61,2.2-3.31,2-4.84-1.74-16.59-3.35-33.21-5.87-49.7-.85-5.6,2.09-12.54-4.36-16.85-.47-.31-.32-1.58-.42-2.41-1.1-8.41-.16-16.64.67-25.08,1.08-10.95,1.93-22.74-5.56-32.71-1.32-1.76-1.74-4.2-2.87-7.06M471.67,788.08c2.66-16.37,5.18-32.51,7.93-48.6,1.77-10.34,5-20.56,5.61-31,1-17.71.48-35.52.58-53.29a13.22,13.22,0,0,0-.32-2c-3,4.7-6.15,9.33-6.84,14.31a89.48,89.48,0,0,0,.31,27.51c1.32,7.86,3.08,17.32-4.06,24.49-.37.38-.28,1.27-.33,1.94-.69,8.66-1.17,17.34-2.09,26-1.17,11.11-2.42,22.23-4.23,33.25-.54,3.32-.53,5.45,3.44,7.41m4.76-267.85c4.38.37,5.06-1.8,5.06-5.2,0-40.21.07-80.41,0-120.61,0-2.15-1.69-4.29-2.59-6.44l-2.29.42c-.33,4.59-1,9.18-.95,13.77q.3,55.53.81,111.06c0,2.33,0,4.65,0,7m-236.4.32c0-1.15,0-2,0-2.8.28-40,.61-80,.76-120,0-3.11-1.25-6.22-1.92-9.33h-2.16c-.59,2-1.68,4.07-1.69,6.11-.08,40.2,0,80.4-.08,120.61,0,3.46.89,5.42,5.09,5.46M465.34,672c1.35-14.45,2.69-28.69,4-42.92.11-1.15,0-2.31,0-3.45-9.36,1-13.27-8-20.58-10.55-1.84,12.85,9.29,51.61,16.56,56.92M246.67,626q2.15,23,4.28,45.83l2.11.28c6.39-18.72,16.73-36.36,14.82-57.6-7.17,3.66-11.63,11.18-21.21,11.49M441,810.8c-55.5,11.56-110,11.5-164.72,1.19,3.59,2.37,7.34,4.65,11.33,5.21,16.36,2.29,32.74,5,49.21,5.81a402.54,402.54,0,0,0,88.51-5c5.31-.92,10.91-1.68,15.67-7.22M259.29,354.39l1,1.14c5.52-2.6,10.87-5.62,16.57-7.74,20.55-7.66,42.13-10.33,63.81-11.36,15.18-.72,30.47-.07,45.65.88,16.83,1.05,33.54,3.58,49.52,9.27,7,2.51,13.73,5.9,20.57,8.89-2.23-3-4.8-6.22-8.07-7.26-12.85-4.07-25.72-8.56-38.94-10.83a303.32,303.32,0,0,0-73.45-3.44c-22.8,1.65-45,5.76-66.45,13.49-3.75,1.35-6.81,4.59-10.19,7m73.11,72.23h51.35c-1.71-7.51-4.56-10-11.46-10H344.2c-7.1,0-9.7,2.14-11.8,10m95.72,392.82c-24.14,3-47,5.58-70.33,5.55s-46-2.57-69.33-5.57c9.25,11.73,126.83,11.76,139.66,0m55.37-301.38c1.49-4.7,3.23-9.14,4.25-13.74a37.77,37.77,0,0,0,.94-11.25c-.55-6.54-2.61-13-2.65-19.53-.15-25.47.27-51,.4-76.42a24.23,24.23,0,0,0-.95-4.75l-2,.28ZM233.08,392.88l-2.24-.53a33.17,33.17,0,0,0-.83,5.27c0,27.32.06,54.63.06,81.95,0,2,.15,4.22-.67,5.9a23.37,23.37,0,0,0-1,18.46c1.59,4.54,3.64,8.8,3.11,13.76a11.57,11.57,0,0,0,1.57.56Zm271.69,2.76,2-2.34c-1.44-2.88-2.15-6.88-4.48-8.42a189,189,0,0,0-21.82-12c-2.91-1.42-4.83.73-4.82,3.82,0,5.6,2.61,10.76,7.29,12.8,6.86,3,14.5,4.16,21.81,6.11m-290.6-.47c5.49-1.41,10.66-2.71,15.81-4.08,6.54-1.73,9.15-7.06,10.73-12.76,1.21-4.38-1.81-6.67-6.12-5a72.66,72.66,0,0,0-10.41,4.89,70.08,70.08,0,0,0-11.8,8.22c-1.43,1.32-1.44,4.44-1.54,6.77,0,.58,2.11,1.26,3.33,1.94M231.46,625c4.53-2.78,5-7,4.52-11.74s-.77-9.32-.87-14c-.48-22.26-.83-44.52-1.32-66.78-.09-4-.66-8-1-11.95l-1.32.09Zm77.77-450.35.64,1c13.76-1.24,27.53-2.45,41.29-3.74,2.78-.27,5.58-1.43,8.29-1.2,10.12.85,20.21,2.07,30.3,3.23,5.59.64,11.17,1.45,16.76,2.18-.52-1.91-1.5-3.63-2.68-3.78-14.73-1.84-29.49-4.8-44.24-4.77-15.6,0-31.19,2.91-46.77,4.71-1.27.15-2.4,1.56-3.59,2.38m37.27,5.1-21.5,1.5a82.22,82.22,0,0,0,17.47-.18c4-.42,6.32.94,6.66,5.43h18.13c.5-4,2.12-5.74,5.82-5.42,6.17.53,12.36.8,18.54,1.18l.06-1L370,179.81l-2.09-4.47,4.95-.6c-4.71-.79-9.76-2.29-14.82-2.3-4.86,0-9.73,1.5-14.61,2.33l4.79.5c-.69,1.81-1.26,3.29-1.73,4.51m138.09,445.4V520.7l-1.36,0a18.4,18.4,0,0,0-.46,2.72c-.75,29.77-1.39,59.55-2.28,89.32-.15,5.17.09,9.81,4.1,12.48M258.23,201.62c13.55-9.18,26.42-19.77,45.25-16.47,1.46-3.67,3.24-8.12,5.43-13.61-12,5-22.72,9.55-33.47,14-7.77,3.21-12,10.12-17.21,16.08M407.4,172c2.24,5.32,4.08,9.7,5.55,13.21,18.39-3.34,31,7.11,44.59,16.36-5-10.61-20.78-19.86-50.14-29.57m76.07,81.57,1.71-.61c-1.25-4.33-2-8.86-3.83-12.94-4-9-8.28-17.84-12.73-26.6-3.6-7.08-6.81-14.57-11.6-20.79-8.33-10.83-21.08-14.71-33.62-18.46-1.8-.54-3.69-.76-5.55-1.13a87.13,87.13,0,0,0,15.42,7.11c12.39,4.51,22.49,11.92,28.34,23.88,5.4,11.06,10,22.53,14.9,33.81,2.3,5.25,4.64,10.49,7,15.73M298.9,173.85c-.16-.48-.33-.95-.5-1.43-6.38,2.16-12.82,4.2-19.15,6.5-11.06,4-20,10.8-25.35,21.48-7,14.16-13.71,28.5-20.3,42.88-1.25,2.72-1.35,5.95-2,8.95l1.26.47a51,51,0,0,0,2.43-4.55c5.22-12.43,10.15-25,15.63-37.32,6.57-14.79,16.95-25.74,32.77-31,5.17-1.7,10.13-4,15.19-6m-31,368.52c.35-5,.16-8.17-5.39-9.74-6.89-2-13.32-5.53-20.28-8.55,0,3.36-.27,6.06.11,8.66.19,1.32,1.33,3.25,2.44,3.57,7.48,2.18,15.06,4,23.12,6.06m205.65-6.49c.32-3.87.62-7.54,1-11.93-7.27,3.12-13.45,6.58-20.09,8.36-5.85,1.57-6.86,4.53-5.52,10l24.62-6.39m-24-3.15c8-3.48,15.86-6.88,23.68-10.41a3.05,3.05,0,0,0,1.29-2.28c.15-3,.06-6.11.06-9.86-7.17,4.53-13.27,8.89-19.85,12.35-4,2.12-6.62,4.23-5.18,10.2M242,510.62c0,2.94-.13,5.4.06,7.85.1,1.34.39,3.42,1.23,3.82,7.65,3.61,15.44,6.91,23.19,10.31l1.17-1c-.55-2.26-.35-5.63-1.78-6.58-7.55-5.05-15.51-9.48-23.87-14.45m-.34-144.53c-.45,2.51-1.1,3.78-.76,4.67a17.08,17.08,0,0,1-.67,14.46c-.56,1.13.32,4,1.44,4.74,3,2.05,6.53,3.38,10.42,5.28-2.33-10.19-2.92-20.14-10.43-29.15M440.71,812.36l.93,2.22c1.87-.43,3.79-.71,5.62-1.3,9.35-3,14.35-11.08,20.58-17.77,3.06-3.29,2.72-5.72-.77-8.17a9.27,9.27,0,0,1-.6.82c-5.25,6-10.27,12.2-15.89,17.82-2.7,2.71-6.54,4.29-9.87,6.38M464.83,395.1c2.62-1.38,5-2.85,7.61-4,4.18-1.79,4.35-4.35,3-8.4-1-3-.38-6.58-.44-9.91,0-1.92,0-3.85,0-6.8-5.53,6.49-10,19.83-10.13,29.07m-216.47,393c-1.56,1.46-3.42,3.45-.87,6.23,4.63,5,9.07,10.3,14.14,14.86a19.49,19.49,0,0,0,14.11,5.1c-1.86-2.34-2.87-4.17-4.38-5.34s-4.13-1.48-5.55-2.87c-5.88-5.76-11.49-11.78-17.45-18m74.21-361.25c-10-7-30-5.38-36.07,3.8,5.84-.73,11.55-1.53,17.28-2.13,6-.63,11.94-1.07,18.79-1.67m-41.67,5.31,1.21.59c1.74-2.08,3.15-4.6,5.27-6.16,10.36-7.59,25.94-8,36.91-1.33a44.68,44.68,0,0,0,4.81,2.1c-.61-1.58-.66-2.17-1-2.45-10.86-9.71-34.43-9.16-44.45,1.2-1.46,1.5-1.87,4-2.77,6.05M477.82,693.7l-2.71-.4c-1.71,7.19-3.28,14.42-3.12,22,0,.62,1.78,1.87,2.07,1.69,1-.6,2.39-1.63,2.47-2.6.59-6.87.9-13.76,1.29-20.64m-237.08-.4-1.42.35c0,6.56-.16,13.12.13,19.66.06,1.3,1.85,2.52,2.85,3.78.72-1.63,2.17-3.32,2-4.86-.49-5.44-1.49-10.83-2.4-16.22a11.49,11.49,0,0,0-1.18-2.71M485.6,636.14c-9.32,5.91-6.59,14.88-7,24.18,6.27-7.73,5.57-16.16,7-24.18M237.41,659.29c.06-8.24,1.82-17-6.61-23.23,1,8.28.87,16.51,6.61,23.23M372.07,176.4c0,.47,0,.93.05,1.4l36.16,3.94.13-1.21-36.34-4.13M479.89,639.14c5.21-6.3,5.15-11.59,0-15.43ZM308,180.47c0,.42.09.84.14,1.25l36.46-4-.15-1.33L308,180.47M236.24,623.62c-5.36,5.31-4.78,11.68.91,15-.3-4.93-.58-9.65-.91-15m250.43-250.7c0-3.27.16-6.09-.09-8.86a3.32,3.32,0,0,0-2.07-2.12,2.86,2.86,0,0,0-2.46,1c-1.7,2.39,1,8.72,4.62,10M234.1,361.81c-5.66,1-6,2.47-3.59,11.2,6-2.29,2.73-7,3.59-11.2M371.22,182.55l0,1.1,34.49,3.42.09-1.07-34.61-3.45M479,371.56l1.14-.55v-8.47c-1.85,1.23-3.15,2.09-4.57,3l3.43,6m-238.46-6.35-4-2.31v8.22l1.34.35c.8-1.86,1.61-3.72,2.7-6.26M344.65,184c-.07-.36-.15-.72-.23-1.09l-20.58,1.44.07,1L344.65,184"
                />
                <path
                    class="cls-2"
                    d="M26.54,238.49c.88-13,1.71-25.34,2.56-37.67a14.47,14.47,0,0,0,.34-2.48c-1.11-9.38,3-17,7.36-24.89,3.33-6.07,7.83-8.23,14-8.32,11-.16,22-.09,33,0,3.1,0,5.8.75,7.34,4.11.58,1.26,2.53,2,4,2.75,4.15,2.14,8.72,3.66,12.46,6.35a67.47,67.47,0,0,1,26.32,39.39c7.1,28.82,12.52,58.06,18.4,87.16,1.78,8.8,2.62,17.78,4.26,26.6.47,2.5,2.21,4.78,3.44,7.12,17.74,33.68,35.92,67.15,53,101.19,4,7.91,4.94,17.7,5.69,26.75,2.72,33.19,6.38,66.34,5.3,99.74-1.1,34-3,68-15.35,100.09-9.13,23.65-19.51,46.87-30.46,69.74-6.61,13.79-9.44,28-10.52,42.91-.88,12.18-2.2,24.32-3.08,36.5-.3,4-3.17,5.07-6,5.61-7.05,1.33-14.17,2.26-21.28,3.21-8,1.07-16.07,1.94-24.09,3-1.45.2-3.27.59-4.14,1.57-6.91,7.88-15.89,5-24.34,5-1.33,0-2.93-.64-3.93-.11-7.25,3.86-13.13,1.39-18.7-3.51-5.9-5.18-12.38-10-14.55-18-1-3.65-.35-7.73-1.33-11.38-1.82-6.8-4.27-13.42-6.47-20.12-4-12.26-5.56-24.69-2.18-36.64-6.59-3.77-13.14-6.56-18.58-10.78C-7.31,713.07-6,673.09,21.29,654.08c2.85-2,3.47-4.1,3.66-7.38.32-5.4.53-11.25,2.73-16,5.39-11.61,5.26-23.64,4.82-35.85-.34-9.38-.58-18.75-1.07-28.12-.11-2-1.16-4-1.73-6a14.44,14.44,0,0,1-.94-3.78c-.05-22.93,0-45.86,0-68.79,0-17.11-.08-34.22-.24-51.33-.23-25.64-.48-51.29-.94-76.94-.08-4.43,1.37-5.61,5.72-5.81,15-.7,30.16-.31,43.7-8.68,15.15-9.37,24.26-22.67,27.15-40.17,3.09-18.68-2.89-34.79-15.47-48.26a52.51,52.51,0,0,0-33.54-16.41c-9.28-1-18.62-1.39-28.57-2.1m132.8,579.58-8.69-7.49v11l8.56-3.73c3.1,1,3.14-1.13,3.33-3.23,1.34-14.8,2.55-29.63,4.15-44.4.7-6.43,1.23-13.16,3.57-19.07,5.74-14.57,12.68-28.67,18.78-43.11,7.13-16.89,14.72-33.66,20.61-51,9.67-28.43,11.39-58.16,12.32-88,1-32.21-1.89-64.21-4.41-96.23-.76-9.77-3-19.43-4.82-29.09-.44-2.33-1.86-4.46-3.3-7.77-.71,4.42-1.18,7.31-1.89,11.68-1.67-2.73-2.66-4.19-3.5-5.73C193,421.56,181.88,401.18,171,380.69c-5.41-10.14-10.84-20.31-15.46-30.82-2-4.57-3.42-10.33-2.46-15,.81-4,1.33-7.56.54-11.46-.76-3.7-1.48-7.42-2.18-11.13-4.37-23.44-8.56-46.92-13.15-70.32-2.86-14.58-6.22-29.12-14.07-42-2.92-4.82-6.82-9-10.28-13.53L112,187.64a19.5,19.5,0,0,0,1.62,3.83c5.62,8,10,16.51,11.43,26.36,1.12,7.73.1,8.92-7.69,8.39l-20.65-12c0,5.39,0,11.69,0,18,0,5.86.88,11.81.06,17.54-.55,3.87,0,6.49,2.27,9.5C126.12,295,106.33,348.46,62.51,358c-4,.87-8.11,1-12.17,1.44,36-6,58.81-26,58.83-62.87,0-37.1-23.06-57-59.16-62.5a46.18,46.18,0,0,1,23.34,4.64c7.3,3.75,14,8.62,21.78,13.48,0-4.88.1-9.77,0-14.66-.24-9.66-.58-19.33-.93-29-.31-8.36-.72-16.72-1.05-25.08-.16-4,1.6-5.22,5.29-3.47.8.38,1.67.63,2.51.94l.88-1.38-10.69-8.14-1.32,1v14.25C78,184.05,78.13,175.3,79.18,166.37h-6c3.11,11.24,1.93,31.46-1.88,33.87,3.22-9.08,2.1-31.06-2.38-34.44v36.12c-11.09,1.25-21.7-2.77-24-8.77-3.09-8.06-1.14-23,3.37-25.84-4.68-.3-6.77,1.27-6.53,6.57.47,10.21.11,20.46.11,30.69,0,10.86,0,21.72,0,33.11,17.41.46,33.35,3.95,46.1,16.11s19,27.27,18.67,44.82a55.56,55.56,0,0,1-13.12,35C80.45,349.43,63,355.69,43,355.4v12.17c29-3.29,57.74-6.25,86.8-2.53-.9-12-1.69-23.51-2.64-35-1-11.83-1.78-23.67-3.19-35.44-2.6-21.71-5.62-43.36-8.32-65.06-.13-1.07,1.22-2.32,1.88-3.48a31,31,0,0,0-.1,4.41c1.64,13.41,3.59,26.8,5,40.24q4.68,45.12,8.81,90.3c.34,3.66,1.59,5.15,5,5.2,11.3.15,19.46,5.87,26.3,14.33,14.29,17.7,24.73,37.65,34.27,58.12,3.38,7.24,7,14.6,8.81,22.31a369.59,369.59,0,0,1,8.95,79c.22,19.91-.64,39.86-1.9,59.73-.81,12.62-3.14,25.15-4.95,37.7-1.21,8.36-5.66,15.21-10.7,21.76-5.41,7-10.94,13.95-15.92,21.27-7.2,10.58-16.45,10.92-27.87,7.28-3.08-1-6-2.34-9.09-3.54V795.11a5.4,5.4,0,0,1-.81-3.41c-.34-34.36-.73-68.72-.93-103.08,0-3.82-1.32-5.85-4.58-7.92-10.12-6.42-19.94-13.34-29.8-20.16-3.45-2.39-6.7-5.07-10-7.61,2.51,4.78,6.15,8.72,8,13.38,8.79,22.46,10.4,44.74-3.31,66.21-.76,1.19-.66,3.3-.24,4.79,1.42,5.06,4.09,10,4.6,15.07,1.84,18.29,3.07,36.65,4.34,55,.25,3.59,1.32,4.25,4.67,3.16,7.14-2.31,14.39-4.28,21.61-6.34,4.55-1.29,9.77-4.83,11.84,3.21.06.23.47.37.67.59q4.65,5,9.31,10.08m-21.41-284.7c-1.16-22.84-2.34-45.19-3.42-67.55-1.43-29.6-2.87-59.19-4.13-88.79-.54-12.76,1.69-10.34-11.46-11.26a309.51,309.51,0,0,0-65.14,2.49c-3.26.46-4.27,1.54-4.07,4.71.43,7,.62,14,.87,21.07,1.07,30.13,2.18,60.26,3.16,90.39.48,14.74.71,29.48,1.08,44.22a14.34,14.34,0,0,0,.45,2.35c27.59-1,55-2,82.66,2.37m2.87,147V655.94l-1.81-.22c-.53,2.9-.89,5.84-1.69,8.66-.39,1.41-1.38,3.31-2.51,3.66a4.86,4.86,0,0,1-4.23-1.48c-2.12-2.78-3.68-6-5.54-9a12.07,12.07,0,0,1,.93-14.43c.92-1.14,1.5-2.57,2.49-3.63s2.29-2.4,3.36-2.33a6.29,6.29,0,0,1,3.84,2.43,59.23,59.23,0,0,1,3.89,6.38c0-12.24.14-24.39,0-36.54-.33-23.12-1-46.24-1.19-69.36,0-4.21-1.45-5.48-5.41-5.71-8.66-.5-17.3-1.88-26-2-17.18-.34-34.36-.1-52-.1,0,2.51-.05,4.14,0,5.76q1.47,38.64,3,77.28a91.06,91.06,0,0,0,.73,11,5.64,5.64,0,0,0,3,3.8c16.75,6.06,31.29,15.77,44.74,27.15a180.59,180.59,0,0,0,34.46,23.13m6.63-271.87c.34,4,.73,7.21.88,10.48,1.12,24.91,2.15,49.83,3.31,74.74.37,8,1.17,16,1.45,24,.12,3.27,1.7,4.15,4.5,4.68,9.5,1.79,19,3.8,28.44,5.69,7.76,1.54,15.54,3,23.24,4.5,1.79-49-12.48-92.65-38.54-131.27-3.14,2.32-6.11,5.75-9.8,6.9-3.93,1.22-8.54.27-13.48.27m11.81,230.43c6.11-.38,11.53.35,16.14-1.24,8.32-2.87,16-7.43,24.24-10.67,4.26-1.67,5.72-4.4,6-8.47,1.32-18.15,2.7-36.3,4-54.45.2-2.75,0-5.52,0-8.47l-54.79-1.66,4.37,85M58.6,636.57c-2.13-3.43-4-6.16-5.58-9.05s-3.92-5.79-4.08-8.79c-1-19.05-1.57-38.12-2.17-57.2-.68-21.75-1.24-43.52-1.86-65.28q-1.08-38.67-2.16-77.35c-.44-16.41-.74-32.82-1.23-49.23-.14-4.64-.73-9.27-1.15-14.27l-10.65,1.08c-.06,1.29-.15,2.28-.15,3.26q.39,40.22.77,80.43c.16,18.95.12,37.9.39,56.84.34,25.23-.45,50.46,2.5,75.66,1.6,13.76,1.09,27.77,1.39,41.67.16,7.78,0,15.56,0,23.84l24-1.61m42,98.83C89.34,747,76.69,752.51,62.7,755.74c.12,2.13.11,4.15.38,6.13,3,21.81,6,43.61,8.89,65.43.52,3.91,2.5,5.57,6.29,5.41,3.16-.14,6.33-.37,9.5-.39,7.39,0,15,1.57,20.84-5.37,1.24-1.49,4.32-1.44,6.56-2.09,8.11-2.35,10-5.67,8.29-14.39-2.75.65-5.52,1.19-8.21,2-3.63,1.06-5,0-5.34-3.93-1.42-18.65-2.94-37.3-4.89-55.9-.57-5.43-2.67-10.71-4.38-17.22m-51.15,7.25c27.34-.8,48.3-20.77,48.08-48.27-.24-30-24.6-47.52-47.65-47.59A48.12,48.12,0,0,0,1.69,694.45c-.43,25.94,22,48.23,47.79,48.2m-11.84,12.2c15.18.79,29.59-.52,43.21-7.16,17.28-8.43,27.3-22,29.2-41.19a84.93,84.93,0,0,0,.25-12.56c-1.08-21.48-8.24-39.43-29.19-49.11-9.81-4.53-20-7.26-30.94-6-5.7.67-11.45.87-17.56,1.31V623.52c-5.6,10.56-6.71,16.17-5.52,26.59,15-6.69,30.12-7.33,44.93.19,15,7.63,24.09,20.12,26.72,36.62a47.6,47.6,0,0,1-9.25,37.44c-12.7,16.71-30.07,21.73-50.28,19.16-.57,4.06-1,7.48-1.57,11.33m102.13-219.4c-.1,1.82-.29,3.28-.24,4.74.53,16.72,1.21,33.43,1.65,50.15.5,19.24.76,38.49,1.21,57.73q.36,15.3,1.07,30.59c.06,1.28.73,3.2,1.68,3.67,3.81,1.87,7.84,3.3,12.52,5.18-2.85-50.81-5.64-100.65-8.45-150.65l-9.44-1.41M36.44,757.35c2,9.36,3.29,18.28,6,26.73s6.58,16.5,6.38,25.71a9.73,9.73,0,0,0,2.22,6.43c5.42,5.61,11.24,10.84,17,16.09.81.73,2.21.81,3.39,1.21-3.65-26.22-7.22-51.85-10.77-77.43l-24.24,1.26M149.21,534.79c-.6-8.92-1.22-17.39-1.72-25.87q-1.55-26-3-52.07-2.22-41.07-4.3-82.16c-.33-6.5-.79-7-7.9-6.78a11.75,11.75,0,0,0-.2,1.89q1.5,32.32,3,64.64c1.4,30.07,2.88,60.14,4.14,90.22.46,10.79-.85,9.07,9.93,10.13m10.57,115.82c.57,9.14,1.13,17.79,1.63,26.44.3,5.26,4.83,7.9,9.47,5.26a16.91,16.91,0,0,0,4.92-4.09c7.39-9.47,15-18.77,21.72-28.73,3.08-4.58,4.13-10.53,6.1-15.85l-1.4-.87-42.44,17.84M53.44,531.25c-1.85-54.3-3.67-108-5.49-161.5-4.29-.68-5.28,1.1-5.11,4.49.68,13.2,1.35,26.4,1.74,39.61.85,28.28,1.51,56.58,2.28,84.87.28,10,.66,20.07,1,30.11a17.36,17.36,0,0,0,.44,2.42ZM206,441.31l1.44-.25c-.26-3.55.57-7.65-.94-10.55-15.44-29.75-31.24-59.31-47-88.9-1.28-2.41-2.86-4.66-4.31-7l-1.93.79c2.49,7.65,4.05,15.78,7.66,22.86,8.2,16,17.51,31.5,26.16,47.31,6.47,11.82,12.62,23.81,18.91,35.72M154.82,552.79h54.75c.62-8.29.62-8.32-7.16-9.41-9.24-1.28-18.48-2.57-27.74-3.74-6.67-.85-13.37-1.5-20.19-2.26,0,4,0,7.12,0,10.28,0,1.33.17,2.65.33,5.13M40.38,173c-5.55,5.84-8.37,12.39-8.8,18.83-.81,11.82-1.87,23.62-2.7,35.43-.23,3.25,0,6.52,0,9.87H40.38ZM209.64,534.55,153.8,523.33v12l55.84,7Zm-160.95-.8c0,10.18-.22,19.86.05,29.53.5,18.38,1.29,36.76,1.93,55.13.14,4.15,1.92,7.12,5.94,9.15-.68-21.34-1.34-42.22-2-63.09q-.44-13-1-26.07c-.13-3.21-.55-6.27-4.93-4.65M95.52,204.18c8.26-.86,14.74,2.62,20.64,7,2.18,1.63,3.22,4.77,4.79,7.22-2.84-.05-5.86.47-8.49-.31-3.79-1.12-7.31-3.18-10.94-4.84,6,5.89,12,11.74,21.12,11.15,3.45-12.94-11.32-40.89-27.12-42.93ZM154,588.43l.76-.23q-1.19-25-2.35-50c-.4-8.52-.68-17-1.12-25.56q-2.38-46.37-4.82-92.72c-.81-16-1.48-32.09-2.32-48.13,0-1.15-.89-2.25-1.37-3.38a8.32,8.32,0,0,0-1.18,5.29c1.23,19.86,2.56,39.71,3.74,59.57q2.1,35.31,4,70.63c1.17,21.54,2.18,43.08,3.32,64.62.35,6.65.89,13.29,1.34,19.94m-1.21-204.86c-.42,1-.57,2.78-1.46,3.32-5.17,3.17-3.84,8-4.11,12.75-.3,5.4,1.59,7.42,6.72,7.78,4.17.3,11.62-1.92,13-4.94,2.12-4.68-.3-8.47-3.5-11.58-1.92-1.88-4.51-3.08-6.78-4.61-1.3-.88-2.56-1.81-3.86-2.72M49.52,171.19c-1,1.18-1.54,1.54-1.55,1.92-.11,3.51-.2,7-.15,10.54.16,10.68,5.85,15.48,16.67,14.14V169.32l-1.46,0a86.13,86.13,0,0,1-.1,10c-.24,2-1.15,5.2-2.43,5.57a15.89,15.89,0,0,1-8.91-.17c-1.18-.38-1.7-3.64-2-5.67-.33-2.27-.07-4.64-.07-7.85m76.2,647.38c7.48-4.46,14.57-8.37,22.64-1.2,0-2.27.11-3.88,0-5.47-.64-7.61-2.08-8.57-9.23-6.31-2.37.75-4.74,1.5-7.1,2.27-6.95,2.26-6.95,2.26-6.29,10.71M212.1,546c-1,17.65-1.93,35.3-3.13,52.94s-2.15,35.33-8.31,52.11c11.74-34.18,11.49-69.76,11.44-105M159.84,648.53c14.45-6,28.4-11.81,42.28-17.74,1-.45,1.65-1.95,2.47-3-5.09,1.08-9.41,3.08-13.74,5-9.61,4.32-18.84,10.24-30.21,7.4-.23-.06-.55.28-.8.42Zm-11.31,173c-6.49-8.68-16.46-7.81-24,2.13l24-2.13M119.83,216.9c-6.16-6.56-13.17-10-22-11.49,3.63,6.73,14.4,12.37,22,11.49m10.24,422.15c.42,7,.73,13.69,1.37,20.4.09.85,1.94,1.53,3.39,2.6,1.19-12.6-.58-22.14-4.76-23M81.29,169.13c-.94,11-.79,11.3,6.49,14.3,1-13.14.74-13.66-6.49-14.3m1.3,473.36.51-.68L59.41,631l-1.21,1.17c1,1.62,1.59,4.28,2.92,4.69,7.06,2.17,14.29,3.79,21.47,5.59m-26.5-456.8,5.53-4.62c-1.75-1.24-3.5-3.44-5.27-3.45s-3.65,2.09-5.48,3.28l5.22,4.79m90.46,202,1.29.51,2.58-4.32c.9-1.5,1.79-3,3-5-2-1.14-4.24-2.44-6.86-3.95Zm30.87,292.81c-4.68,3.72-9.68,5.63-15.83,3.25.12,1.78.2,3,.28,4.22,8.1.78,12.08-1,15.55-7.47M145.09,370l20,18.28c-5-7.39-9.55-15.25-20-18.28m36.6,42.49-1.39.68L196,444.36l1.31-.66ZM128.41,643.69c-5,6.06-4.4,11.74,1.09,15-.35-4.86-.69-9.45-1.09-15"
                />
                <path
                    class="cls-2"
                    d="M678.88,744.83c5.6,15.11.32,30.4-4.73,45a87.79,87.79,0,0,0-4.46,19.55c-1,9.47-8.32,14.92-14.83,20.6-5.52,4.83-11.29,7.11-19.23,4-4.57-1.78-10.56,0-15.9.31a12.1,12.1,0,0,1-9.08-3c-6-4.86-13.26-6-20.94-6.49-11.26-.8-22.44-2.83-33.63-4.45-2.83-.41-3.86-2.22-4.11-5.26-1.53-18.82-2.75-37.7-5.36-56.38-1.05-7.55-5.13-14.73-8.2-21.93-10.54-24.71-21.77-49.14-31.71-74.09-7.57-19-10.81-39.3-11.92-59.67-1.34-24.4-2.93-48.94-1.71-73.28,1.43-28.47,1.95-57.25,8.83-85.14,2-8.25,6.56-16,10.61-23.63,15.29-28.76,30.9-57.35,46.24-86.08,1.12-2.09,1.11-4.79,1.59-7.21,7-35.32,13.62-70.7,21.09-105.91,2.76-13,9.32-24.32,18.06-34.74,5.52-6.59,12.11-10.32,19.28-14,2.94-1.52,5.3-4.13,8.08-6a10.88,10.88,0,0,1,4.52-1.79,133,133,0,0,1,41,.94,8,8,0,0,1,4.52,3.31c6.18,9,10.76,18.32,10.53,30.05-.25,12.77,1.71,25.59,2.76,39.15-7,.33-13.43.63-19.88.95-14.36.72-27.62,4.35-38.73,14.11-14.28,12.54-21.16,28.37-19.81,47.14a55.68,55.68,0,0,0,44.09,50.84c9.07,1.93,18.58,1.95,27.92,2.42,3.81.19,5.32,1.19,5.27,5.23-.54,45.27-.91,90.53-1.37,135.8-.17,16.75-.24,33.51-.76,50.26-.44,14.5-1.24,29-2.29,43.48-1.08,14.91-1.79,29.57,5.07,43.66,1.92,3.93,2.11,9.1,1.78,13.61-.27,3.74.59,5.62,3.61,7.69,25.81,17.69,29.1,55.11,6.28,76.34-6.18,5.75-14.3,9.41-22.44,14.62m-79.7-518.65c.65,1,1.87,2,1.84,3a83.42,83.42,0,0,1-1,8.44c-2.57,20.05-5.32,40.07-7.64,60.14-1.6,14-2.67,28-3.86,41.94-.72,8.41-1.2,16.83-1.73,24.44,15.06,0,29.75-.37,44.41.11,14.08.46,28.14,1.81,42.34,2.78V355.63c-40.45.28-62.11-27.82-63.7-56.38a55.59,55.59,0,0,1,9.59-34.69c13.11-19.45,32.41-26.79,55.3-26.83v-6.31c0-19.12-.23-38.25.14-57.37.11-5.56-2.15-6.93-7.21-6.78,5.19,2.88,7.31,17.57,4,25.81-2.5,6.3-15.12,10.83-23.95,8.44,0-10.48,0-21-.06-31.58,0-1.28-.74-2.55-1.15-3.82-.87,1.18-2.49,2.35-2.49,3.53,0,10.21-1.81,20.51,1.14,30.58-3.91-2.13-5.25-24.39-1.88-34.21l-6,.34c.77,14.39-.94,17.61-11,20.19v-14.3l-1.3-.85-10,8.34.88,1.06c6.84-2.85,7.77-2.21,7.43,5.25-.17,3.51-.46,7-.62,10.52-.68,14.88-1.43,29.75-1.94,44.63-.12,3.72.57,7.47.87,11,7.47-4.72,14.14-9.77,21.51-13.38,9.91-4.84,19.9-6,23.37-4-25.33,6-30.1,8.08-38.61,15.69-11,9.85-18.92,22-20.06,36.57-3.3,42.1,18.32,64.81,58.74,71.83a9.28,9.28,0,0,1-3,.44c-18.91-1.48-34.3-9.79-45.63-24.85-17.34-23.06-17-52.76.14-76.06a10.12,10.12,0,0,0,2.25-5.23c.19-8.13,0-16.27,0-24.4,0-5.23,0-10.47,0-14.9l-21,12.43c-8,.33-8.89-.85-7.71-8.88,1.46-9.88,6-18.28,11.61-26.28.7-1,.73-2.44,1.08-3.68-1.66-.07-2.25.22-2.7.65-9.6,9-15.24,20.57-18,33-6.59,29.11-12.19,58.44-18.09,87.7a183.77,183.77,0,0,0-3.09,19.61c-.26,2.93,2.17,6.26,1.53,9-1.87,7.89-3.6,16.11-7.3,23.2-13.47,25.76-27.72,51.1-41.68,76.6-1.72,3.14-3.49,6.26-5.93,10.63-.76-4.42-1.26-7.35-1.77-10.29a16.45,16.45,0,0,0-3.5,6.83c-6.52,27.33-7.35,55.36-8.6,83.16-1.15,25.85.46,51.88,1.76,77.78,1,19.56,4.37,39,11.69,57.2,10.91,27.08,23.28,53.56,34.69,80.44a75,75,0,0,1,5.65,19.58c2.18,17.4,3.45,34.91,5.29,52.36.13,1.21,2,2.25,3,3.36l9,3.18V810.2a13.12,13.12,0,0,0,1-2.09c1.92-6.39,2.52-6.72,8.78-4.87,8.16,2.4,16.37,4.64,24.47,7.24,3.5,1.12,4.7.59,5-3.34,1.22-18.35,2.48-36.71,4.33-55,.52-5.11,3.25-10,4.67-15a6.49,6.49,0,0,0-.49-4.76c-4.8-7.38-8.18-15.15-9.07-24.06-1.8-18.15.23-35.37,11.2-50.65,1.15-1.59,2.41-3.08,3.62-4.63-14.12,10-28.34,19.3-42.37,28.89a7.8,7.8,0,0,0-2.76,5.57c-.5,28.33-.8,56.66-1.11,85-.07,6,0,12.07,0,18.11v4.79h-.82V684.1c-3.32,1.35-6.3,2.84-9.44,3.79-11.66,3.56-19.7,2.61-25.6-4.94-5.56-7.11-11.09-14.25-16.32-21.61-4.6-6.47-9.72-12.54-11.54-20.81-5.21-23.63-6.53-47.68-7.62-71.68a433.19,433.19,0,0,1,3.87-79.16c1.47-10.57,2.61-21.44,6.07-31.41a287.91,287.91,0,0,1,37.94-72.6c7.77-10.93,17.06-19.82,31.88-19.77,1.12,0,3.12-2,3.23-3.28,1.56-16.64,2.62-33.33,4.29-50,1.91-18.94,4.33-37.83,6.51-56.74,1.15-9.92,2.25-19.84,3.39-29.75M662.62,531c0-11.07-.15-21.91,0-32.74.32-19.09.7-38.18,1.35-57.26.77-22.57,1.81-45.13,2.82-67.69.15-3.19-.48-4.84-4.2-5.07-9-.58-17.93-2.22-26.92-2.36-15.36-.23-30.73.28-46.1.77-1.15,0-3.1,2.39-3.2,3.77-.86,11.67-1.47,23.37-2,35.06-.84,19.39-1.5,38.8-2.34,58.19-.37,8.52-1.08,17-1.46,25.53-.67,14.63-1.2,29.27-1.8,44.19,27.69-4.56,55-3.3,83.78-2.39M575.23,681.44c10.18-6.68,20.09-12,28.62-19.05,15.67-12.92,31.57-25.18,50.86-32.33a5.77,5.77,0,0,0,3-4.18c1.42-29.57,2.63-59.15,3.85-88.73a41.78,41.78,0,0,0-.23-4.31c-8.62-.44-16.81-1.42-25-1.15-17.86.6-35.69,1.9-53.54,2.77-3.78.19-4.53,1.94-4.58,5.42-.27,21.77-.76,43.53-1.22,65.3,0,2.33-.49,4.66-.51,7,0,11.27,0,22.54,0,34.62a77.52,77.52,0,0,1,4.2-6.84c.91-1.2,2.45-2.83,3.59-2.74,1.39.11,2.73,1.74,3.93,2.87a28.4,28.4,0,0,1,2.06,2.74c4.75,5.66,4.13,12.91-1.38,17.86-1.09,1-1.52,2.68-2.51,3.82a51.28,51.28,0,0,1-4.09,3.83c-1.05-1.43-2.53-2.72-3.08-4.33-1.16-3.32-1.82-6.81-2.69-10.23l-1.34.33ZM546.5,400.17c-27,40-40.91,83.75-39.41,132.48,18.07-3.6,35.87-7.09,53.63-10.8,1-.22,2.29-2.24,2.39-3.51.58-7.33.81-14.68,1.2-22,1.52-29,3.05-58.06,4.6-87.62-8.42-.32-18.08,2.31-22.41-8.52M507.91,555.56c0,10.08-.4,19.6.1,29.06.63,12,1.84,24,3.22,36,.22,1.94,2.23,4.35,4.07,5.31,6.5,3.38,13.52,5.83,19.91,9.4,7,3.92,14,4.61,22.08,2.13q2.12-41.43,4.27-83.48l-53.65,1.62m174.35,82.71c-1.41-47.3,4.11-93.87,3.66-140.68-.46-47-.1-94.08-.1-141.29l-9.8-.81c-.38,4.25-.86,7.89-1,11.54q-1.08,31.89-2,63.77-1.53,49.69-3,99.4c-.82,29.3-1.36,58.61-2.36,87.91-.1,3-1.65,6.88-3.88,8.76-3.34,2.83-4.58,5.78-4.27,9.8l22.78,1.6M592.85,810.4c-1,9.82.72,12.17,9.35,14.9,3.7,1.16,7,3.52,10.56,5.19a15.65,15.65,0,0,0,5.4,1.83c6.83.34,13.69.48,20.53.47,3.72,0,5.43-2,5.91-5.91,2.12-17.21,4.55-34.38,6.84-51.58.88-6.55,1.67-13.11,2.48-19.58-14.38-3.16-26.72-8.92-38-20.08-1.65,5.86-3.82,10.77-4.33,15.84-2,19.26-3.46,38.58-5,57.88-.23,3-1.66,3.83-4.17,3.35-3.09-.59-6.13-1.46-9.59-2.31m74-67.75c25.84.12,48.31-22,48-47.95a48.1,48.1,0,0,0-48-47.9c-24,0-48,18.44-47.9,47.84.07,28.13,21.42,47.12,47.83,48m16.87-117.88v15.07a47,47,0,0,1-6.87-.05c-13.06-2.07-25.91-1.88-38.26,3.49-13.36,5.82-23.36,14.68-28.43,29-4.31,12.2-5,24.49-3.4,37a54.88,54.88,0,0,0,5.15,16c7.23,15.22,20.85,22.92,36.11,27,9.77,2.64,20.33,2.38,31.15,3.49l-1.81-11.19c-8.44-.79-16.76-.27-24.18-2.62a53.55,53.55,0,0,1-20.5-11.78,51,51,0,0,1-12.6-20A55.09,55.09,0,0,1,618,686.59c3.23-25.45,32-52.87,71.35-36.92,1.43-9.44.46-14.57-5.64-24.9M567.24,536.88c-2.8,50-5.59,99.87-8.44,150.63,4.32-1.69,7.87-2.72,11-4.48a6.86,6.86,0,0,0,3.19-4.7q1.26-29.62,2-59.26c.58-24,.9-47.93,1.39-71.9.07-3.78.45-7.55.72-11.77l-9.89,1.48m77.64,297.55c3.58-2.36,6.89-3.73,9.06-6.13,4.86-5.36,11.09-10.6,13.19-17.06,2.63-8.11,2.21-17.1,6.41-25.23,2.6-5,3.2-11.19,4.35-16.91.77-3.82.93-7.76,1.38-11.79l-23.48-1.22-10.91,78.34m-67.94-300.9c2.57-55.55,5.13-110.65,7.68-165.77-8-.11-8.1-.06-8.3,6.89-.1,3.18-.1,6.37-.28,9.55q-2.41,42.06-4.89,84.12c-.87,14.69-2,29.36-2.73,44.06-.36,7.27-.06,14.58-.06,22.3l8.58-1.15m-20.37,117L514.3,632.81l-1.36.85c1.84,5.21,2.91,10.9,5.71,15.53,4.3,7.12,9.61,13.66,14.84,20.17,3.63,4.51,7.41,9.09,11.9,12.67s9.48.41,9.73-5.15c.4-8.68,1-17.35,1.45-26.33m112-119.26c1.61-53.64,3.21-107.12,4.83-160.95l-4.85-1.15c-1.82,54.31-3.62,108.1-5.43,162.1ZM563,335.42l-2-.53c-1.38,2.25-2.88,4.44-4.11,6.76-15.49,29.17-30.87,58.39-46.46,87.5-2.25,4.19-1.77,7.88-.36,11.75,15.63-28.14,31.44-56,46.53-84.24,3.41-6.39,4.32-14.12,6.38-21.24M506.75,553.76l55.13-1.56V537.8a5.49,5.49,0,0,0-1.56-.29c-17.05,2-34.1,4.08-51.13,6.28a3.63,3.63,0,0,0-2.33,2.47,53.33,53.33,0,0,0-.11,7.5M687.46,237.29a9,9,0,0,0,.45-1.94c-1-16-1.57-32-3.45-47.89-.59-5-4.8-9.58-7.35-14.35l-.75.58v63.6Zm-125,286.07-55.38,11.15v7.88c15.4-2,30.42-3.88,45.42-5.89,12.39-1.66,10.35,1.29,10.32-12.47,0-.15-.15-.29-.36-.67m98.43,103.81.77.66c1.38-3,3.72-6,4-9.12,1-13,1.57-26,2-39.05.38-12.38.31-24.78.5-37.18,0-2.91.3-5.82.46-8.73-5.36-.29-5.43-.12-5.66,5.85-.62,16.71-1.51,33.41-1.92,50.12-.32,12.48-.07,25-.07,37.45M621.11,181.35C604.28,184.28,590.05,213,594,224.5c9.06.4,15-5.37,21.15-10.67-4.53,1.44-8.78,3.58-13.27,5-1.89.6-4.26-.37-6.42-.62,1-1.92,1.58-4.4,3.14-5.65,6.42-5.15,13.49-9.07,22.47-8.52ZM574,368.75l-.55-.3a20,20,0,0,0-1.13,4.1c-1.38,25.72-2.78,51.45-4,77.18-1.2,25.24-2.2,50.49-3.32,75.74-.32,7.35-.73,14.7-1.13,22q-1.05,19.46-2.14,38.9c1.63-12.2,2.5-24.43,3.21-36.68q2.1-36.3,4-72.62c1.15-21.38,2.15-42.78,3.32-64.16.41-7.67,1.33-15.32,1.64-23,.28-7.06.06-14.14.06-21.21m-10.19,14.7c-1.46,1-2.78,2.39-4.38,2.86-5.57,1.63-8.26,6-10.18,10.79-1.29,3.25-.2,6.07,3.21,7.9a18.11,18.11,0,0,0,12.92,1.86c2.67-.55,3.87-1.31,3.75-4-.25-5.73,2-12-4.18-16.35-.82-.57-.87-2.26-1.14-3M652,198.12c14.81.13,22.27-12.78,15.17-26.88a70,70,0,0,1-.07,7.92c-.24,1.91-.67,5-1.74,5.36a16.9,16.9,0,0,1-8.91.52c-1.35-.34-2.57-3.4-2.84-5.36-.46-3.42-.13-6.94-.13-10.42l-1.48,0ZM590.91,818.77c.56-8.8.56-8.8-7-11.15-1.74-.55-3.51-1-5.25-1.54-8.92-2.84-10.23-1.93-10.53,7.46,0,1.07,0,2.13,0,3.91,8.28-7.3,15.31-3.32,22.77,1.32M504.33,545.84c-3.24,24.58,3.73,92.6,10.78,102.47-9.5-34.07-8.4-68.4-10.78-102.47m52.4,93.79c-8.55,2-16.09,1-23.48-3.25-6.54-3.74-13.75-6.32-21.1-9.61,1.16,3.89,32.67,18.47,44.58,21.16ZM568.19,821.5l24.2,2.14c-8.83-10.1-18.31-10.79-24.2-2.14m28.15-604.36c8.91.31,19.72-5.67,22-11.64-8.44,1.35-15.32,5-22,11.64M581.58,661.86c1.43-.72,3.33-1.17,3.38-1.79.64-7,1-14,1.46-21.37-4.14,1.57-5.71,10.42-4.84,23.16m47.17-478.15c7.41-4,8.62-7.22,5.81-14.66-6.63,1.19-6.63,1.19-5.81,14.66m28.56,447.14-23.81,11c6.77-.93,13-3.35,19.43-4.48,3.92-.69,5.49-1.69,4.38-6.52M531.25,670.47c7.29,12.82,14.13,20.06,23.64,17.14-.07-1.18-.13-2.41-.21-3.85-13.17,4.51-16.41-7.52-23.43-13.29M660.37,185.69l5.32-4.73c-1.8-1.2-3.6-3.35-5.4-3.35s-3.57,2.17-5.35,3.39l5.43,4.69M519.17,443.56l1.37.68,16.64-33.07-1.29-.64q-8.37,16.52-16.72,33m43.88-64.69,5.83,9.3,1-.61v-13l-6.79,4.31m-12.29,8.67,1,1.1c3-3.13,5.84-6.41,9-9.36s6.41-5.34,9.64-8c-9.61,2.11-14.14,9.74-19.69,16.25m36.35,271.55c5.59-4.56,5.94-10.26.8-15.21-.28,5.3-.53,10-.8,15.21"
                />
                <path
                    class="cls-2"
                    d="M.29,296c-1-25.75,21.55-49.61,49.25-49.47a49.68,49.68,0,1,1,.06,99.36C18.43,345.73-.84,319.77.29,296m49.28-47.51c-26.36,0-48.41,21.61-47.84,47.86.6,27.6,21.69,47.76,48.11,47.71,25.16-.05,47.73-19,47.73-48a47,47,0,0,0-48-47.62"
                />
                <path
                    class="cls-2"
                    d="M716.28,296.67c.79,23.49-18.44,48.93-49.5,49.28-27.41.3-49.53-22.37-49.45-50s22.1-49.39,49.89-49.48c27.4-.08,50.37,23.68,49.06,50.16m-49.64-48.2C643.73,248,619.18,265.86,619,296c-.17,28.67,22.31,48.21,48.09,48.09,26.21-.13,47-20.12,47.75-47.56.68-26.39-21.57-48.08-48.2-48"
                />
                <path
                    class="cls-3"
                    d="M439.16,651.79c-54.12,13.89-107.75,13.94-161.6.07.12-69.92,1.73-139.74-6.38-210.58,9.76-1.81,19.44-4.21,29.26-5.3,13.62-1.52,27.36-3.14,41-2.81,29.36.71,58.9-1.15,88,4.64,4.24.84,8.39,2.14,12.56,3.31a23.39,23.39,0,0,1,3,1.29c-3.73,34.91-6,69.59-5.9,104.43s0,69.67,0,104.95M358.43,463.63c-13.57,0-27.14,0-40.71,0-12.36,0-18.15,5.63-18.19,18s0,24.8,0,37.2c0,13.84,5.66,19.51,19.53,19.51q39.21,0,78.41,0a39.89,39.89,0,0,0,7.48-.69c7.08-1.37,11.67-7.62,11.57-14.85-.18-14.07-.3-28.14-.13-42.21.13-11-5.35-17-16.23-17q-20.85,0-41.72,0"
                />
                <g class="cls-4">
                    <rect
                        class="cls-5"
                        x="253.17"
                        y="188.46"
                        width="210.99"
                        height="147.93"
                    />
                </g>
                <path
                    class="cls-2"
                    d="M330.92,424.15C316,414.4,301.29,413,286.5,422c-3.07,1.86-4.83,5.88-7.21,8.89-1,1.25-2.05,2.46-3.07,3.69-1.27-1.26-3.34-2.32-3.69-3.8-3-12.33-5.58-24.74-8.34-37.12q-2.28-10.26-4.64-20.49c-2.28-10,.93-16.59,10.21-20.69a146.34,146.34,0,0,1,41.44-11.19c14.74-1.81,29.61-3.85,44.41-3.74,29.28.21,58.51,2.35,86.26,13,5.89,2.26,12.83,4.2,14.58,11.65a24.69,24.69,0,0,1,.28,10.3c-4,18.95-8.3,37.81-12.47,56.71-1.26,5.71-2,6.42-7.37,4.36-14.66-5.68-30.08-5.85-45.42-6.52-3.28-.14-5.43-.64-6.74-4.24-2.1-5.72-6.39-8.53-12.88-8.25a245.32,245.32,0,0,1-25.15,0c-7.63-.45-13,2-15.78,9.58"
                />
                <g class="cls-6">
                    <rect
                        class="cls-7"
                        x="267.28"
                        y="741.22"
                        width="181.67"
                        height="76.93"
                    />
                </g>
                <g class="cls-8">
                    <rect
                        class="cls-9"
                        x="239.85"
                        y="359.56"
                        width="36.63"
                        height="446.36"
                    />
                </g>
                <g class="cls-10">
                    <rect
                        class="cls-11"
                        x="439.7"
                        y="359.43"
                        width="37.87"
                        height="447.13"
                    />
                </g>
                <path
                    class="cls-12"
                    d="M328.32,430.37c1.05-.5,2.11-1.44,3.16-1.43,24,.14,47.92.54,71.88.57,12.05,0,23.5,2.6,34.84,6.3,3.88,1.27,6.35.36,7.37-4.52,4.2-20.09,9.08-40,13.25-60.12,1.41-6.84,1.83-14.23-3.29-20a22.14,22.14,0,0,0-9-5.8c-18.83-6.51-38-11.57-58.07-12.28-18-.63-36.11-1.47-54.11-.73-20.71.85-40.88,5.36-60.78,11.55-17.44,5.43-18.29,13.94-15.91,27.75,3.37,19.54,8.37,38.8,12.73,58.17,1.56,6.94,3,7.91,9.74,5.4,13.55-5.09,27.71-5.8,41.9-6.31,1.78-.06,3.6.95,6.39,1.74l-58.8,8.2c-1.63-6.75-3.77-14.59-5.38-22.53-3.74-18.48-7.51-37-10.64-55.55a44.19,44.19,0,0,1,.69-16.83c1.79-7.8,9.42-10.47,15.48-13.95,15.3-8.76,32.43-11.93,49.53-14.94,21.77-3.84,43.82-3.26,65.6-1.57,20.92,1.63,41.67,6,60.6,16,4.7,2.49,9.86,5,13.15,9a20.26,20.26,0,0,1,4.53,13.17c-.76,10.77-2.77,21.49-4.79,32.13-3.13,16.55-6.57,33-10.12,49.51-1.6,7.4-1.75,6.82-8.89,5.41-11.92-2.35-23.94-5-36-5.62-23.59-1.14-47.23-.91-70.86-1.26-1.28,0-2.56-.18-3.84-.27l-.35-1.13"
                />
                <path
                    class="cls-12"
                    d="M439.14,653.66c2.5,22.25,4.89,43.47,7.27,64.69.66,5.81,1.22,11.63,2,17.43.36,2.75-.62,4.1-3.16,5.3A149.46,149.46,0,0,1,395.3,754.8c-12.3,1.18-24.67,3-37,2.6-16.15-.47-32.28-2.58-48.37-4.34-14.93-1.63-28.65-7.25-42.6-13.76,3.24-28.27,6.47-56.44,9.8-85.58,54.06,13.63,107.72,13.77,162-.06M282.32,667.37c-.57,1.54-1.76,3.49-2,5.55q-3.1,29.93-5.82,59.91c-.12,1.36.83,3.58,1.94,4.16,4.85,2.54,9.74,5.52,15,6.68,12.69,2.81,25.53,5.07,38.4,6.82,9.93,1.34,20.1,2.77,30,2,18.61-1.41,37.18-3.94,55.62-6.9,7.59-1.21,14.84-4.67,22.2-7.22,3-1,4.3-2.87,3.92-6.46-1.67-16.13-2.9-32.31-4.49-48.46-.56-5.63-1.69-11.21-2.48-16.33-16,2.15-30.73,4.2-45.46,6.05-3.66.46-7.51,1.24-10.42-2.58-.77-1-3.06-1.2-4.66-1.21-10.57-.1-21.14-.14-31.7,0-1.89,0-3.77,1-5.63,1.63-2.14.73-4.34,2.43-6.35,2.21-15.74-1.72-31.45-3.8-48.07-5.89"
                />
                <path
                    class="cls-2"
                    d="M267.39,524.13c-8.86-5.58-16.49-10.3-24-15.23-.85-.56-1.34-2.26-1.34-3.44q-.1-56-.06-112.16c7.93,1.57,9.84,3.65,11.3,10.81,3.37,16.5,6.94,33,10.32,49.45a63.71,63.71,0,0,1,1.23,9.93c.89,19.7,1.66,39.41,2.54,60.64"
                />
                <path
                    class="cls-2"
                    d="M473.74,392.66c0,8.38-.05,15.92,0,23.46.23,29.17.44,58.34.82,87.51,0,3-.8,4.95-3.37,6.52-5.56,3.39-11,7-16.51,10.47-1.5.93-3.18,1.57-5.64,2.77.62-15.75,1.69-30.61,1.7-45.47,0-26.73,8.79-51.94,12.85-77.95.2-1.28,1.55-2.66,2.72-3.44a74.27,74.27,0,0,1,7.42-3.87"
                />
                <path
                    class="cls-2"
                    d="M242.29,537.76c9,2.25,16.79,4.12,24.49,6.17.61.17,1.27,1.56,1.27,2.38q.22,31.61.22,63.22a4.81,4.81,0,0,1-1.73,3.29c-4.47,3.49-9,6.9-13.7,10.1-3.39,2.32-6.38,1.27-6.56-2.28-1.38-27.2-2.63-54.42-4-82.88"
                />
                <path
                    class="cls-2"
                    d="M447.49,544.53l26.42-6.83c-1.25,29.07-2.46,57.3-3.65,85.17-1.45.6-2,1.07-2.3.93-4.44-2.32-9-4.43-13.21-7.17s-7.66-5.3-7.48-11.71c.59-20.19.22-40.4.22-60.39"
                />
                <g class="cls-13">
                    <rect
                        class="cls-14"
                        x="235.01"
                        y="230.95"
                        width="23.31"
                        height="134.96"
                    />
                </g>
                <g class="cls-15">
                    <rect
                        class="cls-16"
                        x="458.13"
                        y="230.79"
                        width="22.47"
                        height="134.83"
                    />
                </g>
                <g class="cls-17">
                    <rect
                        class="cls-18"
                        x="250.02"
                        y="799.04"
                        width="217.74"
                        height="38.07"
                    />
                </g>
                <g class="cls-19">
                    <rect
                        class="cls-20"
                        x="228.84"
                        y="224.8"
                        width="20.27"
                        height="135.41"
                    />
                </g>
                <g class="cls-21">
                    <rect
                        class="cls-22"
                        x="470.01"
                        y="226.07"
                        width="17.66"
                        height="134.13"
                    />
                </g>
                <g class="cls-23">
                    <rect
                        class="cls-24"
                        x="235.03"
                        y="521.74"
                        width="13.96"
                        height="148.98"
                    />
                </g>
                <g class="cls-25">
                    <rect
                        class="cls-26"
                        x="467.46"
                        y="521.74"
                        width="13.39"
                        height="149.28"
                    />
                </g>
                <g class="cls-27">
                    <g class="cls-28">
                        <path
                            class="cls-29"
                            d="M468.18,223.5c-.83,2.22-1.6,5.54-2.14,5.5-3.32-.24-7.32-.28-9.72-2.15-7.9-6.14-15.21-13-22.74-19.65-5.27-4.63-10.63-9.18-15.75-14-1.29-1.21-1.79-3.27-2.65-4.94,1.86-.76,3.73-2.2,5.57-2.18,9.4.1,17.36,4.79,25,9.35,7.88,4.68,15,10.74,19.05,19.37,1.33,2.81,2.26,5.8,3.36,8.68"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-30">
                        <path
                            class="cls-29"
                            d="M249.6,229.13c-2.58-9,1.59-15.75,6.77-21.71,9-10.34,20.55-16.95,33.71-20.59a17.94,17.94,0,0,1,8.3-.3c3.7.8,4.16,3.16,1.36,5.63-10.77,9.51-21.63,18.93-32.45,28.39a68.45,68.45,0,0,0-5.17,4.75,12.18,12.18,0,0,1-12.52,3.83"
                        />
                    </g>
                </g>
                <g class="cls-31">
                    <rect
                        class="cls-32"
                        x="229.85"
                        y="649.25"
                        width="18.81"
                        height="138.66"
                    />
                </g>
                <g class="cls-33">
                    <rect
                        class="cls-34"
                        x="467.69"
                        y="653.19"
                        width="18.54"
                        height="134.89"
                    />
                </g>
                <g class="cls-35">
                    <rect
                        class="cls-36"
                        x="475.6"
                        y="387.98"
                        width="5.97"
                        height="132.62"
                    />
                </g>
                <g class="cls-37">
                    <rect
                        class="cls-38"
                        x="234.93"
                        y="388.37"
                        width="5.87"
                        height="132.19"
                    />
                </g>
                <path
                    class="cls-2"
                    d="M465.34,672c-7.27-5.31-18.4-44.07-16.56-56.93,7.31,2.52,11.22,11.61,20.58,10.56,0,1.14.09,2.3,0,3.44-1.31,14.24-2.65,28.48-4,42.93"
                />
                <path
                    class="cls-2"
                    d="M246.67,626c9.57-.31,14-7.83,21.21-11.49,1.91,21.24-8.43,38.88-14.82,57.6l-2.11-.29Q248.82,649,246.67,626"
                />
                <g class="cls-39">
                    <rect
                        class="cls-40"
                        x="276.3"
                        y="810.8"
                        width="164.71"
                        height="13.68"
                    />
                </g>
                <path
                    class="cls-12"
                    d="M259.29,354.39c3.38-2.37,6.44-5.61,10.19-7,21.46-7.73,43.65-11.84,66.45-13.49a303.32,303.32,0,0,1,73.45,3.44c13.22,2.27,26.09,6.76,38.94,10.83,3.27,1,5.83,4.3,8.07,7.26-6.84-3-13.55-6.38-20.57-8.89-16-5.69-32.69-8.22-49.52-9.27-15.18-.95-30.48-1.6-45.65-.88-21.68,1-43.26,3.7-63.81,11.36-5.7,2.12-11.06,5.14-16.57,7.74l-1-1.14"
                />
                <path
                    class="cls-2"
                    d="M332.4,426.62c2.1-7.83,4.7-10,11.8-10h28.09c6.9,0,9.75,2.45,11.46,10Z"
                />
                <path
                    class="cls-12"
                    d="M428.12,819.44c-12.83,11.74-130.41,11.71-139.66,0,23.31,3,46.11,5.54,69.33,5.57s46.19-2.54,70.33-5.55"
                />
                <g class="cls-41">
                    <rect
                        class="cls-42"
                        x="483.49"
                        y="392.37"
                        width="5.52"
                        height="125.69"
                    />
                </g>
                <g class="cls-43">
                    <rect
                        class="cls-44"
                        x="226.26"
                        y="392.35"
                        width="6.81"
                        height="125.89"
                    />
                </g>
                <g class="cls-45">
                    <rect
                        class="cls-46"
                        x="475.66"
                        y="372.46"
                        width="31.13"
                        height="23.18"
                    />
                </g>
                <g class="cls-47">
                    <rect
                        class="cls-48"
                        x="210.82"
                        y="372.79"
                        width="30.83"
                        height="22.38"
                    />
                </g>
                <g class="cls-49">
                    <rect
                        class="cls-50"
                        x="231.46"
                        y="520.57"
                        width="4.99"
                        height="104.45"
                    />
                </g>
                <path
                    class="cls-12"
                    d="M309.23,174.68c1.19-.82,2.32-2.23,3.59-2.38,15.57-1.8,31.17-4.68,46.77-4.71,14.75,0,29.51,2.93,44.24,4.78,1.18.14,2.16,1.87,2.68,3.77-5.59-.73-11.17-1.54-16.76-2.18-10.09-1.16-20.18-2.38-30.3-3.23-2.71-.23-5.51.93-8.29,1.2-13.76,1.29-27.53,2.5-41.29,3.74l-.64-1"
                />
                <path
                    class="cls-51"
                    d="M346.5,179.78c.47-1.22,1-2.7,1.73-4.51l-4.78-.49c4.87-.84,9.74-2.36,14.6-2.34,5.06,0,10.11,1.51,14.82,2.3l-4.95.6,2.09,4.47,21.67,1.48-.06,1c-6.18-.38-12.37-.65-18.54-1.18-3.7-.32-5.32,1.39-5.82,5.42H349.13c-.34-4.49-2.64-5.85-6.66-5.43a82.22,82.22,0,0,1-17.47.18l21.5-1.5"
                />
                <g class="cls-52">
                    <rect
                        class="cls-53"
                        x="480.34"
                        y="520.66"
                        width="4.26"
                        height="104.52"
                    />
                </g>
                <g class="cls-54">
                    <rect
                        class="cls-55"
                        x="258.23"
                        y="171.54"
                        width="50.68"
                        height="30.07"
                    />
                </g>
                <g class="cls-56">
                    <rect
                        class="cls-57"
                        x="407.4"
                        y="171.95"
                        width="50.13"
                        height="29.57"
                    />
                </g>
                <g class="cls-58">
                    <rect
                        class="cls-59"
                        x="417.85"
                        y="172.99"
                        width="67.33"
                        height="80.53"
                    />
                </g>
                <g class="cls-60">
                    <rect
                        class="cls-61"
                        x="231.62"
                        y="172.42"
                        width="67.28"
                        height="80.28"
                    />
                </g>
                <path
                    class="cls-12"
                    d="M267.87,542.37c-8.06-2.06-15.64-3.88-23.12-6.06-1.11-.32-2.25-2.25-2.44-3.57-.38-2.6-.11-5.31-.11-8.66,7,3,13.39,6.6,20.28,8.55,5.55,1.57,5.74,4.73,5.39,9.74"
                />
                <path
                    class="cls-12"
                    d="M473.52,535.88l-24.62,6.39c-1.34-5.43-.33-8.39,5.52-10,6.64-1.78,12.82-5.24,20.09-8.36-.37,4.39-.67,8.06-1,11.93"
                />
                <path
                    class="cls-12"
                    d="M449.48,532.73c-1.44-6,1.16-8.08,5.18-10.2,6.58-3.46,12.68-7.82,19.85-12.35,0,3.75.09,6.81-.06,9.86a3.05,3.05,0,0,1-1.29,2.28c-7.82,3.53-15.7,6.93-23.68,10.41"
                />
                <path
                    class="cls-12"
                    d="M242,510.62c8.36,5,16.32,9.4,23.87,14.45,1.43.95,1.23,4.32,1.78,6.58l-1.17,1c-7.75-3.4-15.54-6.7-23.19-10.31-.84-.4-1.13-2.48-1.23-3.82-.19-2.44-.06-4.91-.06-7.85"
                />
                <path
                    class="cls-12"
                    d="M241.64,366.09c7.51,9,8.1,19,10.43,29.15-3.89-1.9-7.4-3.23-10.42-5.28-1.12-.74-2-3.61-1.44-4.74a17.08,17.08,0,0,0,.67-14.46c-.34-.89.31-2.16.76-4.67"
                />
                <g class="cls-27">
                    <g class="cls-62">
                        <path
                            class="cls-63"
                            d="M440.71,812.36c3.33-2.09,7.16-3.67,9.87-6.38,5.62-5.62,10.64-11.85,15.89-17.82a7.64,7.64,0,0,0,.59-.82c3.5,2.45,3.84,4.88.78,8.17-6.23,6.69-11.23,14.74-20.58,17.77-1.83.59-3.75.87-5.62,1.3l-.93-2.22"
                        />
                    </g>
                </g>
                <path
                    class="cls-12"
                    d="M464.83,395.1c.16-9.24,4.6-22.58,10.12-29.07,0,3,0,4.88,0,6.8.06,3.33-.59,6.91.44,9.91,1.38,4.05,1.22,6.61-3,8.4-2.57,1.11-5,2.58-7.61,4"
                />
                <g class="cls-27">
                    <g class="cls-64">
                        <path
                            class="cls-63"
                            d="M248.35,788.1c6,6.2,11.58,12.22,17.46,18,1.42,1.39,3.92,1.62,5.55,2.87s2.52,3,4.38,5.34a19.49,19.49,0,0,1-14.11-5.1c-5.07-4.56-9.51-9.82-14.14-14.86-2.55-2.78-.69-4.77.86-6.23"
                        />
                    </g>
                </g>
                <path
                    class="cls-2"
                    d="M322.57,426.85c-6.85.6-12.83,1-18.79,1.67-5.73.6-11.45,1.4-17.28,2.13,6.08-9.18,26.11-10.8,36.07-3.8"
                />
                <path
                    class="cls-2"
                    d="M280.9,432.16c.9-2,1.31-4.55,2.77-6.05,10-10.36,33.59-10.91,44.45-1.2.32.28.36.87,1,2.45a45.28,45.28,0,0,1-4.8-2.1c-11-6.67-26.55-6.26-36.91,1.33-2.12,1.56-3.53,4.08-5.28,6.16l-1.2-.59"
                />
                <path
                    class="cls-12"
                    d="M477.82,693.7c-.39,6.88-.7,13.77-1.29,20.64-.08,1-1.45,2-2.47,2.6-.29.18-2.06-1.07-2.07-1.69-.16-7.53,1.41-14.76,3.12-22l2.71.4"
                />
                <path
                    class="cls-12"
                    d="M240.74,693.3a11.49,11.49,0,0,1,1.18,2.71c.91,5.39,1.91,10.78,2.41,16.22.14,1.54-1.31,3.23-2,4.86-1-1.26-2.79-2.48-2.85-3.78-.29-6.54-.13-13.1-.13-19.66l1.42-.35"
                />
                <g class="cls-65">
                    <rect
                        class="cls-66"
                        x="476.28"
                        y="636.14"
                        width="9.32"
                        height="24.18"
                    />
                </g>
                <g class="cls-67">
                    <rect
                        class="cls-68"
                        x="230.8"
                        y="636.06"
                        width="8.43"
                        height="23.23"
                    />
                </g>
                <path
                    class="cls-51"
                    d="M372.07,176.4l36.34,4.13-.13,1.21-36.16-3.94c0-.47,0-.93-.05-1.4"
                />
                <path
                    class="cls-12"
                    d="M479.89,639.14V623.71c5.14,3.84,5.21,9.13,0,15.43"
                />
                <path
                    class="cls-51"
                    d="M308,180.47l36.46-4.05.15,1.33-36.46,4-.15-1.25"
                />
                <path
                    class="cls-12"
                    d="M236.24,623.62c.33,5.35.61,10.06.91,15-5.69-3.32-6.27-9.69-.91-15"
                />
                <path
                    class="cls-12"
                    d="M486.67,372.92c-3.58-1.26-6.32-7.59-4.62-10a2.85,2.85,0,0,1,2.46-1,3.32,3.32,0,0,1,2.07,2.12c.25,2.77.09,5.59.09,8.86"
                />
                <path
                    class="cls-12"
                    d="M234.1,361.81c-.86,4.18,2.38,8.91-3.59,11.2-2.44-8.73-2.07-10.23,3.59-11.2"
                />
                <path
                    class="cls-51"
                    d="M371.22,182.55,405.83,186l-.09,1.07-34.49-3.42,0-1.1"
                />
                <path
                    class="cls-12"
                    d="M479,371.56l-3.43-6c1.42-1,2.72-1.82,4.57-3V371Z"
                />
                <path
                    class="cls-12"
                    d="M240.52,365.21l-2.7,6.26-1.34-.36V362.9l4,2.31"
                />
                <path
                    class="cls-51"
                    d="M344.65,184l-20.74,1.35-.07-1,20.58-1.44c.08.37.16.73.23,1.09"
                />
                <g class="cls-69">
                    <rect
                        class="cls-70"
                        x="97.88"
                        y="186.42"
                        width="125.1"
                        height="632.44"
                    />
                </g>
                <g class="cls-71">
                    <rect
                        class="cls-72"
                        x="49.51"
                        y="364.27"
                        width="88.42"
                        height="169.11"
                    />
                </g>
                <g class="cls-73">
                    <rect
                        class="cls-74"
                        x="54.9"
                        y="532.15"
                        width="85.9"
                        height="148.18"
                    />
                </g>
                <g class="cls-75">
                    <rect
                        class="cls-76"
                        x="41.49"
                        y="165.8"
                        width="88.26"
                        height="201.77"
                    />
                </g>
                <path
                    class="cls-2"
                    d="M147.43,408.46c4.94,0,9.55,1,13.48-.27,3.69-1.14,6.66-4.58,9.81-6.9,26.05,38.62,40.32,82.27,38.53,131.27-7.7-1.49-15.48-3-23.24-4.5-9.49-1.88-18.94-3.9-28.44-5.69-2.8-.53-4.38-1.41-4.5-4.68-.28-8-1.08-16-1.45-24-1.16-24.91-2.19-49.83-3.31-74.74-.15-3.27-.54-6.53-.88-10.48"
                />
                <path
                    class="cls-2"
                    d="M159.24,638.89l-4.37-85,54.79,1.66c0,2.95.17,5.72,0,8.47-1.29,18.15-2.67,36.3-4,54.45-.3,4.07-1.76,6.8-6,8.48-8.21,3.23-15.92,7.79-24.23,10.66-4.62,1.59-10,.86-16.15,1.24"
                />
                <path
                    class="cls-12"
                    d="M58.6,636.57l-24,1.61c0-8.28.13-16.06,0-23.84-.3-13.9.21-27.91-1.39-41.67-2.95-25.2-2.16-50.43-2.5-75.66-.27-18.94-.23-37.89-.39-56.84Q30,400,29.57,359.74c0-1,.09-2,.15-3.26l10.65-1.08c.42,5,1,9.63,1.15,14.27.49,16.41.79,32.82,1.23,49.23q1,38.69,2.16,77.36c.62,21.75,1.18,43.52,1.86,65.27.6,19.08,1.16,38.15,2.17,57.2.16,3,2.52,5.94,4.08,8.79s3.45,5.62,5.58,9.05"
                />
                <g class="cls-77">
                    <rect
                        class="cls-78"
                        x="62.7"
                        y="735.4"
                        width="62.51"
                        height="97.47"
                    />
                </g>
                <path
                    class="cls-2"
                    d="M49.48,742.65c-25.79,0-48.22-22.26-47.79-48.2a48.12,48.12,0,0,1,48.22-47.66c23,.07,47.41,17.55,47.65,47.6.22,27.49-20.74,47.46-48.08,48.26m.26-12.84A35,35,0,0,0,85,694.42a35.25,35.25,0,0,0-70.5.16,34.78,34.78,0,0,0,35.25,35.23"
                />
                <path
                    class="cls-12"
                    d="M37.64,754.85c.53-3.85,1-7.27,1.57-11.33,20.21,2.57,37.58-2.45,50.28-19.16a47.6,47.6,0,0,0,9.25-37.44c-2.63-16.5-11.68-29-26.72-36.62-14.81-7.52-29.9-6.88-44.93-.19-1.19-10.42-.08-16,5.52-26.59v16.64c6.11-.44,11.86-.64,17.56-1.3,11-1.29,21.13,1.44,30.94,6,21,9.68,28.11,27.63,29.19,49.11a84.9,84.9,0,0,1-.25,12.56c-1.9,19.24-11.92,32.76-29.2,41.19-13.62,6.64-28,7.95-43.21,7.16"
                />
                <g class="cls-79">
                    <rect
                        class="cls-80"
                        x="139.48"
                        y="535.45"
                        width="18.18"
                        height="152.06"
                    />
                </g>
                <path
                    class="cls-12"
                    d="M36.44,757.35l24.24-1.26c3.55,25.58,7.12,51.21,10.77,77.43-1.18-.4-2.58-.48-3.39-1.21-5.77-5.25-11.59-10.48-17-16.09a9.73,9.73,0,0,1-2.22-6.43c.2-9.21-3.66-17.24-6.38-25.71s-4-17.36-6-26.73"
                />
                <g class="cls-81">
                    <rect
                        class="cls-82"
                        x="132.1"
                        y="367.86"
                        width="17.11"
                        height="167.59"
                    />
                </g>
                <path
                    class="cls-2"
                    d="M159.78,650.61l42.44-17.84,1.4.87c-2,5.32-3,11.27-6.1,15.85-6.67,10-14.33,19.26-21.72,28.73a16.91,16.91,0,0,1-4.92,4.09c-4.64,2.64-9.17,0-9.47-5.26-.5-8.65-1.06-17.3-1.63-26.44"
                />
                <g class="cls-83">
                    <rect
                        class="cls-84"
                        x="42.7"
                        y="369.61"
                        width="10.74"
                        height="161.64"
                    />
                </g>
                <path
                    class="cls-2"
                    d="M206,441.31c-6.29-11.91-12.44-23.9-18.91-35.72-8.65-15.81-18-31.27-26.16-47.3-3.61-7.09-5.17-15.22-7.66-22.87l1.93-.79c1.45,2.32,3,4.57,4.31,7,15.75,29.59,31.55,59.15,47,88.9,1.51,2.9.68,7,.94,10.55l-1.44.25"
                />
                <path
                    class="cls-12"
                    d="M154.82,552.79c-.16-2.48-.31-3.8-.33-5.13,0-3.16,0-6.33,0-10.28,6.82.76,13.52,1.41,20.19,2.26,9.26,1.17,18.5,2.46,27.74,3.75,7.78,1.08,7.78,1.11,7.15,9.4H154.82"
                />
                <path
                    class="cls-12"
                    d="M40.38,173v64.12H28.84c0-3.35-.19-6.62,0-9.86.83-11.82,1.89-23.62,2.7-35.43.43-6.45,3.25-13,8.8-18.83"
                />
                <path
                    class="cls-12"
                    d="M209.64,534.56v7.79l-55.84-7v-12l55.84,11.23"
                />
                <g class="cls-85">
                    <rect
                        class="cls-86"
                        x="48.47"
                        y="533.3"
                        width="8.14"
                        height="94.26"
                    />
                </g>
                <g class="cls-27">
                    <g class="cls-87">
                        <path
                            class="cls-29"
                            d="M95.52,204.18V181.51c15.8,2,30.57,30,27.12,42.93-9.14.59-15.12-5.26-21.12-11.15,3.63,1.66,7.15,3.72,10.94,4.84,2.63.78,5.64.26,8.49.32-1.57-2.46-2.61-5.6-4.79-7.23-5.9-4.42-12.38-7.9-20.64-7m19.37-.54c-1.37-5.83-10.73-11.14-17.57-10,.48,5.58,10.93,11.51,17.57,10"
                        />
                    </g>
                </g>
                <path
                    class="cls-12"
                    d="M154,588.43c-.45-6.65-1-13.29-1.34-19.94-1.14-21.54-2.15-43.08-3.32-64.62q-1.9-35.31-4-70.63c-1.18-19.86-2.51-39.71-3.74-59.57a8.32,8.32,0,0,1,1.18-5.29c.48,1.13,1.32,2.23,1.37,3.38.84,16,1.51,32.09,2.32,48.13q2.37,46.37,4.82,92.72c.44,8.52.72,17,1.12,25.56q1.15,25,2.35,50l-.76.23"
                />
                <g class="cls-88">
                    <rect
                        class="cls-89"
                        x="146.11"
                        y="383.57"
                        width="22.9"
                        height="24.15"
                    />
                </g>
                <g class="cls-27">
                    <g class="cls-90">
                        <path
                            class="cls-29"
                            d="M49.52,171.19c0,3.21-.26,5.58.07,7.85.3,2,.82,5.29,2,5.67a15.89,15.89,0,0,0,8.91.17c1.28-.37,2.19-3.56,2.43-5.57a86.12,86.12,0,0,0,.11-10l1.45,0v28.47c-10.82,1.34-16.51-3.46-16.67-14.14,0-3.52,0-7,.15-10.54,0-.38.57-.74,1.55-1.92"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-91">
                        <path
                            class="cls-63"
                            d="M125.72,818.57c-.66-8.45-.66-8.45,6.29-10.71,2.36-.77,4.73-1.52,7.1-2.27,7.15-2.26,8.59-1.3,9.23,6.31.13,1.59,0,3.2,0,5.47-8.07-7.17-15.16-3.26-22.64,1.2"
                        />
                    </g>
                </g>
                <path
                    class="cls-12"
                    d="M212.1,546c.05,35.29.3,70.87-11.44,105,6.16-16.78,7.12-34.48,8.32-52.11s2.09-35.29,3.12-52.94"
                />
                <path
                    class="cls-12"
                    d="M159.84,648.53v-7.87c.25-.14.57-.48.8-.42,11.37,2.84,20.59-3.08,30.2-7.4,4.34-1.94,8.66-3.94,13.75-5-.82,1-1.42,2.52-2.47,3-13.88,5.93-27.83,11.7-42.28,17.74"
                />
                <g class="cls-27">
                    <g class="cls-92">
                        <path
                            class="cls-63"
                            d="M148.53,821.48l-24,2.13c7.58-9.93,17.55-10.81,24-2.13"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-93">
                        <path
                            class="cls-29"
                            d="M119.83,216.9c-7.57.88-18.34-4.76-22-11.49,8.8,1.5,15.81,4.93,22,11.49"
                        />
                    </g>
                </g>
                <path
                    class="cls-51"
                    d="M130.07,639.05c4.18.86,6,10.4,4.76,23-1.45-1.07-3.3-1.75-3.39-2.6-.64-6.71-.95-13.45-1.37-20.4"
                />
                <path
                    class="cls-12"
                    d="M81.29,169.13c7.23.64,7.45,1.16,6.49,14.3-7.28-3-7.43-3.32-6.49-14.3"
                />
                <g class="cls-94">
                    <rect
                        class="cls-95"
                        x="58.2"
                        y="631.04"
                        width="24.89"
                        height="11.45"
                    />
                </g>
                <g class="cls-27">
                    <g class="cls-96">
                        <path
                            class="cls-29"
                            d="M56.09,185.69l-5.22-4.79c1.83-1.19,3.66-3.3,5.48-3.28s3.52,2.21,5.27,3.45l-5.53,4.62"
                        />
                    </g>
                </g>
                <path
                    class="cls-12"
                    d="M146.55,387.65V374.87c2.62,1.51,4.86,2.81,6.86,3.95-1.2,2-2.09,3.52-3,5l-2.58,4.32-1.29-.51"
                />
                <path
                    class="cls-12"
                    d="M177.42,680.46c-3.47,6.43-7.45,8.25-15.55,7.47-.08-1.19-.16-2.44-.28-4.22,6.15,2.38,11.15.47,15.83-3.25"
                />
                <path
                    class="cls-12"
                    d="M145.09,370c10.47,3,15,10.89,20,18.28l-20-18.28"
                />
                <g class="cls-97">
                    <rect
                        class="cls-98"
                        x="150.65"
                        y="810.58"
                        width="8.69"
                        height="11.02"
                    />
                </g>
                <path
                    class="cls-12"
                    d="M181.69,412.53l15.63,31.17-1.31.66L180.3,413.21l1.39-.68"
                />
                <path
                    class="cls-51"
                    d="M128.41,643.69c.4,5.56.74,10.15,1.09,15-5.49-3.27-6.08-9-1.09-15"
                />
                <g class="cls-99">
                    <rect
                        class="cls-100"
                        x="493.9"
                        y="187.44"
                        width="125.7"
                        height="630.92"
                    />
                </g>
                <g class="cls-101">
                    <rect
                        class="cls-102"
                        x="578.84"
                        y="365.84"
                        width="88.13"
                        height="167.56"
                    />
                </g>
                <g class="cls-103">
                    <rect
                        class="cls-104"
                        x="575.23"
                        y="531.65"
                        width="86.42"
                        height="149.8"
                    />
                </g>
                <g class="cls-105">
                    <rect
                        class="cls-106"
                        x="586.76"
                        y="166.02"
                        width="88.19"
                        height="201.03"
                    />
                </g>
                <path
                    class="cls-2"
                    d="M546.5,400.17c4.33,10.83,14,8.2,22.41,8.52-1.55,29.56-3.09,58.59-4.6,87.62-.39,7.34-.62,14.7-1.2,22-.1,1.27-1.36,3.29-2.39,3.51-17.76,3.71-35.56,7.2-53.64,10.8-1.49-48.73,12.37-92.45,39.42-132.48"
                />
                <path
                    class="cls-2"
                    d="M507.91,555.56l53.65-1.62q-2.16,42.07-4.27,83.48c-8,2.48-15,1.79-22.08-2.13-6.39-3.57-13.41-6-19.91-9.4-1.84-1-3.85-3.37-4.07-5.31-1.38-12-2.59-24-3.22-36-.5-9.46-.1-19-.1-29.06"
                />
                <path
                    class="cls-12"
                    d="M682.26,638.27l-22.77-1.59c-.32-4,.92-7,4.26-9.81,2.23-1.88,3.78-5.73,3.88-8.77,1-29.29,1.54-58.6,2.36-87.89q1.39-49.71,3-99.41,1-31.89,2-63.77c.13-3.65.61-7.3,1-11.54l9.8.81c0,47.21-.36,94.25.1,141.29.45,46.8-5.07,93.38-3.66,140.68"
                />
                <g class="cls-107">
                    <rect
                        class="cls-108"
                        x="591.82"
                        y="735.64"
                        width="62.11"
                        height="97.16"
                    />
                </g>
                <path
                    class="cls-2"
                    d="M666.84,742.65c-26.41-.89-47.76-19.88-47.83-48-.08-29.4,23.85-47.87,47.9-47.84a48.1,48.1,0,0,1,48,47.9c.27,26-22.2,48.07-48,47.95m-.22-12.84c19.66.08,35.35-15.2,35.45-34.53.11-19.9-15.25-35.85-34.66-36-19.65-.15-35.75,15.56-35.83,34.94a35,35,0,0,0,35,35.59"
                />
                <path
                    class="cls-12"
                    d="M683.71,624.77c6.1,10.33,7.06,15.46,5.64,24.9-39.3-16-68.12,11.47-71.35,36.92a55.09,55.09,0,0,0,2.07,23.65,51,51,0,0,0,12.6,20A53.55,53.55,0,0,0,653.17,742c7.42,2.35,15.74,1.83,24.18,2.62l1.81,11.19c-10.82-1.11-21.38-.85-31.15-3.49-15.26-4.12-28.88-11.82-36.11-27a55.2,55.2,0,0,1-5.16-16c-1.64-12.48-.9-24.77,3.41-37,5.07-14.34,15.07-23.2,28.43-29,12.35-5.37,25.2-5.56,38.26-3.49a47,47,0,0,0,6.87.05Z"
                />
                <g class="cls-109">
                    <rect
                        class="cls-110"
                        x="558.8"
                        y="535.4"
                        width="18.32"
                        height="152.11"
                    />
                </g>
                <path
                    class="cls-12"
                    d="M644.88,834.43l10.91-78.34,23.48,1.22c-.45,4-.61,8-1.38,11.79-1.15,5.72-1.75,11.86-4.35,16.91-4.2,8.13-3.78,17.12-6.41,25.23-2.1,6.46-8.33,11.7-13.19,17.06-2.17,2.4-5.48,3.77-9.06,6.13"
                />
                <g class="cls-111">
                    <rect
                        class="cls-112"
                        x="568.06"
                        y="367.74"
                        width="16.56"
                        height="166.94"
                    />
                </g>
                <path
                    class="cls-2"
                    d="M556.57,650.55c-.5,9-1.05,17.65-1.45,26.33-.25,5.56-5.34,8.67-9.73,5.15s-8.27-8.16-11.9-12.67c-5.23-6.51-10.54-13.05-14.84-20.17-2.8-4.63-3.87-10.32-5.71-15.54l1.36-.84,42.27,17.74"
                />
                <g class="cls-113">
                    <rect
                        class="cls-114"
                        x="663.1"
                        y="369.19"
                        width="10.28"
                        height="162.11"
                    />
                </g>
                <path
                    class="cls-2"
                    d="M563,335.42c-2.06,7.12-3,14.85-6.38,21.24-15.09,28.24-30.9,56.1-46.53,84.24-1.41-3.87-1.89-7.56.36-11.75,15.59-29.11,31-58.33,46.45-87.5,1.24-2.32,2.74-4.51,4.12-6.76l2,.53"
                />
                <path
                    class="cls-12"
                    d="M506.75,553.76a53.33,53.33,0,0,1,.11-7.5,3.63,3.63,0,0,1,2.33-2.47c17-2.2,34.08-4.24,51.13-6.28a5.55,5.55,0,0,1,1.56.29v14.4l-55.13,1.56"
                />
                <path
                    class="cls-12"
                    d="M687.46,237.29h-11.1v-63.6l.75-.58c2.55,4.77,6.76,9.34,7.35,14.35,1.88,15.88,2.42,31.91,3.45,47.89a9,9,0,0,1-.45,1.94"
                />
                <path
                    class="cls-12"
                    d="M562.49,523.36c.21.38.36.52.36.67,0,13.76,2.07,10.81-10.32,12.47-15,2-30,3.9-45.42,5.89v-7.88l55.38-11.15"
                />
                <g class="cls-115">
                    <rect
                        class="cls-116"
                        x="660.67"
                        y="533.67"
                        width="7.89"
                        height="94.16"
                    />
                </g>
                <g class="cls-27">
                    <g class="cls-117">
                        <path
                            class="cls-29"
                            d="M621.1,181.35V204c-9-.55-16,3.37-22.46,8.52-1.56,1.25-2.12,3.73-3.14,5.65,2.15.25,4.53,1.22,6.42.62,4.49-1.4,8.74-3.54,13.27-5C609,219.13,603.1,224.9,594,224.5c-4-11.46,10.24-40.22,27.06-43.15m-19.65,22.41c7.49,1.2,17.65-4.83,17.61-10.21-6.81-.81-15.48,4.07-17.61,10.21"
                        />
                    </g>
                </g>
                <path
                    class="cls-12"
                    d="M574,368.75c0,7.07.22,14.15-.06,21.21-.31,7.68-1.23,15.33-1.64,23-1.17,21.38-2.17,42.78-3.32,64.16q-1.95,36.31-4,72.62c-.71,12.25-1.58,24.48-3.21,36.68q1.07-19.45,2.14-38.9c.4-7.35.81-14.7,1.13-22,1.12-25.25,2.12-50.5,3.32-75.74,1.23-25.73,2.63-51.46,4-77.18a20,20,0,0,1,1.13-4.1l.55.3"
                />
                <g class="cls-118">
                    <rect
                        class="cls-119"
                        x="547.98"
                        y="383.45"
                        width="23.19"
                        height="24.39"
                    />
                </g>
                <g class="cls-27">
                    <g class="cls-120">
                        <path
                            class="cls-29"
                            d="M652,198.12V169.3l1.48,0c0,3.48-.33,7,.13,10.42.27,2,1.49,5,2.84,5.36a16.91,16.91,0,0,0,8.91-.52c1.07-.35,1.5-3.45,1.74-5.36a70,70,0,0,0,.07-7.92c7.1,14.1-.36,27-15.17,26.88"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-121">
                        <path
                            class="cls-63"
                            d="M590.91,818.77c-7.46-4.64-14.49-8.62-22.77-1.32,0-1.78,0-2.84,0-3.91.3-9.39,1.61-10.3,10.53-7.46,1.74.55,3.51,1,5.25,1.54,7.54,2.35,7.54,2.35,7,11.15"
                        />
                    </g>
                </g>
                <path
                    class="cls-12"
                    d="M504.33,545.84c2.38,34.07,1.28,68.4,10.78,102.47-7.05-9.87-14-77.89-10.78-102.47"
                />
                <path
                    class="cls-12"
                    d="M556.73,639.63v8.3c-11.91-2.69-43.42-17.27-44.58-21.16,7.35,3.29,14.56,5.87,21.1,9.61,7.39,4.22,14.93,5.23,23.48,3.25"
                />
                <g class="cls-27">
                    <g class="cls-122">
                        <path
                            class="cls-63"
                            d="M568.19,821.5c5.89-8.65,15.37-8,24.2,2.14l-24.2-2.14"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-123">
                        <path
                            class="cls-29"
                            d="M596.34,217.14c6.65-6.66,13.53-10.29,22-11.64-2.25,6-13.06,11.95-22,11.64"
                        />
                    </g>
                </g>
                <path
                    class="cls-51"
                    d="M581.58,661.86c-.87-12.74.7-21.59,4.84-23.16-.46,7.42-.82,14.41-1.46,21.37-.05.62-2,1.07-3.38,1.79"
                />
                <path
                    class="cls-12"
                    d="M628.75,183.71c-.82-13.47-.82-13.47,5.81-14.66,2.8,7.44,1.6,10.68-5.81,14.66"
                />
                <path
                    class="cls-51"
                    d="M657.31,630.85c1.11,4.83-.46,5.83-4.38,6.52-6.44,1.13-12.66,3.55-19.43,4.48l23.81-11"
                />
                <path
                    class="cls-12"
                    d="M531.25,670.47c7,5.77,10.26,17.8,23.43,13.29.08,1.44.14,2.67.21,3.85-9.51,2.92-16.35-4.32-23.64-17.14"
                />
                <g class="cls-27">
                    <g class="cls-124">
                        <path
                            class="cls-29"
                            d="M660.37,185.69,654.94,181c1.78-1.22,3.56-3.39,5.35-3.39s3.6,2.15,5.4,3.35l-5.32,4.73"
                        />
                    </g>
                </g>
                <path
                    class="cls-12"
                    d="M519.17,443.56q8.36-16.51,16.72-33l1.29.64-16.64,33.07-1.37-.68"
                />
                <path
                    class="cls-51"
                    d="M563,378.87l6.8-4.31v13l-1,.61c-1.83-2.92-3.66-5.84-5.84-9.3"
                />
                <g class="cls-125">
                    <rect
                        class="cls-126"
                        x="557.03"
                        y="810.2"
                        width="9.16"
                        height="11.2"
                    />
                </g>
                <path
                    class="cls-12"
                    d="M550.76,387.54c5.55-6.51,10.08-14.14,19.69-16.25-3.23,2.65-6.59,5.15-9.64,8s-6,6.23-9,9.36l-1-1.1"
                />
                <path
                    class="cls-51"
                    d="M587.11,659.09c.27-5.21.52-9.91.8-15.21,5.14,5,4.79,10.65-.8,15.21"
                />
                <path
                    class="cls-2"
                    d="M49.57,248.47a47,47,0,0,1,48,47.62c0,29-22.57,47.9-47.73,48-26.42,0-47.51-20.11-48.11-47.71-.57-26.25,21.48-47.82,47.84-47.86m-.27,82.8C69.2,331.36,84.92,316,85,296.45a35.25,35.25,0,1,0-70.5-.81c-.06,20.14,15,35.54,34.81,35.63"
                />
                <path
                    class="cls-2"
                    d="M666.64,248.47c26.63-.07,48.88,21.62,48.2,48-.7,27.44-21.54,47.43-47.75,47.56-25.78.12-48.26-19.42-48.09-48.09a47,47,0,0,1,47.64-47.48m.28,82.8c19.92,0,35.18-15.33,35.16-35.28a35.25,35.25,0,1,0-70.5.11,34.88,34.88,0,0,0,35.34,35.17"
                />
                <path
                    class="cls-3"
                    d="M358.43,463.63q20.86,0,41.72,0c10.88,0,16.36,6,16.23,17-.17,14.07-.05,28.14.13,42.21.1,7.23-4.49,13.48-11.57,14.85a39.89,39.89,0,0,1-7.48.69q-39.21.07-78.41,0c-13.87,0-19.53-5.67-19.53-19.51,0-12.4,0-24.8,0-37.2s5.83-18.07,18.18-18c13.58,0,27.15,0,40.72,0m0,2.18c-14.07,0-28.15-.05-42.23,0-9.06,0-14.15,4.08-14.48,13.07-.53,14.55-.51,29.15,0,43.71.3,8.9,5.38,13.42,14.31,13.46q42.23.24,84.45,0c8.88-.05,14-4.73,14.28-13.51q.64-21.6,0-43.22c-.26-9.2-5.36-13.49-14.62-13.53-13.9-.06-27.81,0-41.72,0"
                />
                <path
                    class="cls-2"
                    d="M282.32,667.37c16.62,2.09,32.33,4.17,48.07,5.89,2,.22,4.21-1.48,6.35-2.21,1.86-.63,3.74-1.6,5.63-1.63,10.56-.16,21.13-.12,31.7,0,1.6,0,3.89.19,4.66,1.21,2.91,3.82,6.76,3,10.42,2.58,14.73-1.85,29.43-3.9,45.47-6.05.79,5.12,1.91,10.7,2.47,16.33,1.59,16.15,2.82,32.33,4.5,48.46.37,3.59-.95,5.43-3.93,6.46-7.36,2.55-14.61,6-22.2,7.22-18.44,3-37,5.49-55.62,6.9-9.9.75-20.07-.68-30-2-12.87-1.75-25.71-4-38.4-6.82-5.24-1.16-10.13-4.14-15-6.68-1.11-.58-2.06-2.8-1.94-4.16q2.72-30,5.82-59.91c.22-2.06,1.41-4,2-5.55m1.21,1.54a33.46,33.46,0,0,0-1.41,5.09c-.56,4.64-.88,9.31-1.35,14-1.45,14.47-3,28.93-4.3,43.41-.13,1.52.69,4,1.82,4.59,4.7,2.48,9.51,5.15,14.61,6.4,19.67,4.82,39.76,8.26,59.93,8,18.78-.23,37.57-2.91,56.27-5.22,9.54-1.18,19.09-3.14,27.63-8.28,2.45-1.48,3.71-2.83,3.33-5.88-1.08-8.62-1.91-17.27-2.76-25.91-1.05-10.65-2-21.3-3-31.94-.28-2.88-1.42-4.4-4.9-3.78a406.42,406.42,0,0,1-68.73,6.72c-25.82.18-51.34-2.72-77.1-7.18m94.92,4.67c0-.64,0-1.28,0-1.92-13.52-.88-27-.62-40.57-.17,0,.7,0,1.39,0,2.09Z"
                />
                <path
                    class="cls-2"
                    d="M135.74,510.87c-.47,1.74-1,3.48-1.4,5.23a63.9,63.9,0,0,1-2.05,8c-.63,1.57-2.19,2.78-3.33,4.15a24,24,0,0,1-3.8-3.27c-1.33-1.72-2-4-3.43-5.59-4.7-5-5.22-11.54-.37-16.53,2.16-2.22,2.8-8.78,6.8-5.93s5.72,8.64,8.45,13.15l-.87.81m-9.28,9.78,4,.21c-.44-6.56-.73-12.71-1.35-18.83-.12-1.28-1.44-2.45-2.2-3.66-.57,1.23-1.66,2.49-1.62,3.71.2,6,.69,11.95,1.12,18.57m-2.85-17.11c-5.07,5.54-4.64,10.9.82,14.62-.27-4.86-.52-9.35-.82-14.62"
                />
                <path
                    class="cls-2"
                    d="M49.74,729.81a34.78,34.78,0,0,1-35.25-35.23,35.25,35.25,0,1,1,35.25,35.23M17.48,693.59c-.38.39-.75.78-1.13,1.16,1,.55,1.94,1.54,2.93,1.57,4.68.15,9.37-.13,14,.12,1.4.07,3.48,1.09,3.9,2.2s-.79,2.88-1.61,4.16c-.6.92-1.74,1.5-3.93,3.28,2.92-.34,4.4-.56,5.89-.68s3.59-.78,4.52,0,.82,2.87,1,4.41a28.8,28.8,0,0,1-.49,4.37c4.73-5,9.27-12.11,12,0a17.39,17.39,0,0,0,1.46-4.44c.34-1.52.27-3.94,1.14-4.35,1.31-.62,3.31,0,5,.43.81.19,1.47,1,2.19,1.54a4.57,4.57,0,0,0-.08-3.84c-.71-1.71-1.52-3.38-2.28-5.06,1.89-.7,3.74-1.87,5.67-2,4.16-.28,8.37.07,12.55-.09.9,0,1.76-1.16,2.64-1.78-2.73.1-4.66,1.13-6.46.94a71.12,71.12,0,0,1-11.08-2.25c-4.22-1.14-4.66-3.46-1.73-6.89.79-.93,1.09-2.27,2.17-4.65-2,.91-2.43,1.18-2.89,1.3-1.8.47-3.61.9-5.41,1.34-.38-1.77-.64-3.58-1.16-5.3a31.89,31.89,0,0,0-2.1-4.21c-2.37,12.47-7.24,4.07-10.34,2-.76,3-.67,6.34-2.06,7.15-1.56.91-4.44-.44-7.35-.9.19.81.1,2.28.79,3,3.67,4.14,3.23,5.68-2.3,7.19a7.74,7.74,0,0,0-2.21.78c-3.53,2.31-10.2,2.08-13.25-.55M79,677.5c-4.39,3.22-8.08,5.78-11.56,8.58A2.82,2.82,0,0,0,69,691.34c4.58.22,9.17.09,14.61.09-1.7-5-3.09-9.2-4.67-13.93M56.72,661.69H42.48c1.58,4.95,2.86,9.39,4.49,13.7a4,4,0,0,0,3,1.88c.73.07,2-1.1,2.31-2,1.57-4.31,2.89-8.7,4.47-13.6m-40.9,29.74c5.68,0,10,.13,14.32-.09a4.11,4.11,0,0,0,3-2c.32-.8-.45-2.56-1.28-3.22-3.49-2.76-7.19-5.27-11.61-8.45l-4.48,13.74M36,725.57c1.57-4.91,2.93-8.67,3.94-12.52.36-1.39-.1-3-.18-4.51-1.5.26-3.27.1-4.44.86-3.62,2.35-7,5.05-11.06,8L36,725.57m27.44-62c-1.7,5.06-3.25,9.27-4.48,13.59a4,4,0,0,0,.86,3.51c.68.54,2.59.27,3.5-.34,3.71-2.45,7.25-5.16,11.67-8.36l-11.55-8.4m-39.17,8.49c4.67,3.34,8.24,6,12,8.46a4,4,0,0,0,3.51,0c.6-.34.85-2.12.57-3.06-1.28-4.4-2.79-8.73-4.51-14l-11.57,8.57M74.9,717.41c-4.4-3.29-7.91-6.08-11.61-8.57a3.86,3.86,0,0,0-3.55-.16,3.94,3.94,0,0,0-.8,3.46c1.21,4.28,2.73,8.47,4.41,13.5l11.55-8.23M56.7,727.65c-1.63-5-2.91-9.23-4.47-13.4-.39-1-1.67-2.39-2.58-2.42s-2.32,1.26-2.69,2.27c-1.57,4.3-2.84,8.72-4.36,13.55Zm26.87-29.4c-5.72,0-10.21-.1-14.7.07-1,0-2.6.88-2.72,1.57a4.16,4.16,0,0,0,1.12,3.42c3.61,2.85,7.45,5.42,11.7,8.44l4.6-13.5M20.44,711.72c4.52-3.35,8-5.82,11.36-8.51.86-.7,1.79-2.36,1.5-3.13s-2-1.71-3.08-1.76c-4.44-.19-8.89-.08-14.36-.08l4.58,13.48"
                />
                <path
                    class="cls-2"
                    d="M114.89,203.64c-6.64,1.53-17.09-4.4-17.57-10,6.84-1.17,16.2,4.15,17.57,10m-14.61-9.27c-.37.65-.74,1.3-1.1,2l12.24,6.42,1-1.91-12.13-6.47"
                />
                <path
                    class="cls-2"
                    d="M566.19,810.29,557,818.35l8.8-12.08c.21,2.41.29,3.21.36,4"
                />
                <path
                    class="cls-2"
                    d="M580.84,508.88c1.61-3.05,3.64-7.34,6.16-11.32.49-.78,3.87-1,4.22-.41,2.77,4.49,8,7.94,7.09,14.11a18,18,0,0,1-2.87,7.21c-1.6,2.33-4.73,3.55-4.34,7.28.08.71-2,2.17-3.27,2.34-1,.13-3-.94-3.2-1.82-1.36-5.21-2.34-10.51-3.79-17.39m5.2,11.8,1.4.94c.93-1,2.56-1.89,2.67-3,.6-5.61.92-11.25,1.06-16.89,0-1.12-1.18-2.27-1.81-3.4-.68,1-1.85,1.94-2,3-.59,6.43-.94,12.89-1.37,19.33m6.86-3c4.79-3.6,5.13-9.07,0-13.92Z"
                />
                <path
                    class="cls-2"
                    d="M666.62,729.81a35,35,0,0,1-35-35.59c.08-19.38,16.18-35.09,35.83-34.94,19.41.15,34.77,16.1,34.66,36-.1,19.33-15.79,34.61-35.45,34.53m-15-23.39,7.47-1.53c.29,2.09.44,4.22.92,6.28a5,5,0,0,0,1.12,1.9c2.38-2.31,4.23-5.36,5.62-5.17,2,.28,3.58,3,5.89,5.12l.78-3.14c.4-1.64.33-3.78,1.36-4.75.71-.67,2.94.33,4.5.45,1.32.11,2.67,0,3.39,0-1.33-2.63-2.45-4.82-3.56-7,2.36-.74,4.69-1.89,7.1-2.11,3.82-.36,7.7,0,11.54-.19.82,0,1.57-1.22,3.21-2.59-3.63.93-5.56,2-7.36,1.77a74.07,74.07,0,0,1-11-2.27c-4.2-1.1-4.74-3.56-1.84-6.88a13.76,13.76,0,0,0,1.55-3.28c-7.72,3.34-8.32,3-8.74-4.71,0-.63-1.18-1.2-1.28-1.29-2.11,1.69-4,4.32-5.59,4.16-1.8-.17-3.35-2.86-5.47-4.89a15.43,15.43,0,0,0-.61,3.82c.27,4-1.9,5.62-5.55,4a27,27,0,0,1-2.87-1.7l-1.08.8a19.62,19.62,0,0,0,2,3.25c2.84,3.19,2.09,5.83-2.07,6.81-.8.19-1.93-.19-2.45.25-4.81,4-9.57,2.37-14.73.67a4,4,0,0,0,2.84,2.11c4.69.15,9.38-.11,14.06.1,1.28.05,3.35,1,3.57,1.91.31,1.28-.56,3-1.32,4.31-.56.94-1.77,1.49-2.71,2.23l1.31,1.54m-18.64-15c5.56,0,9.9.15,14.21-.1a4.75,4.75,0,0,0,3.32-2.18c.34-.62-.63-2.46-1.49-3.14-3.49-2.77-7.17-5.3-11.48-8.43-1.57,4.75-2.94,8.93-4.56,13.85m40.84-29.57H659.89c1.51,4.79,2.65,8.94,4.17,13a4.56,4.56,0,0,0,3.05,2.43c.75.12,2.21-1.31,2.58-2.32,1.5-4.18,2.71-8.47,4.13-13.06m22.49,15.73c-4.43,3.17-7.9,5.47-11.14,8.06-1,.79-2.13,2.6-1.85,3.5s2.16,2.1,3.4,2.18c4.31.26,8.64.1,14,.1-1.51-4.79-2.82-8.92-4.37-13.84m-15.66-14c-1.75,5.12-3.31,9.31-4.54,13.6a4,4,0,0,0,.92,3.48c.69.55,2.58.34,3.48-.25,3.71-2.44,7.24-5.15,11.68-8.36l-11.54-8.47M641.54,672c4.36,3.18,7.64,5.74,11.11,8,1.08.7,3.11,1.24,3.93.7s1.22-2.7.89-3.88c-1.2-4.24-2.79-8.37-4.51-13.35L641.54,672m11.6,53.72c1.75-5.26,3.29-9.46,4.49-13.76a3.79,3.79,0,0,0-.92-3.39,4,4,0,0,0-3.56.25c-3.71,2.49-7.22,5.27-11.43,8.4l11.42,8.5m20.8,1.91c-1.57-4.92-2.75-9-4.25-13a5,5,0,0,0-2.83-2.79c-.65-.18-2.31,1.29-2.68,2.32-1.54,4.31-2.76,8.75-4.22,13.52Zm18.26-10.26c-4.17-3.1-7.7-5.86-11.41-8.38-.9-.62-2.95-1-3.44-.47a4.7,4.7,0,0,0-1.11,3.83c1.15,4.21,2.7,8.32,4.35,13.2l11.61-8.18m-54.6-5.76c4.24-3,8-5.49,11.51-8.25a4.3,4.3,0,0,0,1.35-3.32c-.06-.68-1.63-1.7-2.55-1.74-4.63-.17-9.27-.08-14.9-.08l4.59,13.39m63.15-13.4c-5.65,0-10.12-.13-14.57.08a4.2,4.2,0,0,0-3,1.93c-.34.63.38,2.35,1.13,2.92,3.61,2.75,7.4,5.27,11.85,8.38,1.58-4.61,2.89-8.44,4.57-13.31"
                />
                <path
                    class="cls-2"
                    d="M601.45,203.77c2.13-6.15,10.8-11,17.61-10.22,0,5.38-10.12,11.41-17.61,10.22m15.91-7.48c-.36-.66-.73-1.32-1.1-2L604.18,201l1,1.9,12.14-6.6"
                />
                <path
                    class="cls-2"
                    d="M49.3,331.27c-19.82-.09-34.87-15.49-34.81-35.63a35.25,35.25,0,1,1,70.5.81C84.92,316,69.2,331.36,49.3,331.27M44,314.19,49.91,309c1.63,1.85,3.25,3.71,5.2,5.94.27-1,.65-2.36,1-3.72.37-1.52.24-3.95,1.11-4.37,1.28-.61,3.28.06,4.91.45a8.23,8.23,0,0,1,2.29,1.45,4.71,4.71,0,0,0-.15-3.81c-.71-1.69-1.51-3.34-2.27-5,1.7-.71,3.37-1.91,5.12-2,4.33-.29,8.7,0,13-.16,1,0,1.87-1.07,2.8-1.65-.92-.43-1.82-1.21-2.76-1.24-4.51-.14-9,.11-13.55-.2-1.59-.11-3.9-1.07-4.4-2.27s1-3.08,1.6-4.66c.45-1.12.95-2.22,1.43-3.34a4,4,0,0,0-2.34.25c-1.77.46-4.06,1.7-5.2,1s-.9-3.33-1.46-5.05A13.7,13.7,0,0,0,55,278.1c-2,2-3.59,4.92-5.22,4.94s-3.48-2.7-6-4.9a34.09,34.09,0,0,1-.49,3.68c-.31,1.36-.44,3.18-1.35,3.85s-2.71.3-4,0c-1-.23-1.91-1.07-4.11-2.39.71,2.28,1,3.42,1.43,4.48.65,1.53,2.43,3.82,2,4.34a7.82,7.82,0,0,1-4.87,2.58c-4.32.37-8.7,0-13,.23-1,0-1.89,1.08-2.83,1.66.93.43,1.84,1.21,2.77,1.24,4.68.12,9.38-.11,14,.15,1.41.08,3.52,1.06,3.9,2.13s-.79,2.89-1.59,4.19a10.68,10.68,0,0,1-2.47,2.15l1.41,1.48,7.19-1.35c.35,1.93.59,3.89,1.09,5.78A5.74,5.74,0,0,0,44,314.19m12.67-50.86H42.48c1.58,4.84,2.78,9,4.35,13a4.68,4.68,0,0,0,3.06,2.46c.72.12,2.17-1.35,2.55-2.38,1.49-4,2.7-8.2,4.25-13.07M79,279c-4.41,3.23-8.18,5.84-11.74,8.71a3.82,3.82,0,0,0-1.17,3.36c.34.86,2,1.62,3.15,1.67,4.46.19,8.93.07,14.24.07L79,279M15.81,292.83c5.65,0,10,.12,14.29-.08,1.14-.05,2.79-.85,3.16-1.74s-.42-2.62-1.26-3.27c-3.58-2.81-7.37-5.36-11.73-8.46-1.56,4.75-2.88,8.76-4.46,13.55m40.93,36.5c-1.59-4.92-2.87-9.2-4.41-13.39-.4-1.08-1.91-2.75-2.44-2.59a5.2,5.2,0,0,0-3,2.66c-1.57,4.13-2.77,8.4-4.34,13.32ZM75.11,319C70.6,315.7,67,313,63.29,310.55c-.93-.61-2.78-.94-3.52-.41s-1.13,2.4-.83,3.44c1.23,4.39,2.78,8.69,4.44,13.69L75.11,319M35.93,327.1c1.65-4.94,3.13-9,4.25-13.07.33-1.19,0-3.25-.76-3.85s-2.83-.14-3.86.54c-3.67,2.43-7.14,5.16-11.32,8.24l11.69,8.14m39.24-53.63-11.79-8.18c-1.63,4.85-3.09,8.75-4.2,12.75-.35,1.26-.22,3.25.57,4,.59.6,2.83.26,3.87-.4,3.62-2.31,7-4.95,11.55-8.21m8.37,26.38c-5.46,0-9.8-.11-14.12.06-1.16,0-3.22.87-3.25,1.42a5.06,5.06,0,0,0,1.47,3.76c3.46,2.78,7.18,5.25,11.3,8.19,1.54-4.51,2.93-8.55,4.6-13.43M24.29,273.54c4.53,3.31,7.93,6,11.55,8.33a4.91,4.91,0,0,0,4,.14c.54-.24.65-2.4.33-3.52-1.22-4.23-2.7-8.39-4.32-13.27l-11.57,8.32m-3.88,39.62c4.29-3.07,7.88-5.47,11.24-8.17,1-.77,1.22-2.4,1.8-3.64-1.13-.5-2.25-1.39-3.4-1.44-4.43-.17-8.86-.06-14.27-.06,1.67,4.82,3.06,8.8,4.63,13.31"
                />
                <path
                    class="cls-2"
                    d="M666.92,331.27a34.88,34.88,0,0,1-35.34-35.17,35.25,35.25,0,1,1,70.5-.11c0,19.95-15.24,35.27-35.16,35.28m-33.58-35c.14.53.29,1.05.43,1.58,5.31,0,10.63-.14,15.94.08,1.62.07,3.21,1.15,4.82,1.76-.69,1.69-1.38,3.37-2.06,5.06-.46,1.16-.91,2.32-1.36,3.48a4.29,4.29,0,0,0,2.65-.5c1.8-.49,3.64-.84,5.46-1.25.34,1.8.58,3.63,1,5.4a15.18,15.18,0,0,0,1.18,2.66c1.95-2.09,3.67-5.28,5.1-5.15,1.94.17,3.65,2.88,6.29,5.24a24.52,24.52,0,0,1,.32-4c.32-1.36.63-3.14,1.59-3.8s2.73-.31,4,0c1,.25,1.76,1.2,2.62,1.83l1.21-.78c-.51-1.12-1.07-2.22-1.54-3.36-.66-1.57-2.13-3.56-1.64-4.63s2.9-1.91,4.51-2c4.5-.25,9,0,13.55-.13.88,0,1.73-.92,2.6-1.42-.85-.52-1.68-1.46-2.55-1.49-4.68-.16-9.39.13-14-.22a6.15,6.15,0,0,1-4.22-2.7c-.44-.76,1.15-2.65,1.78-4.06.5-1.13.93-2.29,1.33-3.28-3.1.54-5.46,1.42-7.59,1.05-.68-.12-.65-3.61-1.2-5.49a4.65,4.65,0,0,0-1.23-1.72c-2.16,1.89-4.2,4.86-5.57,4.58-1.95-.41-3.41-3.19-5.73-5.65a36.66,36.66,0,0,1-.45,4.43c-.31,1.36-.56,3.15-1.5,3.84s-2.69.28-4,0a11.14,11.14,0,0,1-2.87-1.69l-1.12.75c.59,1.07,1.25,2.12,1.76,3.23.66,1.41,2.06,3.34,1.59,4.22a6,6,0,0,1-4.25,2.53c-4.49.35-9,.07-13.55.25-1.12,0-2.22.88-3.33,1.35m4.18-17.15-4.47,13.72c5.34,0,9.85.12,14.35-.08,1.1-.05,2.79-.93,3.06-1.79s-.5-2.63-1.36-3.32c-3.38-2.72-7-5.17-11.58-8.53m36.38-15.79h-14c1.51,4.81,2.64,9,4.16,13,.42,1.12,2,2.56,3,2.48s2.33-1.62,2.77-2.81c1.46-3.87,2.59-7.88,4.1-12.63m22.34,15.84c-4.47,3.23-8.26,5.85-11.88,8.69-.75.58-1.48,2.28-1.15,2.89a4.3,4.3,0,0,0,3,2c4.48.21,9,.09,14.51.09-1.55-4.77-2.9-8.88-4.46-13.67m-15.62-14c-1.7,5-3.26,9.15-4.5,13.42a4.07,4.07,0,0,0,.82,3.54c.69.58,2.64.46,3.53-.12,3.71-2.44,7.24-5.17,11.73-8.45l-11.58-8.39M641.36,319l11.83,8.16c1.66-4.88,3.19-8.93,4.34-13.08a5.17,5.17,0,0,0-.82-4c-.35-.47-2.53-.14-3.46.47-3.74,2.44-7.32,5.14-11.89,8.41m50.9,0c-4.28-3.18-7.68-5.87-11.27-8.25-1-.68-3.12-1.08-3.85-.5s-1.16,2.68-.84,3.88c1.12,4.21,2.63,8.33,4.21,13.17l11.75-8.3M674,329.37c-1.57-4.86-2.78-9-4.29-13-.47-1.22-1.79-2.13-2.72-3.18-1,1-2.47,1.75-2.91,2.93-1.54,4.12-2.73,8.38-4.26,13.27Zm-21-64.14-11.59,8.37c4.38,3.14,7.79,5.76,11.39,8.06,1.06.68,2.68.46,4,.65.19-1.39.84-2.91.49-4.15-1.16-4.1-2.68-8.11-4.34-12.93m47.73,34.62c-5.71,0-10-.11-14.35.07-1.13.05-2.85.76-3.16,1.6a3.84,3.84,0,0,0,1.25,3.32c3.6,2.8,7.4,5.33,11.66,8.33,1.56-4.54,2.94-8.53,4.6-13.32m-67.8,0c1.74,5,3.14,9,4.66,13.35,4.13-2.94,7.86-5.45,11.38-8.21a4,4,0,0,0,1.45-3.27c-.2-.82-1.89-1.74-3-1.79-4.48-.2-9-.08-14.53-.08"
                />
                <path
                    class="cls-3"
                    d="M358.46,465.81c13.91,0,27.82-.05,41.72,0,9.26,0,14.36,4.33,14.62,13.53q.61,21.6,0,43.22c-.26,8.78-5.4,13.46-14.28,13.51q-42.23.23-84.45,0c-8.93,0-14-4.56-14.31-13.46-.48-14.56-.5-29.16,0-43.71.33-9,5.42-13,14.48-13.07,14.08-.07,28.16,0,42.23,0"
                />
                <path
                    class="cls-2"
                    d="M283.52,668.91c25.77,4.46,51.29,7.36,77.11,7.18a406.42,406.42,0,0,0,68.73-6.72c3.48-.62,4.62.9,4.9,3.78,1.05,10.64,2,21.29,3,31.94.86,8.64,1.69,17.29,2.77,25.91.38,3-.88,4.4-3.33,5.88-8.54,5.14-18.09,7.1-27.63,8.28-18.7,2.31-37.49,5-56.27,5.22-20.17.24-40.26-3.2-59.93-8-5.1-1.25-9.91-3.92-14.61-6.4-1.13-.59-2-3.07-1.82-4.59,1.3-14.48,2.85-28.94,4.3-43.41.47-4.65.79-9.32,1.35-14a34.64,34.64,0,0,1,1.4-5.09"
                />
                <g class="cls-27">
                    <g class="cls-127">
                        <path
                            class="cls-63"
                            d="M378.45,673.58H337.88c0-.7,0-1.39,0-2.09,13.53-.45,27.05-.71,40.57.17,0,.64,0,1.28,0,1.92"
                        />
                    </g>
                </g>
                <path
                    class="cls-51"
                    d="M126.46,520.65c-.43-6.62-.92-12.59-1.12-18.57,0-1.22,1-2.48,1.62-3.71.76,1.21,2.08,2.38,2.2,3.66.62,6.12.91,12.27,1.35,18.83l-4-.21"
                />
                <path
                    class="cls-51"
                    d="M123.61,503.54c.3,5.27.55,9.76.82,14.62-5.46-3.72-5.89-9.08-.82-14.62"
                />
                <path
                    class="cls-51"
                    d="M17.48,693.59c3.05,2.63,9.72,2.86,13.25.55a7.74,7.74,0,0,1,2.21-.78c5.53-1.51,6-3.05,2.3-7.19-.69-.77-.6-2.24-.79-3,2.91.46,5.79,1.81,7.35.9,1.39-.81,1.3-4.13,2.06-7.15,3.1,2,8,10.42,10.34-2A33.21,33.21,0,0,1,56.3,679c.52,1.72.78,3.53,1.16,5.3,1.8-.44,3.61-.87,5.41-1.34.46-.12.88-.39,2.89-1.3-1.08,2.38-1.38,3.72-2.18,4.65-2.92,3.43-2.48,5.75,1.74,6.89a71.23,71.23,0,0,0,11.07,2.25c1.81.19,3.74-.84,6.47-.94-.88.62-1.74,1.74-2.64,1.77-4.18.17-8.39-.18-12.55.1-1.93.14-3.79,1.31-5.67,2,.76,1.68,1.57,3.35,2.28,5.05a4.63,4.63,0,0,1,.08,3.85c-.72-.53-1.38-1.35-2.19-1.55-1.64-.39-3.64-1-5-.42-.87.41-.8,2.83-1.14,4.35a17.39,17.39,0,0,1-1.46,4.44c-2.75-12.12-7.29-5-12,0a28.8,28.8,0,0,0,.49-4.37c-.17-1.54-.07-3.69-1-4.41s-3-.08-4.52,0-3,.34-5.89.68c2.19-1.78,3.33-2.36,3.93-3.28.82-1.28,2-3.11,1.61-4.16s-2.5-2.13-3.9-2.2c-4.68-.25-9.37,0-14.06-.12-1,0-1.95-1-2.92-1.57.38-.38.75-.77,1.13-1.16m34.27,13.22c1.7-2.12,3.44-3.35,3.54-4.72.08-1-1.89-2.25-2.95-3.39-1.18,1.13-3,2.09-3.34,3.44-.26,1,1.37,2.47,2.75,4.67m-13-7.23c2.28,1.29,3.72,2.73,5.12,2.69,1,0,2.92-2.49,2.66-3.1a5.59,5.59,0,0,0-3.57-3.09c-1-.14-2.24,1.77-4.21,3.5m18.09-12.21c-2.06-1.64-3.37-3.45-4.36-3.29A5.4,5.4,0,0,0,49,687.21c-.24.63,1.77,3,2.75,3,1.39,0,2.78-1.47,5-2.83m-13.51,7.22c1.55-2,3.4-3.34,3.19-4.27-.3-1.41-2-2.5-3.16-3.73-1.12,1.08-3.13,2.15-3.12,3.22,0,1.35,1.64,2.7,3.09,4.78m18.87.07c-2.1-1.51-3.48-3.22-4.45-3-1.34.29-2.37,2-3.54,3.13,1.14,1,2.22,2.57,3.43,2.68s2.42-1.4,4.56-2.8"
                />
                <path
                    class="cls-51"
                    d="M79,677.5c1.58,4.73,3,8.88,4.67,13.93-5.44,0-10,.13-14.61-.09a2.82,2.82,0,0,1-1.62-5.26c3.48-2.8,7.17-5.36,11.56-8.58"
                />
                <path
                    class="cls-51"
                    d="M56.72,661.69c-1.58,4.9-2.9,9.29-4.47,13.6-.32.88-1.58,2.05-2.31,2a4,4,0,0,1-3-1.88c-1.63-4.31-2.91-8.75-4.49-13.7Z"
                />
                <path
                    class="cls-51"
                    d="M15.82,691.43l4.48-13.74c4.42,3.18,8.12,5.69,11.61,8.45.83.66,1.6,2.42,1.28,3.22a4.13,4.13,0,0,1-3,2c-4.31.22-8.65.09-14.32.09"
                />
                <path
                    class="cls-51"
                    d="M36,725.57l-11.74-8.14c4-3,7.44-5.68,11.06-8,1.17-.76,2.94-.6,4.44-.86.08,1.51.54,3.12.18,4.51-1,3.85-2.37,7.61-3.94,12.52"
                />
                <path
                    class="cls-51"
                    d="M63.46,663.59,75,672c-4.41,3.2-8,5.91-11.66,8.36-.91.61-2.82.88-3.5.34a4,4,0,0,1-.86-3.51c1.23-4.32,2.78-8.53,4.48-13.59"
                />
                <path
                    class="cls-51"
                    d="M24.29,672.08l11.57-8.57c1.72,5.23,3.23,9.56,4.51,14,.28.94,0,2.72-.57,3.06a4,4,0,0,1-3.51,0c-3.76-2.42-7.33-5.12-12-8.46"
                />
                <path
                    class="cls-51"
                    d="M74.9,717.41l-11.55,8.23c-1.68-5-3.2-9.22-4.41-13.5a3.94,3.94,0,0,1,.8-3.46,3.86,3.86,0,0,1,3.55.16c3.7,2.49,7.21,5.28,11.61,8.57"
                />
                <path
                    class="cls-51"
                    d="M56.7,727.65H42.6c1.52-4.83,2.79-9.25,4.36-13.55.37-1,1.79-2.3,2.69-2.27s2.19,1.38,2.58,2.42c1.56,4.17,2.84,8.44,4.47,13.4"
                />
                <path
                    class="cls-51"
                    d="M83.57,698.25,79,711.75c-4.25-3-8.09-5.59-11.7-8.44a4.13,4.13,0,0,1-1.12-3.42c.12-.69,1.74-1.54,2.72-1.57,4.49-.17,9-.07,14.7-.07"
                />
                <path
                    class="cls-51"
                    d="M20.44,711.72l-4.58-13.48c5.47,0,9.92-.11,14.36.08,1.11,0,2.75.88,3.08,1.76s-.64,2.43-1.5,3.13c-3.33,2.69-6.84,5.16-11.36,8.51"
                />
                <g class="cls-27">
                    <g class="cls-128">
                        <path
                            class="cls-29"
                            d="M100.28,194.37l12.13,6.47-1,1.91-12.24-6.42c.36-.66.73-1.31,1.1-2"
                        />
                    </g>
                </g>
                <path
                    class="cls-51"
                    d="M586,520.68c.43-6.44.78-12.9,1.37-19.33.1-1,1.27-2,2-3,.63,1.13,1.83,2.28,1.81,3.4-.14,5.64-.46,11.28-1.06,16.89-.11,1.07-1.74,2-2.67,3Z"
                />
                <path
                    class="cls-51"
                    d="M592.9,517.72V503.8c5.13,4.85,4.79,10.32,0,13.92"
                />
                <path
                    class="cls-51"
                    d="M651.62,706.42l-1.31-1.54c.94-.74,2.15-1.29,2.71-2.23.76-1.3,1.63-3,1.32-4.31-.22-.9-2.29-1.86-3.57-1.91-4.68-.21-9.37.05-14.06-.1a4,4,0,0,1-2.84-2.11c5.16,1.7,9.92,3.31,14.73-.67.52-.44,1.65-.06,2.45-.25,4.16-1,4.91-3.61,2.07-6.81a19.62,19.62,0,0,1-2-3.25l1.08-.8a27,27,0,0,0,2.87,1.7c3.65,1.62,5.82,0,5.55-4a15.43,15.43,0,0,1,.61-3.82c2.12,2,3.67,4.72,5.47,4.89,1.6.16,3.48-2.47,5.59-4.16.1.09,1.24.66,1.28,1.29.42,7.69,1,8,8.74,4.71a13.76,13.76,0,0,1-1.55,3.28c-2.9,3.32-2.36,5.78,1.84,6.88a74.07,74.07,0,0,0,11,2.27c1.8.2,3.73-.84,7.36-1.77-1.64,1.37-2.39,2.55-3.21,2.59-3.84.2-7.72-.17-11.54.19-2.41.22-4.74,1.37-7.1,2.11,1.11,2.19,2.23,4.38,3.56,7-.72,0-2.06.08-3.39,0-1.56-.12-3.79-1.12-4.5-.45-1,1-1,3.11-1.36,4.75l-.78,3.15c-2.31-2.17-3.93-4.85-5.89-5.13-1.39-.19-3.24,2.86-5.62,5.17a5,5,0,0,1-1.12-1.9c-.48-2.06-.63-4.18-.92-6.28l-7.47,1.53m12.79.42c1.57-2.09,3.32-3.44,3.14-4.43-.26-1.38-2-2.5-3-3.73-1.14,1.05-3.17,2.09-3.19,3.16,0,1.36,1.6,2.74,3.1,5m4.2-7.45c2.18,1.39,3.55,2.93,4.89,2.9,1.1,0,2.15-1.93,3.22-3-1.19-1.15-2.25-3-3.62-3.24-1-.2-2.37,1.68-4.49,3.34m-3.75-7.67c1.34-2.13,3-3.63,2.7-4.54a5.17,5.17,0,0,0-3.43-3.08c-.81-.15-2.93,2.09-2.82,3.08.14,1.34,1.85,2.51,3.55,4.54m12.93-1.85c-2-1.46-3.46-3.3-4.39-3.06a5.35,5.35,0,0,0-3.22,3.48c-.18.76,2.07,3,3.11,2.9,1.36-.11,2.59-1.82,4.5-3.32M663.71,695c-2-1.65-3.21-3.47-4.21-3.34-1.34.17-2.48,1.85-3.72,2.88,1.05,1,2,2.74,3.17,2.91s2.54-1.23,4.76-2.45"
                />
                <path
                    class="cls-51"
                    d="M633,691.44c1.62-4.92,3-9.1,4.56-13.85,4.32,3.13,8,5.66,11.48,8.43.86.68,1.83,2.52,1.49,3.14a4.75,4.75,0,0,1-3.32,2.18c-4.31.25-8.65.1-14.21.1"
                />
                <path
                    class="cls-51"
                    d="M673.82,661.87c-1.42,4.59-2.63,8.88-4.13,13.06-.37,1-1.83,2.44-2.58,2.32a4.52,4.52,0,0,1-3-2.43c-1.53-4-2.67-8.16-4.18-13Z"
                />
                <path
                    class="cls-51"
                    d="M696.31,677.6c1.55,4.92,2.86,9,4.37,13.84-5.32,0-9.65.16-14-.1-1.23-.08-3.07-1.16-3.39-2.18s.85-2.7,1.84-3.5c3.24-2.59,6.71-4.89,11.14-8.06"
                />
                <path
                    class="cls-51"
                    d="M680.65,663.56,692.19,672c-4.44,3.21-8,5.92-11.68,8.36-.9.59-2.79.8-3.48.25a4,4,0,0,1-.92-3.48c1.23-4.29,2.79-8.48,4.54-13.6"
                />
                <path
                    class="cls-51"
                    d="M641.54,672,653,663.52c1.72,5,3.31,9.11,4.51,13.35.33,1.18-.06,3.33-.89,3.88s-2.85,0-3.93-.7c-3.47-2.27-6.75-4.83-11.11-8"
                />
                <path
                    class="cls-51"
                    d="M653.14,725.76l-11.42-8.5c4.21-3.13,7.72-5.91,11.43-8.4a4,4,0,0,1,3.56-.25,3.79,3.79,0,0,1,.92,3.39c-1.2,4.3-2.74,8.5-4.49,13.76"
                />
                <path
                    class="cls-51"
                    d="M673.94,727.67H660c1.46-4.77,2.68-9.21,4.22-13.52.37-1,2-2.5,2.68-2.32a5,5,0,0,1,2.83,2.79c1.51,4,2.68,8.13,4.25,13"
                />
                <path
                    class="cls-51"
                    d="M692.2,717.41l-11.61,8.18c-1.65-4.88-3.2-9-4.35-13.2a4.7,4.7,0,0,1,1.11-3.83c.49-.51,2.54-.15,3.44.47,3.71,2.52,7.24,5.28,11.41,8.38"
                />
                <path
                    class="cls-51"
                    d="M637.6,711.65,633,698.26c5.63,0,10.27-.09,14.9.08.92,0,2.49,1.06,2.55,1.74a4.32,4.32,0,0,1-1.34,3.32c-3.54,2.76-7.28,5.25-11.52,8.25"
                />
                <path
                    class="cls-51"
                    d="M700.75,698.25c-1.68,4.87-3,8.7-4.57,13.31-4.45-3.11-8.24-5.63-11.85-8.38-.75-.57-1.47-2.29-1.13-2.92a4.2,4.2,0,0,1,3-1.93c4.45-.21,8.92-.08,14.57-.08"
                />
                <g class="cls-27">
                    <g class="cls-129">
                        <path
                            class="cls-29"
                            d="M617.36,196.29l-12.14,6.6-1-1.9,12.08-6.68c.37.66.74,1.32,1.1,2"
                        />
                    </g>
                </g>
                <path
                    class="cls-51"
                    d="M44,314.19a5.74,5.74,0,0,1-1.16-1.86c-.5-1.89-.75-3.85-1.09-5.78l-7.19,1.35-1.41-1.48a10.43,10.43,0,0,0,2.46-2.15c.81-1.3,2-3.11,1.6-4.2s-2.49-2-3.9-2.12c-4.67-.26-9.37,0-14-.15-.93,0-1.84-.81-2.77-1.24.94-.58,1.86-1.62,2.83-1.66,4.34-.19,8.72.14,13-.23a7.82,7.82,0,0,0,4.87-2.58c.43-.52-1.35-2.81-2-4.34-.46-1.06-.72-2.2-1.43-4.48,2.2,1.32,3.08,2.16,4.11,2.4,1.31.3,3.13.65,4,0s1-2.49,1.35-3.85a34.09,34.09,0,0,0,.49-3.68c2.5,2.2,4.26,4.93,6,4.9S53,280.12,55,278.1a14.37,14.37,0,0,1,1.26,2.54c.56,1.72.37,4.41,1.46,5.05s3.43-.57,5.2-1a4,4,0,0,1,2.34-.25c-.48,1.12-1,2.22-1.43,3.34-.63,1.58-2.08,3.53-1.6,4.66s2.81,2.16,4.4,2.27c4.5.31,9,.06,13.55.2.94,0,1.84.81,2.76,1.24-.93.58-1.84,1.61-2.8,1.65-4.34.17-8.71-.13-13,.16-1.74.12-3.41,1.32-5.11,2,.76,1.66,1.56,3.31,2.27,5a4.71,4.71,0,0,1,.15,3.81,8.23,8.23,0,0,0-2.29-1.45c-1.63-.39-3.63-1.07-4.91-.45-.87.42-.74,2.85-1.11,4.37s-.7,2.71-1,3.72c-2-2.23-3.57-4.09-5.2-5.94L44,314.19m18.11-18.06c-2.06-1.5-3.45-3.24-4.37-3-1.4.33-2.46,2-3.67,3.15,1.09,1.08,2.16,3,3.25,3,1.31,0,2.62-1.62,4.79-3.15M52.21,308.2c1.46-2.17,3.06-3.52,3-4.85,0-1-2-2-3.19-3.05-1.08,1.22-2.75,2.32-3,3.72-.19.9,1.62,2.22,3.19,4.18M38.7,291.63c2.15,1.41,3.49,2.93,4.9,3,1,.05,2.06-1.9,3.1-2.95-1.17-1.14-2.2-2.94-3.53-3.2-1-.19-2.39,1.6-4.47,3.15m4.51,13.53c1.55-1.84,3.47-3.22,3.25-4a5.06,5.06,0,0,0-3.3-3.14c-.82-.17-2.89,1.76-3,2.85s1.56,2.38,3,4.33m9.06-12.05c1.43-2,3-3.23,2.95-4.33s-2.13-3.06-2.93-2.88A5,5,0,0,0,49,289.05c-.21.85,1.67,2.2,3.23,4.06"
                />
                <path
                    class="cls-51"
                    d="M56.69,263.33c-1.55,4.87-2.76,9-4.25,13.07-.38,1-1.83,2.5-2.55,2.38a4.68,4.68,0,0,1-3.06-2.46c-1.57-4-2.77-8.15-4.35-13Z"
                />
                <path
                    class="cls-51"
                    d="M79,279l4.48,13.81c-5.31,0-9.78.11-14.24-.07-1.13-.05-2.81-.81-3.15-1.67a3.82,3.82,0,0,1,1.17-3.36c3.56-2.87,7.33-5.48,11.74-8.71"
                />
                <path
                    class="cls-51"
                    d="M15.81,292.83c1.58-4.79,2.9-8.8,4.46-13.55,4.36,3.1,8.15,5.65,11.73,8.46.83.65,1.6,2.46,1.26,3.27s-2,1.69-3.16,1.74c-4.31.2-8.64.08-14.29.08"
                />
                <path
                    class="cls-51"
                    d="M56.74,329.33H42.51c1.57-4.92,2.77-9.19,4.34-13.32a5.17,5.17,0,0,1,3-2.66c.53-.16,2,1.51,2.44,2.59,1.54,4.19,2.82,8.47,4.41,13.39"
                />
                <path
                    class="cls-51"
                    d="M75.11,319l-11.73,8.32c-1.66-5-3.21-9.3-4.44-13.69-.3-1.05.08-2.92.83-3.45s2.59-.19,3.52.42C67,313,70.6,315.7,75.11,319"
                />
                <path
                    class="cls-51"
                    d="M35.93,327.1,24.24,319c4.18-3.08,7.65-5.81,11.32-8.24,1-.68,3.1-1.11,3.86-.54s1.09,2.66.76,3.85c-1.12,4.12-2.6,8.13-4.25,13.07"
                />
                <path
                    class="cls-51"
                    d="M75.17,273.47c-4.52,3.26-7.93,5.9-11.55,8.21-1,.66-3.28,1-3.87.4-.79-.79-.92-2.77-.57-4,1.11-4,2.57-7.91,4.2-12.76l11.79,8.18"
                />
                <path
                    class="cls-51"
                    d="M83.54,299.84c-1.67,4.89-3.06,8.92-4.6,13.44-4.13-2.95-7.84-5.41-11.31-8.19a5.06,5.06,0,0,1-1.46-3.76c0-.55,2.08-1.37,3.25-1.42,4.32-.17,8.66-.07,14.12-.07"
                />
                <path
                    class="cls-51"
                    d="M24.29,273.54l11.57-8.32c1.62,4.88,3.1,9,4.32,13.27.32,1.12.21,3.28-.34,3.52a4.92,4.92,0,0,1-4-.14c-3.63-2.33-7-5-11.55-8.33"
                />
                <path
                    class="cls-51"
                    d="M20.41,313.16c-1.57-4.51-3-8.49-4.63-13.31,5.41,0,9.84-.11,14.27.06,1.15,0,2.27.94,3.4,1.44-.58,1.24-.85,2.87-1.8,3.64-3.36,2.7-6.95,5.1-11.24,8.17"
                />
                <path
                    class="cls-51"
                    d="M633.34,296.26c1.11-.47,2.21-1.3,3.34-1.35,4.51-.18,9.05.1,13.54-.25a6,6,0,0,0,4.25-2.53c.47-.88-.93-2.81-1.59-4.22-.51-1.11-1.16-2.16-1.76-3.23l1.12-.75a11.43,11.43,0,0,0,2.87,1.69c1.31.32,3.12.67,4,0s1.19-2.48,1.5-3.84a36.66,36.66,0,0,0,.45-4.43c2.32,2.46,3.78,5.24,5.73,5.65,1.37.28,3.41-2.7,5.57-4.58a4.65,4.65,0,0,1,1.23,1.72c.55,1.88.52,5.37,1.2,5.49,2.14.37,4.49-.51,7.59-1.05-.4,1-.83,2.15-1.33,3.28-.63,1.41-2.22,3.3-1.78,4.06a6.15,6.15,0,0,0,4.22,2.7c4.66.35,9.37.06,14,.22.87,0,1.7,1,2.55,1.49-.87.5-1.72,1.4-2.6,1.42-4.52.14-9-.12-13.55.13-1.61.09-4,.86-4.51,2s1,3.06,1.64,4.63c.47,1.14,1,2.24,1.54,3.36l-1.21.78c-.86-.63-1.65-1.58-2.62-1.83-1.3-.34-3.11-.67-4,0s-1.28,2.44-1.6,3.8a24.52,24.52,0,0,0-.32,4c-2.64-2.36-4.35-5.07-6.29-5.24-1.43-.13-3.15,3.06-5.1,5.15a15.18,15.18,0,0,1-1.18-2.66c-.47-1.77-.71-3.6-1-5.4-1.82.41-3.66.76-5.46,1.25a4.29,4.29,0,0,1-2.65.5c.45-1.16.9-2.32,1.36-3.48.68-1.69,1.37-3.37,2.06-5.06-1.61-.61-3.19-1.69-4.82-1.76-5.31-.22-10.62-.08-15.94-.08-.14-.53-.29-1-.43-1.58m39.72.18c1.75-2.35,3.44-3.63,3.45-4.93,0-1.1-1.88-3-3-3.08s-3.19,1.65-3.3,2.75c-.13,1.28,1.4,2.74,2.87,5.26M659.76,304c2.31,1.31,3.74,2.74,5.14,2.7,1,0,2.9-2.43,2.65-3.08a5.33,5.33,0,0,0-3.49-3c-1-.13-2.26,1.69-4.3,3.38m4-7.94c-2.21-1.4-3.56-2.89-5-2.92-1,0-3,2.3-2.82,2.92a5.41,5.41,0,0,0,3.35,3.22c1,.18,2.34-1.62,4.42-3.22m9.7,9.3c1.56-2.15,3.33-3.63,3.06-4.44a5,5,0,0,0-3.45-2.93c-.9-.12-3,1.89-2.91,2.83.09,1.3,1.71,2.49,3.3,4.54m-9-12.24c1.47-1.92,3.29-3.35,3-4.19a5.11,5.11,0,0,0-3.39-3c-.79-.14-2.74,1.88-2.79,3s1.61,2.3,3.13,4.2"
                />
                <path
                    class="cls-51"
                    d="M637.52,279.11c4.61,3.36,8.2,5.81,11.58,8.53.86.69,1.65,2.41,1.36,3.32s-2,1.74-3.06,1.79c-4.5.2-9,.08-14.35.08l4.47-13.72"
                />
                <path
                    class="cls-51"
                    d="M673.9,263.32c-1.51,4.75-2.64,8.76-4.1,12.63-.44,1.18-1.75,2.73-2.77,2.81s-2.57-1.36-3-2.48c-1.52-4-2.65-8.15-4.16-13Z"
                />
                <path
                    class="cls-51"
                    d="M696.24,279.16c1.56,4.79,2.91,8.9,4.46,13.67-5.53,0-10,.12-14.51-.09a4.3,4.3,0,0,1-3-2c-.33-.61.4-2.31,1.15-2.9,3.62-2.83,7.41-5.45,11.88-8.68"
                />
                <path
                    class="cls-51"
                    d="M680.62,265.16l11.58,8.39c-4.49,3.28-8,6-11.73,8.45-.89.58-2.84.7-3.53.12a4,4,0,0,1-.82-3.54c1.24-4.27,2.8-8.45,4.5-13.42"
                />
                <path
                    class="cls-51"
                    d="M641.36,319c4.57-3.27,8.15-6,11.89-8.41.93-.61,3.11-.94,3.46-.47a5.17,5.17,0,0,1,.82,4c-1.15,4.15-2.68,8.2-4.34,13.08L641.36,319"
                />
                <path
                    class="cls-51"
                    d="M692.26,319l-11.75,8.3c-1.58-4.84-3.09-9-4.21-13.18-.32-1.19,0-3.22.84-3.87s2.83-.18,3.85.5c3.59,2.38,7,5.07,11.27,8.25"
                />
                <path
                    class="cls-51"
                    d="M674,329.37H659.85c1.53-4.89,2.72-9.15,4.26-13.27.44-1.18,1.91-2,2.91-2.93.93,1.05,2.25,2,2.72,3.18,1.51,4,2.72,8.16,4.29,13"
                />
                <path
                    class="cls-51"
                    d="M653.05,265.23c1.66,4.82,3.18,8.83,4.34,12.93.35,1.24-.3,2.76-.49,4.15-1.37-.19-3,0-4-.65-3.6-2.3-7-4.92-11.39-8.06l11.59-8.37"
                />
                <path
                    class="cls-51"
                    d="M700.78,299.85c-1.66,4.79-3,8.78-4.6,13.32-4.26-3-8.06-5.53-11.66-8.33a3.84,3.84,0,0,1-1.25-3.32c.31-.84,2-1.55,3.16-1.6,4.32-.18,8.64-.07,14.35-.07"
                />
                <path
                    class="cls-51"
                    d="M633,299.85c5.55,0,10-.12,14.53.08,1.07.05,2.76,1,3,1.79A4,4,0,0,1,649,305c-3.52,2.76-7.25,5.27-11.38,8.21-1.52-4.34-2.92-8.36-4.66-13.35"
                />
                <path
                    class="cls-2"
                    d="M51.75,706.81c-1.38-2.2-3-3.69-2.75-4.67.37-1.35,2.16-2.31,3.34-3.44,1.06,1.14,3,2.35,2.95,3.39-.1,1.37-1.84,2.6-3.54,4.72"
                />
                <path
                    class="cls-2"
                    d="M38.7,699.58c2-1.73,3.24-3.64,4.21-3.5a5.59,5.59,0,0,1,3.57,3.09c.27.61-1.68,3.08-2.66,3.1-1.4,0-2.84-1.4-5.12-2.69"
                />
                <path
                    class="cls-2"
                    d="M56.79,687.37c-2.25,1.36-3.64,2.83-5,2.83-1,0-3-2.36-2.75-3a5.4,5.4,0,0,1,3.42-3.13c1-.16,2.3,1.65,4.36,3.29"
                />
                <path
                    class="cls-2"
                    d="M43.28,694.59c-1.45-2.08-3.09-3.43-3.09-4.78,0-1.07,2-2.14,3.12-3.22,1.12,1.23,2.86,2.32,3.16,3.73.21.93-1.64,2.31-3.19,4.27"
                />
                <path
                    class="cls-2"
                    d="M62.15,694.66c-2.14,1.4-3.42,2.9-4.56,2.8s-2.29-1.72-3.43-2.68c1.17-1.11,2.2-2.84,3.54-3.13,1-.21,2.35,1.5,4.45,3"
                />
                <path
                    class="cls-2"
                    d="M664.41,706.84c-1.5-2.26-3.12-3.64-3.1-5,0-1.07,2.05-2.11,3.19-3.16,1.09,1.23,2.79,2.35,3,3.73.18,1-1.57,2.34-3.14,4.43"
                />
                <path
                    class="cls-2"
                    d="M668.61,699.39c2.12-1.66,3.51-3.54,4.49-3.34,1.37.28,2.43,2.09,3.62,3.24-1.07,1.07-2.12,3-3.21,3-1.35,0-2.72-1.51-4.9-2.9"
                />
                <path
                    class="cls-2"
                    d="M664.86,691.72c-1.7-2-3.41-3.2-3.55-4.54-.11-1,2-3.23,2.82-3.08a5.17,5.17,0,0,1,3.43,3.08c.28.91-1.36,2.41-2.7,4.54"
                />
                <path
                    class="cls-2"
                    d="M677.79,689.87c-1.91,1.5-3.14,3.21-4.5,3.32-1,.07-3.29-2.14-3.11-2.9a5.35,5.35,0,0,1,3.22-3.48c.93-.24,2.41,1.6,4.39,3.06"
                />
                <path
                    class="cls-2"
                    d="M663.71,695c-2.22,1.22-3.6,2.61-4.76,2.45s-2.12-1.88-3.17-2.91c1.24-1,2.38-2.71,3.72-2.88,1-.13,2.24,1.69,4.21,3.34"
                />
                <path
                    class="cls-2"
                    d="M62.13,296.13c-2.17,1.53-3.48,3.16-4.79,3.15-1.09,0-2.17-1.93-3.25-3,1.21-1.12,2.27-2.82,3.67-3.15.91-.23,2.31,1.51,4.37,3"
                />
                <path
                    class="cls-2"
                    d="M52.21,308.2c-1.57-2-3.38-3.28-3.19-4.19.29-1.39,2-2.49,3-3.71,1.14,1,3.18,2,3.19,3.05,0,1.33-1.58,2.68-3,4.85"
                />
                <path
                    class="cls-2"
                    d="M38.7,291.62c2.08-1.54,3.46-3.33,4.47-3.14,1.33.26,2.36,2.06,3.53,3.2-1,1.05-2.12,3-3.1,2.95-1.41-.07-2.75-1.59-4.9-3"
                />
                <path
                    class="cls-2"
                    d="M43.21,305.16c-1.45-2-3.08-3.2-3-4.34s2.13-3,3-2.84a5.06,5.06,0,0,1,3.3,3.14c.22.82-1.7,2.2-3.25,4"
                />
                <path
                    class="cls-2"
                    d="M52.27,293.11c-1.56-1.86-3.44-3.21-3.23-4.06a5,5,0,0,1,3.25-3.15c.8-.18,2.82,1.77,2.93,2.88s-1.52,2.37-2.95,4.33"
                />
                <path
                    class="cls-2"
                    d="M673.06,296.44c-1.47-2.52-3-4-2.87-5.26.11-1.1,2.19-2.82,3.3-2.75s3,2,3,3.08c0,1.3-1.7,2.58-3.45,4.93"
                />
                <path
                    class="cls-2"
                    d="M659.75,304c2-1.69,3.31-3.51,4.31-3.38a5.33,5.33,0,0,1,3.49,3c.25.65-1.68,3.06-2.65,3.08-1.4,0-2.83-1.39-5.15-2.7"
                />
                <path
                    class="cls-2"
                    d="M663.74,296.05c-2.07,1.6-3.42,3.4-4.41,3.22a5.41,5.41,0,0,1-3.35-3.22c-.23-.62,1.83-2.95,2.82-2.92,1.39,0,2.74,1.52,4.94,2.92"
                />
                <path
                    class="cls-2"
                    d="M673.45,305.35c-1.59-2.05-3.21-3.24-3.3-4.54-.07-.94,2-2.95,2.91-2.83a5,5,0,0,1,3.45,2.93c.27.81-1.5,2.29-3.06,4.44"
                />
                <path
                    class="cls-2"
                    d="M664.49,293.11c-1.52-1.9-3.19-3.09-3.13-4.2s2-3.14,2.79-3a5.11,5.11,0,0,1,3.39,3c.24.84-1.58,2.27-3,4.19"
                />
                <path
                    class="cls-2"
                    d="M214.85,1018.09c-1-2.68-2.95-5.34-3-8-.5-32.35-1.09-64.7-.74-97,.08-7.41,3.77-14.75,5.52-22.2.43-1.82-.43-3.91-.33-5.85a9.89,9.89,0,0,1,1.22-4.26c1.25-2.18,2.84-4.17,4.28-6.23l-2,.11c-1.69-2.28-4.11-4.33-4.92-6.89-1.34-4.24,1.22-7.5,4.84-9.45a29.73,29.73,0,0,1,8.43-3c3.77-.72,7.08-1.51,8.75-5.58.37-.89,2.39-1.53,3.66-1.55,54.82-.72,109.63-1.61,164.45-1.86,23.44-.11,46.9,1.11,70.35,1.89,1.49,0,3,1.4,4.39,2.27,2.4,1.48,4.6,3.36,7.13,4.53,2.86,1.3,6.11,1.73,9,3,4,1.78,6.87,5,5.67,9.48-.72,2.68-3.53,4.79-5.39,7.16l-2-.13a70.87,70.87,0,0,1,4.74,6.63,8.68,8.68,0,0,1,.69,4.22c0,1.41-1,3.12-.54,4.2,8,17.14,5.79,35.42,5.93,53.38.16,21.47,0,42.94-.36,64.4-.07,3.62-1.86,7.22-2.85,10.82H466.49c-5.25-6.91-1.62-15.18-2.92-21.22-14.75-1.18-28.9-2-43-3.56-10.9-1.23-21.63-4.45-32.53-5-16.7-.89-33.48-.45-50.23-.25-7.31.09-14.74.31-21.9,1.67-21,4-41.95,7.59-63.81,5.86,0,5,.35,9.87-.13,14.66-.27,2.7-1.91,5.26-2.93,7.88Zm220-24.74c-1.28-.8-2.5-1.72-3.84-2.39-4.7-2.36-8.57-5.44-10.25-10.33,4.21-.84,8.07-1.49,11.86-2.43,2.84-.69,5.56-2.41,8.38-2.54,7.53-.32,15.1-.26,22.62.13,2.49.13,6.41,1.12,7.05,2.74,1.59,4,5,4.82,8,5.9a9.73,9.73,0,0,0,7.3-.4c9-5.32,13.87-13.55,15.22-25-5.42-1.5-10.72-3.57-16.19-4.31-7.27-1-14.68-1.05-22-1.28-28.61-.92-57.23-2-85.85-2.51-16-.3-32.09.23-48.13.59q-46.23,1.05-92.45,2.34c-7.74.22-15.2,1.7-21.62,6.56,1.58,9.72,5.7,17.77,14.15,23.25,3,2,5.81,2.77,9.27.65,1.48-.91,3.83-.39,5.78-.51.3,4.63,2.76,8.8,7,9.1,9.66.69,19.41.07,29.13,0l32.42-3.75L298.23,985l-.05-2.51c2.94-.94,5.84-2.43,8.85-2.71,5-.45,10-.12,15.07-.12q43.25,0,86.48,0c3.87,0,7.11.85,9.08,5.58l-12.31,3.27c0,.21-.05.42-.08.63q14.84,2.05,29.7,4.07c9.33.18,18.66.62,28,.42,3.72-.08,6.46-2.58,7.34-6.61-5.13,5.37-11.66,6-18.47,6-5.66,0-11.33.23-17,.37M423.87,873.3a63.51,63.51,0,0,0-2.76,6.32c-1.78,5.9-3.28,11.9-5.11,17.79s-5,8.05-11.11,8.09c-8.33,0-16.67,0-25,0q-34.15,0-68.29,0c-6.53,0-9.37-2-11.51-8.26-.76-2.2-1.14-4.53-1.83-6.76-1.74-5.63-3.56-11.24-5.47-17.24H355c-12.23-7.57-12.28-17.3-.43-25.35-2.27,0-3.87,0-5.47,0-18.11.35-36.21.56-54.31,1.12-13.88.43-27.76,1.06-41.61,2.06-7.66.55-14.11,4-19.51,10.84,2.73,0,4.54,0,6.34,0,10.87.36,21.88-.22,32.56,1.38,14.15,2.13,15.22,3.59,19,16.89,2.26,8,0,10.73-8.44,11-7.37.2-14.76,0-22.13.35a20.45,20.45,0,0,0-7.94,2.17c-7.31,3.69-14.43,4.77-21.9.38-2-1.16-4.54-1.32-8.41-2.37.68,7.58.7,13.93,2,20,1,4.91,4.56,7.78,10.23,7.82,21.45.12,42.9.74,64.35.73,42.58,0,85.16-.32,127.75-.51,18.11-.08,36.22-.28,54.33-.24,4.85,0,8.62-1.83,9.56-6.39,1.39-6.7,1.72-13.63,2.65-21.84-4.33,1.49-7.1,2.1-9.55,3.34-5.94,3-12.12,3.67-17.74.27-5.37-3.25-10.86-3.64-16.75-3.51s-11.75,0-17.61-.27c-6.32-.34-8-2.41-7.73-8.41.55-10.2,5.52-17.22,15.5-18.47,12.89-1.61,26-1.61,39-2.3,1.18-.07,2.36-.17,4-.28-7.22-8.6-16.44-11.1-26.38-11.46q-34.67-1.26-69.34-2.13c-8.1-.21-16.21,0-24.32,0,5,3,8.07,7,8,12.73s-3.33,9.5-8.13,12.55ZM213.53,956.62c8.36-1.63,15.63-3,22.86-4.51,1.71-.36,4-.87,4.79-2.1,3.37-5.44,8.33-5.92,13.94-5.61,4.85.27,9.73.06,14.59.06q97.13,0,194.26.09c2.62,0,6.45.53,7.63,2.25,3.6,5.22,8.47,5.62,13.94,6,3.4.22,6.76,1.5,10.08,2.53a60,60,0,0,1,6.29,2.82c.59-10.92.91-20.94,1.72-30.93,1-12.65-1.88-24.52-5.92-36.32-.82-2.41-.12-5.33-.12-8l-.64.56c-1.58-3.44-3.17-6.88-4.84-10.49,3.77-2,8.53-1.77,7.7-7.27-.74-4.93-4.51-6.32-8.34-7.55s-7.71-2.05-12.46-3.27c2.31,2.66,4.08,4.44,5.54,6.43,10.28,14.05,10.85,30.29,9.5,46.57-.9,10.76-5,13.53-16,13.58q-24.4.12-48.81.11-96.12,0-192.25-.13c-10.2,0-14.9-4.72-15.16-15a139.26,139.26,0,0,1,.12-16.09c.89-9.67,2-19.59,8.41-27.37,4.11-5,9.57-8.85,15.46-14.16-3.46,1.38-6.06,2.2-8.46,3.42-2.22,1.13-4.11,2.91-6.34,4-4.27,2.09-9.22,3.19-12.9,6-4,3-2.54,7.2,1.9,9.2,1.29.58,2.86,3,2.58,4.14-.69,2.85-2.38,5.46-3.62,8.07,0,1.72.38,3.66-.07,5.38-1.9,7.25-5.47,14.37-5.81,21.66-.73,15.51.17,31.1.39,46m144.76-75.34v0c-12.06,0-24.12,0-36.17,0a30.55,30.55,0,0,0-6.92,1,4.15,4.15,0,0,0-2.53,2c-3.3,7.86.32,13.49,8.77,13.85,1,0,2,.06,3,.06q34.17,0,68.33-.07a30.29,30.29,0,0,0,7.42-.93,5.35,5.35,0,0,0,3.25-2.56c3.44-7.76,0-13.23-8.48-13.33-12.23-.15-24.45,0-36.68,0m144.37,82.41c-1.09,2.58-2.64,7.52-5.15,11.92-5.6,9.8-13.61,12.91-22.23,9.67-2.9,3.2-5.69,6.21-8.36,9.33a5.15,5.15,0,0,0-1.28,2.92,109.42,109.42,0,0,0,.11,14c.17,1.6,2.19,4.22,3.51,4.31,9.15.64,18.35.86,27.53.93,3.32,0,5.84-1.67,5.85-5.46,0-16.62,0-33.25,0-47.65m-289,.39c0,15.36,0,31.25,0,47.14,0,4.56,2.81,5.74,6.52,5.67,8.7-.17,17.39-.55,26.09-.78,2.68-.07,4-1.2,3.94-4-.07-5,0-10-.06-15.08a4.53,4.53,0,0,0-1.06-2.62c-2.66-3.09-5.45-6.08-8.58-9.54-5.74,5.58-10.9,1.59-16.09-2.56-6.15-4.93-8.9-11.83-10.74-18.26m29.6-12.23c76.74-3.36,152.94-3.23,229.78-.06-2.22-4.49-4.89-6.06-8.83-6q-106.1.06-212.17,0c-4,0-7.1,1.26-8.78,6.1m31.18-87.54c-12.47-.34-24.94-.89-37.41-.84a9.76,9.76,0,0,0-7.09,3.76c-4.38,6.87-5.48,14.82-6,22.47,4.33,1.64,8.08,3.79,12.06,4.38s9,.91,12.48-.83c5.87-2.94,11.71-3.31,17.89-3.16,1.4,0,2.8-.11,4.83-.2-11.11-7.25-11.89-19.72,3.27-25.58M493,889.62c-1.75-6.55-3.43-12.93-5.15-19.31a8.81,8.81,0,0,0-8.88-6.85c-12.53,0-25.06.56-37.59.89-.07.54-.15,1.08-.22,1.61,6,.91,10.59,3.6,11.92,9.8,1.39,6.45-2.79,10.29-8.25,14.34,3.05,0,4.86-.05,6.66,0,3.49.13,8-1,10.29.73,10.76,8.1,20.44,2.19,31.22-1.23M323.09,899.74c-1.71-.15-2.35-.23-3-.27-8-.39-9.35-1.41-9.65-7.07-.55-10.35.06-11.29,8.76-12.49a67.75,67.75,0,0,1,9-.66c19-.06,37.9-.1,56.86,0a119.49,119.49,0,0,1,15,1c1.73.23,4,1.46,4.78,2.91,4.17,8-.23,15.67-9.05,16.3a7.3,7.3,0,0,0-1.28.33,27.76,27.76,0,0,0,9,.35c1.67-.29,4.24-1.79,4.44-3.07,1.15-7.12,1.7-14.35,2.46-21.6H305.8c.29,4.44.36,8.62.88,12.74,1.64,13,1.88,13.08,16.41,11.5m89.37-24.32c-.44,3.44-.87,6.56-1.22,9.69s-.57,6.33-1,9.48c-.7,5.82-2.43,7.65-8.25,7.67q-44,.13-88,0c-5.8,0-8.09-2.46-8.54-8.18-.49-6.14-1-12.27-1.52-18.6H295.9l5.45,19.58c1.89,6.79,4.77,9.08,11.78,9.12,10.9.06,21.79,0,32.69,0h56.83c5,0,9.57-1,11.26-6.41,2.29-7.29,4.18-14.71,6.33-22.36Zm23.39,103.17c-2,1-3.8,2.26-5.82,2.84s-4.1.41-6.62.61c3.69,5.52,8.42,8.46,14.35,8.78,6.67.37,13.38.23,20.06,0,2.25-.08,5-.55,6.57-1.95,2.4-2.16,4-5.25,5.88-8l-9.69-5.56c.46,5.87-1.56,7.55-5.45,7.53s-5.28-2.12-5-7.45c-2.79,3.2-4.19,6.19-6.4,7-3.23,1.21-7.06.9-7.9-3.85m-27.51,2.58H308.17a504.21,504.21,0,0,0,100.17,0M358.1,869.94c4.67.07,9.43-4.64,9.45-9.36s-4.69-9.42-9.39-9.4-9.36,4.61-9.37,9.34,4.55,9.34,9.31,9.42m77.66,19.22c-1.83-3.37-4.76-6.6-5.16-10.11s1.76-7.22,2.8-10.86a24.22,24.22,0,0,0-5.78,8.17c-4.56,11.31-1.73,13.62,8.14,12.8m-153-20.64c1,3.35,3.36,7.14,2.94,10.59s-3.52,6.88-5.32,10.06a21.93,21.93,0,0,0,5.19-.1c1.64-.36,3.79-1.19,4.5-2.47,2.33-4.23-3.34-16.57-7.31-18.08M383.35,986.1c10.34.34,20.78,1.83,30.75-1.83L414,983l-30.63,3.14m-81.51-3.16-.12,1.33c9.86,3.38,20.12,2.37,30.33,1.77l-30.21-3.1M274,883.82c2-2.79,3.94-4.29,4-5.87.05-1.23-2.14-3.55-3.4-3.59s-3.83,1.89-3.94,3.14c-.14,1.55,1.62,3.28,3.34,6.32m162-6c2.73,1.93,4.29,3.85,5.89,3.88,1.2,0,3.58-2.56,3.41-3.66a5.7,5.7,0,0,0-3.83-3.68c-1.22-.23-2.86,1.7-5.47,3.46M370.43,985.62v-.4H346.12v.4Z"
                />
                <path
                    class="cls-51"
                    d="M249.07,1018.09c1-2.62,2.66-5.18,2.93-7.88.48-4.79.13-9.66.13-14.66,21.86,1.73,42.82-1.88,63.81-5.86,7.16-1.36,14.59-1.58,21.9-1.67,16.75-.2,33.53-.64,50.23.26,10.9.58,21.63,3.8,32.53,5,14.07,1.59,28.22,2.38,43,3.56,1.3,6-2.33,14.31,2.92,21.22Z"
                />
                <g class="cls-130">
                    <rect
                        class="cls-131"
                        x="222.66"
                        y="847.84"
                        width="270.83"
                        height="72.42"
                    />
                </g>
                <g class="cls-132">
                    <rect
                        class="cls-133"
                        x="212.41"
                        y="848.76"
                        width="292.26"
                        height="109.37"
                    />
                </g>
                <path
                    class="cls-12"
                    d="M244.12,983.78c-2,.12-4.3-.4-5.78.51-3.46,2.12-6.24,1.32-9.27-.65-8.45-5.48-12.57-13.53-14.14-23.25,6.41-4.86,13.87-6.34,21.61-6.56q46.22-1.27,92.45-2.34c16-.36,32.09-.89,48.13-.59,28.62.53,57.24,1.59,85.85,2.51,7.36.23,14.77.3,22,1.28,5.47.74,10.77,2.81,16.19,4.31-1.35,11.48-6.16,19.71-15.22,25a9.73,9.73,0,0,1-7.3.4c-3-1.08-6.45-1.87-8-5.9-.64-1.62-4.56-2.61-7.05-2.74-7.52-.39-15.09-.45-22.62-.13-2.82.13-5.54,1.85-8.38,2.54-3.79.94-7.65,1.59-11.86,2.43,1.68,4.89,5.55,8,10.25,10.33,1.34.67,2.57,1.59,3.84,2.39l.11-.1-29.66-4.1c0-.21.06-.42.08-.63l12.31-3.27c-2-4.73-5.21-5.58-9.08-5.58q-43.23,0-86.48,0c-5,0-10.09-.33-15.07.12-3,.28-5.91,1.77-8.85,2.71l.05,2.51,14.44,4.07-32.42,3.75.06.13c6.25-2.73,12.8-5.13,14.62-11.55-5.09-1.85-9.73-3.55-14.39-5.19a9.48,9.48,0,0,0-2.94-.48c-8.83,0-17.66-.23-26.48,0-5.14.16-7.15,2.82-7.13,8.1Zm37.47-25.72c0,.31,0,.63,0,.94H434.82c0-.31,0-.63,0-.94Zm189.1,3.86c-.25-.7-.49-1.39-.74-2.08-10.33,0-20.65-.07-31,.1-.91,0-2.14,1.41-2.53,2.42-.18.47,1.17,1.87,2.08,2.32a9.35,9.35,0,0,0,3.89.81c6.7,0,13.43.31,20.1-.22,2.8-.22,5.45-2.18,8.17-3.35m-190.39,0c-4.07-2.72-28.64-3.38-34.14-1.13,3.43,6.12,29.45,7.2,34.14,1.13"
                />
                <path
                    class="cls-51"
                    d="M358.29,881.28c12.23,0,24.45-.11,36.68,0,8.47.1,11.92,5.57,8.48,13.33a5.38,5.38,0,0,1-3.25,2.56,30.29,30.29,0,0,1-7.42.93q-34.15.11-68.33.07c-1,0-2,0-3-.06-8.45-.36-12.07-6-8.77-13.85a4.15,4.15,0,0,1,2.53-2,30.54,30.54,0,0,1,6.91-1c12.06-.09,24.12,0,36.18,0Z"
                />
                <path
                    class="cls-2"
                    d="M502.66,963.69c0,14.4,0,31,0,47.65,0,3.79-2.53,5.49-5.85,5.46-9.18-.07-18.37-.29-27.53-.93-1.32-.09-3.34-2.71-3.5-4.31a107.63,107.63,0,0,1-.12-14,5.15,5.15,0,0,1,1.28-2.92c2.67-3.12,5.47-6.13,8.36-9.33,8.62,3.24,16.63.14,22.23-9.67,2.51-4.4,4.06-9.34,5.15-11.92"
                />
                <path
                    class="cls-2"
                    d="M213.67,964.08c1.84,6.43,4.59,13.33,10.74,18.26,5.19,4.15,10.35,8.14,16.09,2.56,3.13,3.46,5.92,6.45,8.58,9.54a4.53,4.53,0,0,1,1.06,2.62c.1,5,0,10.05.06,15.08,0,2.77-1.26,3.9-3.94,4-8.7.23-17.39.61-26.09.78-3.71.07-6.54-1.11-6.52-5.67.06-15.89,0-31.78,0-47.14"
                />
                <g class="cls-134">
                    <rect
                        class="cls-135"
                        x="243.27"
                        y="945.74"
                        width="229.78"
                        height="6.11"
                    />
                </g>
                <g class="cls-27">
                    <g class="cls-136">
                        <path
                            class="cls-63"
                            d="M274.45,864.31c-15.16,5.86-14.38,18.33-3.27,25.58-2,.09-3.43.23-4.83.2-6.18-.15-12,.22-17.89,3.16-3.47,1.74-8.39,1.44-12.48.83s-7.73-2.74-12.06-4.38c.55-7.65,1.65-15.6,6-22.47a9.76,9.76,0,0,1,7.09-3.76c12.47-.05,24.94.5,37.41.84m-39.59,15.57a7.9,7.9,0,0,0,8,7.89,8.55,8.55,0,0,0,8.16-8.47c-.2-4.1-4.23-8-8.22-8a8.14,8.14,0,0,0-8,8.55"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-137">
                        <path
                            class="cls-63"
                            d="M493,889.62c-10.78,3.42-20.46,9.33-31.22,1.23-2.31-1.74-6.8-.6-10.29-.73-1.8-.07-3.61,0-6.66,0,5.46-4.06,9.64-7.89,8.25-14.34-1.33-6.2-5.89-8.89-11.92-9.8.07-.54.15-1.07.22-1.61,12.53-.34,25.06-.89,37.59-.89a8.81,8.81,0,0,1,8.88,6.85c1.72,6.38,3.41,12.76,5.15,19.31m-19.67-1.85a8.62,8.62,0,0,0,8.2-7.94c.12-4.26-4-8.51-8.18-8.5a8.14,8.14,0,0,0-8,8,7.93,7.93,0,0,0,8,8.43"
                        />
                    </g>
                </g>
                <path
                    class="cls-12"
                    d="M323.09,899.74c-14.52,1.58-14.77,1.45-16.41-11.5-.52-4.12-.59-8.3-.88-12.74H410.44c-.76,7.25-1.31,14.47-2.46,21.6-.2,1.28-2.77,2.78-4.44,3.07a27.76,27.76,0,0,1-9-.35,7.3,7.3,0,0,1,1.28-.33c8.82-.63,13.22-8.31,9.05-16.3-.76-1.45-3.05-2.68-4.78-2.91a119.49,119.49,0,0,0-15-1c-19-.1-37.91-.06-56.86,0a67.75,67.75,0,0,0-9,.66c-8.7,1.2-9.31,2.14-8.76,12.49.3,5.66,1.7,6.68,9.65,7.07.64,0,1.28.12,3,.27"
                />
                <path
                    class="cls-12"
                    d="M412.46,875.42h7.78c-2.15,7.65-4,15.07-6.33,22.36-1.69,5.4-6.29,6.41-11.26,6.41H345.82c-10.9,0-21.79,0-32.69,0-7,0-9.89-2.33-11.78-9.12l-5.45-19.58H304c.52,6.33,1,12.46,1.52,18.6.45,5.72,2.74,8.16,8.54,8.18q44,.12,88,0c5.82,0,7.55-1.85,8.25-7.67.39-3.15.6-6.32,1-9.48s.78-6.25,1.22-9.69"
                />
                <path
                    class="cls-12"
                    d="M435.85,978.59c.84,4.75,4.67,5.06,7.9,3.85,2.21-.83,3.61-3.82,6.4-7-.3,5.33,1.09,7.42,5,7.45s5.91-1.66,5.45-7.53l9.69,5.56c-1.91,2.7-3.48,5.79-5.88,8-1.55,1.39-4.32,1.86-6.57,1.94-6.68.25-13.39.39-20.06,0-5.93-.32-10.66-3.26-14.35-8.78,2.52-.2,4.67,0,6.62-.61s3.84-1.84,5.82-2.84"
                />
                <g class="cls-138">
                    <rect
                        class="cls-139"
                        x="308.17"
                        y="981.17"
                        width="100.17"
                        height="3.32"
                    />
                </g>
                <path
                    class="cls-51"
                    d="M358.1,869.94c-4.76-.08-9.32-4.69-9.31-9.42s4.61-9.31,9.37-9.34,9.41,4.69,9.39,9.4-4.78,9.43-9.45,9.36"
                />
                <g class="cls-27">
                    <g class="cls-140">
                        <path
                            class="cls-63"
                            d="M435.76,889.16c-9.87.82-12.7-1.49-8.14-12.8a24.22,24.22,0,0,1,5.78-8.17c-1,3.64-3.19,7.39-2.8,10.86s3.33,6.74,5.16,10.11"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-141">
                        <path
                            class="cls-63"
                            d="M282.71,868.52c4,1.52,9.64,13.85,7.31,18.08-.71,1.28-2.86,2.11-4.5,2.47a21.41,21.41,0,0,1-5.19.1c1.8-3.18,4.88-6.46,5.32-10.06s-1.91-7.24-2.94-10.59"
                        />
                    </g>
                </g>
                <g class="cls-142">
                    <rect
                        class="cls-143"
                        x="383.35"
                        y="982.96"
                        width="30.75"
                        height="4.97"
                    />
                </g>
                <g class="cls-144">
                    <rect
                        class="cls-145"
                        x="301.72"
                        y="982.94"
                        width="30.33"
                        height="4.72"
                    />
                </g>
                <path
                    class="cls-51"
                    d="M280.25,992.85c-9.72.1-19.47.72-29.13,0-4.24-.3-6.7-4.47-7-9.1l-.13.12c3.91,5.34,8.81,9,15.75,9l20.57.1Z"
                />
                <path
                    class="cls-51"
                    d="M274,883.82c-1.72-3-3.48-4.77-3.34-6.32.11-1.25,2.57-3.19,3.94-3.14s3.45,2.36,3.4,3.59c-.06,1.58-2,3.08-4,5.87"
                />
                <path
                    class="cls-51"
                    d="M436.06,877.81c2.61-1.76,4.25-3.69,5.47-3.46a5.69,5.69,0,0,1,3.83,3.69c.18,1.09-2.21,3.68-3.41,3.65-1.6,0-3.16-2-5.89-3.88"
                />
                <path
                    class="cls-51"
                    d="M434.82,993.35c5.67-.14,11.34-.4,17-.37,6.82,0,13.34-.58,18.48-6-.89,4-3.63,6.53-7.35,6.61-9.32.2-18.65-.24-28-.4l-.13.11"
                />
                <path class="cls-51" d="M370.43,985.62H346.12v-.4h24.31v.4" />
                <path
                    class="cls-2"
                    d="M280.31,993l-20.57-.1c-6.94,0-11.84-3.64-15.75-9,0-5.28,2-7.94,7.12-8.1,8.83-.27,17.66-.08,26.49,0a9.48,9.48,0,0,1,2.94.48c4.66,1.64,9.3,3.34,14.39,5.18-1.82,6.43-8.37,8.83-14.62,11.56m.19-13.5c-4.06,5.32-7.87,5-11.41-1.41-.25-.46-1.11-1.06-1.41-.94-.6.25-1.4.93-1.45,1.49-.37,4.8-4,4.66-7,4-1.87-.46-3.26-2.9-4.87-4.46-1-1-2.8-.89-4.46-.29-5,1.81-5.85,4.21-1.93,7.84,2.63,2.43,6.39,4.57,9.86,5,6.76.79,13.68.44,20.53.22,6.08-.2,12-4.36,13.21-8.45l-11.11-2.93"
                />
                <path
                    class="cls-2"
                    d="M281.59,958.06H434.81c0,.31,0,.63,0,.94H281.61c0-.31,0-.63,0-.94"
                />
                <path
                    class="cls-2"
                    d="M470.69,961.92c-2.72,1.17-5.38,3.13-8.17,3.35-6.67.52-13.4.27-20.1.22a9.35,9.35,0,0,1-3.89-.81c-.91-.45-2.26-1.85-2.08-2.32.39-1,1.62-2.4,2.53-2.42,10.32-.17,20.64-.11,31-.11.24.7.49,1.39.74,2.09m-31.94-.44.09,1.94c9.14.18,18.29,1,27.4-.65l0-1.29Z"
                />
                <path
                    class="cls-2"
                    d="M280.3,961.88c-4.69,6.07-30.71,5-34.14-1.13,5.5-2.25,30.07-1.59,34.14,1.13m-30.56-.32-.18,1.37h28.07c0-.46,0-.92,0-1.37Z"
                />
                <path
                    class="cls-2"
                    d="M234.86,879.88a8.14,8.14,0,0,1,8-8.55c4,0,8,3.87,8.22,8a8.55,8.55,0,0,1-8.16,8.47,7.9,7.9,0,0,1-8-7.89m8.12-6.71c-4.17.41-6.22,2.89-6.6,6.53-.33,3.15,3.35,6.69,6.47,6.29,3.63-.46,6.26-2.4,6.22-6.49s-2.56-5.85-6.09-6.33"
                />
                <path
                    class="cls-2"
                    d="M473.36,887.77a7.93,7.93,0,0,1-8-8.43,8.12,8.12,0,0,1,8-8c4.21,0,8.31,4.23,8.19,8.49a8.62,8.62,0,0,1-8.2,7.94m.28-14.59c-4.06.29-6.24,2.59-6.7,6.29-.4,3.2,3,6.8,6.18,6.53,3.66-.31,6.33-2.19,6.45-6.26s-2.3-6-5.93-6.56"
                />
                <path
                    class="cls-12"
                    d="M280.5,979.48l11.11,2.93c-1.25,4.09-7.13,8.25-13.21,8.45-6.85.22-13.77.57-20.53-.22-3.47-.4-7.23-2.54-9.86-5-3.92-3.63-3.07-6,1.93-7.84,1.66-.6,3.49-.72,4.46.29,1.61,1.56,3,4,4.87,4.46,2.92.7,6.59.84,7-4,0-.56.85-1.24,1.45-1.49.3-.12,1.16.48,1.41.94,3.54,6.42,7.35,6.73,11.41,1.41"
                />
                <path
                    class="cls-63"
                    d="M438.75,961.48h27.47l0,1.29c-9.11,1.66-18.26.83-27.4.65Z"
                />
                <path
                    class="cls-63"
                    d="M249.74,961.56h27.9c0,.45,0,.91,0,1.37H249.56l.18-1.37"
                />
                <g class="cls-27">
                    <g class="cls-146">
                        <path
                            class="cls-147"
                            d="M243,873.17c3.53.48,6.05,2.27,6.09,6.33s-2.59,6-6.22,6.49c-3.12.4-6.8-3.14-6.47-6.29.38-3.64,2.43-6.12,6.6-6.53"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-148">
                        <path
                            class="cls-147"
                            d="M473.64,873.18c3.63.6,6.05,2.51,5.93,6.56s-2.79,6-6.45,6.26c-3.19.27-6.58-3.33-6.18-6.53.46-3.7,2.64-6,6.7-6.29"
                        />
                    </g>
                </g>
                <path
                    class="cls-2"
                    d="M373.42,894.88l2.78-4.57-43.15-3.7a243,243,0,0,1,36.05.32,12.2,12.2,0,0,0-9.31-3.4c-4.66.28-9.3.87-14,1.34-1.32.14-2.65.31-4.48.53,7-3.18,16.74-4.59,23.6-2.4a8.7,8.7,0,0,1,3.68,2.47c1.27,1.46,2.79,1.8,4.55,2.12a107.37,107.37,0,0,1,11.57,2.54c1.48.43,2.63,2,3.92,3l-3.36,3.77c-.92-3-2.89-4.37-6.06-4.72-2.57-.29-4.52.31-5.09,3.34Z"
                />
                <path
                    class="cls-2"
                    d="M342.67,894.06l10.5.81c0,.23,0,.47,0,.7h-14c1.81-2.37,1.34-3.92-2.05-5a15.1,15.1,0,0,0-4.92-.58c-2.17.07-3.59,1.37-4.11,4-.58-2.89.32-4.75,2.82-5a42.64,42.64,0,0,1,10.35.25c3.86.63,4.15,2.07,1.39,4.79"
                />
                <path
                    class="cls-2"
                    d="M372.26,896.9c-4.16-1.34-8.24-3.2-12.51-3.87s-8.7-.14-13.14-.6a35.69,35.69,0,0,1,4.08-.56c3.81-.11,7.63,0,11.44-.15,3.08-.09,5.82.5,7.93,3a16.64,16.64,0,0,0,2.33,1.9,2.88,2.88,0,0,1-.13.31"
                />
                <path
                    class="cls-2"
                    d="M497.7,0c1,21.18,2.24,42.36,3,63.56.41,11.71.1,23.46,0,35.19a34.11,34.11,0,0,1-7.33,20.85c-3.17,4.16-5.42,9.07-7.71,13.82-4.42,9.13-8.57,18.39-13,28-16.38-10.06-34.34-6-51.55-6.44-34.17-.91-68.36-.73-102.55-.72-17.75,0-35.52.22-53.25,1.14-7.06.36-14,2.85-22.08,4.61-3.69-8.1-7.9-17.65-12.38-27.07-2.13-4.47-4.22-9.15-7.31-12.93a32.07,32.07,0,0,1-7.56-20.73c-.11-23.81-.25-47.62.17-71.42.17-9.28,1.81-18.55,2.78-27.82H254.1L257,16c6.73.33,13.56.6,20.38,1,3.75.23,7.52,1.21,11.22,1,2.75-.18,5.39-2.61,8.09-2.65,22.1-.28,44.22-.9,66.29-.11s44.1-3.09,65.9,2.71c3.21.86,7-.69,10.57-.92,6.93-.44,13.86-.74,20.61-1.08.51-5.65,1-10.77,1.44-15.9ZM239.51,118.73c6.74,5.53,14.23,5,18.69-1.23,3.28-4.25,3.84-8.85,1.48-13.65-2.47-5-6.9-6.32-12.17-6.24-4.94.08-8.47,2.37-10.38,6.64-2.31,5.17-1.41,10.15,2.38,14.48m232,6.75c-.21,10.54,1,21-5.09,30.41l4.92,3.13c3.2-6.44,6.29-12.7,9.42-18.94,3.64-7.25,6.71-14.89,11.16-21.62,3.92-5.92,7.1-11.77,6.73-18.91-.84-16-2.14-32-2.86-48.08-.8-18,.74-16.24-16.22-18.92-23.54-3.71-47.45-6.51-71.24-6.9-50-.83-100.19-2.57-150.09,3.59-10.08,1.25-20.07,3.25-30.06,5.13-3.71.7-6.92,2.22-7.16,7-1,19.55-2.23,39.09-3.15,58.64-.32,6.94,2.47,12.85,6.69,18.41a77.26,77.26,0,0,1,7.6,13.35c4.34,9,8.39,18.08,12.71,27.45l5.34-3.38c-6.68-9.46-4.73-20.12-5.31-30.61-5.89-.14-9.85-3.31-11.09-8.55-1.57-6.58-2.08-13.41-3-20.14-.42-3,.69-4.81,4-5,16.5-.94,33-2.09,49.51-2.75,3.55-.14,6.38,2.33,6.17,6.48-.18,3.78-.76,7.54-1.17,11.31a11,11,0,0,0,2-4.71q7-30.72,14-61.46c1.54-6.73,6.54-11.19,13.43-11.23q39.48-.2,79,0c7.12,0,12.05,4.52,13.68,11.59,4.44,19.31,8.83,38.62,13.28,58.13,3.58-10.38,3.59-10.62,14.91-10.24,12.87.43,25.73,1.18,38.57,2.07,7.25.5,7.76,1.36,7.6,8.6,0,2,0,4-.16,6-.77,11.76-5.18,18.21-14,20.14m-41-15.13c3.69,10.5,6.91,19.63,10.12,28.77l-1.53.51c-3.75-10.25-7.5-20.51-11.31-30.9h-5.24c-14.59,0-29.22-.73-43.75.17s-28.77-.24-43.15-.21c-15.58,0-31.17,0-47,0-3.81,10.46-7.57,20.76-11.32,31.06l-1.55-.56c3.29-9.3,6.57-18.61,10.29-29.14a70.61,70.61,0,0,1-40,15.36c1,8.43,1.74,16.5,3,24.51.52,3.38,2.83,4.83,6.64,4.3a129.49,129.49,0,0,1,15.51-1c22.12-.43,44.23-1,66.34-1,21.11-.05,42.22.35,63.32.73,20.26.36,40.52,1,60.78,1.25,1.85,0,4.64-2,5.44-3.72,3.63-8,2.19-16.61,2.31-25.17-14.46-.86-26.79-5.88-38.94-14.89M357.77,77.53c14.07,0,28.14-.08,42.2.06,3.16,0,4.61-.8,4.45-4.19-.2-4.34-.13-8.71,0-13.06.08-2.83-1.17-3.84-3.9-3.84q-42.19.07-84.39,0c-3.16,0-4,1.45-3.95,4.32.13,4.18.19,8.38,0,12.55-.17,3.37,1.25,4.25,4.44,4.22,13.72-.14,27.45-.06,41.18-.06M256.36,27.06a1279.41,1279.41,0,0,1,203.72,0V17.87c-9.28,1.87-18.92-2.88-26.78,3.31-5.83-1.4-11.41-3.84-17-3.89q-56.81-.52-113.62,0c-6.6.06-13.18,2.42-19.4,3.64-8.58-5.2-17.93-1.67-26.91-2.82Zm-39.1,28.66,1.63.18c0-2.15-.09-4.3,0-6.45s.35-4.33.66-6.47c1.21-8.43,1.47-8.87,9.83-10.72,8.08-1.79,16.24-3.25,24.63-4.9,0-7.07.05-14.24,0-21.4,0-3.42-1.61-5-5.34-4.88A203.64,203.64,0,0,1,226.57,1C221.2.62,219.22,3,219,7.64c-.65,16-1.19,32.05-1.77,48.08M462.6,27.24c9.71,2.05,18.85,3.9,27.95,5.95,4,.9,6.61,2.85,6.41,7.86-.21,5.28.74,10.62,1.18,15.93.43-11,.64-22,.35-33a158.12,158.12,0,0,0-1.95-19.41c-.2-1.31-2.45-3.24-3.82-3.29q-13.07-.47-26.15,0c-1.35.05-3.74,2.05-3.79,3.23-.35,7.65-.18,15.32-.18,22.71M306.11,55.62H410.62c-1.25-2,.57-6.19-4.23-6.33-6.35-.19-12.69-.81-19-.77-24.59.16-49.18.67-73.77.65-5.26,0-7.83,1.36-7.48,6.45M407.74,40.13c-2.21-1.38-3.45-2.74-4.82-2.89a132.09,132.09,0,0,0-15-.88q-36.9.26-73.81.79c-3.34,0-3.34.21-3.51,3ZM358.5,84.42A10.19,10.19,0,0,0,348,94.29a10.35,10.35,0,1,0,20.69.29A10.06,10.06,0,0,0,358.5,84.42m43.06-4.21c10.32.53,12.87,2.42,16,11,1.88,5.19,3.69,10.39,5.52,15.59l1.34-.42c-3.59-16-7.18-31.95-10.82-48.18l-7.38.38c0,4.18.15,7.85,0,11.5s1.71,8-4.59,10.15M302.9,58.49c-3.59,16.1-7.11,31.91-10.64,47.72l1.45.36c1.6-4.85,3.44-9.64,4.76-14.56,2.15-8,7.08-12.09,15.12-11.72C307,74,312.43,65.6,309.66,58.49Zm5.81-14.34c0,.56,0,1.11,0,1.67h99.06c0-.55,0-1.11,0-1.67a780.06,780.06,0,0,0-99.09,0m159.64,77.53c6.46.21,11.89-5.21,12.14-12.11.23-6.73-4.87-11.75-12.13-11.91s-13,4.69-13.54,11.43,5.58,12.32,13.53,12.59M351.76,82.75c-.13-.44-.26-.88-.4-1.32-15.3,1.4-30.92-2.05-46,3.13,13.72.87,27.4,1,41.07.75,1.79,0,3.54-1.66,5.31-2.56M412,85.43c-5-3.92-37.33-5.58-47.85-2.73,2.64,1.13,4.5,2.6,6.38,2.62,13.51.2,27,.11,41.47.11M296,105.31c.15.4.31.8.47,1.2H350c-1-1.54-2.47-2.81-3.93-2.82q-23.31-.21-46.62,0c-1.15,0-2.28,1.06-3.42,1.63m124,1.22c.16-.5.32-1,.49-1.5-1.11-.47-2.22-1.35-3.33-1.36-15.43-.09-30.85-.12-46.27,0-1.53,0-3,1.22-4.56,1.87l.48,1ZM257.92,90.61l-26,2.89c.44,4.89.81,8.84,1.3,14.19,2.34-7.77,6.49-12.14,13.46-13s12.07,2.39,15.8,7.86l5.16-6.13h-9.25c-.15-2-.28-3.58-.46-5.8m225.33,16.44c.45-3.64,1.17-6.47,1-9.26-.09-1.5-1.49-4-2.61-4.21-7.61-1.27-15.31-2-23-3-.25,2.49-.41,4.09-.61,6h-9l5.09,5.78c9.88-12,23.44-10.28,29.14,4.61m-183.46-12h45.3c-3.64-3.51-42.85-3.08-45.3,0m116.91.26.37-.87c-1.11-.57-2.22-1.64-3.34-1.65-13.08-.12-26.17-.1-39.25,0-.88,0-1.75.9-2.63,1.39l.45,1.14Zm29,4.19-2.33,0c-1.6,2.11-4.68,4.44-4.41,6.28.31,2.19,3.25,5.15,5.51,5.63a4.65,4.65,0,0,0,5.75-5.56c-.45-2.32-2.95-4.26-4.52-6.37m-179.55,6.8c.1,3.49,2.66,5.75,5.68,5.14,2.32-.47,5.47-3.23,5.83-5.38.55-3.24-1.95-5.86-5.92-5.65-3.53.19-5.51,2-5.59,5.89M399.4,33.64a687.37,687.37,0,0,0-82.33,0ZM284,94.3c-8.24-3.43-19.93-3.36-24.11,0Zm172.22-.08c0-.43,0-.86,0-1.29-7.52-2.18-15-1.34-22.43,1.29ZM273.31,116.63l-9.38-4.13-5.79,9.64,15.17-5.51m169.84.08,15.17,5.3c-2.25-3.74-4.06-6.73-5.71-9.46l-9.46,4.16M298.68,100.94v.43h44.78v-.43Zm74.52,0v.38h44.53v-.38ZM304,86.82c0,.12.1.25.16.37H344c0-.12,0-.25,0-.37Zm108.69.44v-.38H372.32v.38Zm-70.34,4.07v-.49H302.76c0,.16,0,.33,0,.49Zm31.73-.07H414v-.49H374.06Z"
                />
                <path
                    class="cls-51"
                    d="M461.46,0c-.47,5.13-.93,10.25-1.44,15.9-6.75.34-13.68.64-20.61,1.08-3.55.23-7.36,1.78-10.57.93C407,12.1,384.89,16,362.94,15.19s-44.19-.17-66.29.11c-2.7,0-5.34,2.47-8.09,2.65-3.7.25-7.47-.73-11.22-1-6.82-.43-13.65-.7-20.38-1L254.1,0Z"
                />
                <g class="cls-149">
                    <rect
                        class="cls-150"
                        x="217.57"
                        y="24.78"
                        width="281.47"
                        height="134.41"
                    />
                </g>
                <g class="cls-151">
                    <rect
                        class="cls-152"
                        x="246.17"
                        y="108.45"
                        width="224.6"
                        height="46.32"
                    />
                </g>
                <path
                    class="cls-12"
                    d="M357.77,77.53c-13.73,0-27.46-.08-41.18.06-3.19,0-4.61-.85-4.44-4.22.2-4.17.14-8.37,0-12.55-.09-2.87.79-4.33,3.95-4.32q42.19.07,84.39,0c2.73,0,4,1,3.9,3.84-.11,4.35-.18,8.71,0,13.06.16,3.39-1.29,4.22-4.45,4.19-14.06-.14-28.13-.06-42.2-.06"
                />
                <path
                    class="cls-12"
                    d="M256.36,27.06v-9c9,1.16,18.33-2.38,26.91,2.82,6.22-1.22,12.8-3.58,19.4-3.64q56.81-.54,113.62,0c5.6.05,11.17,2.49,17,3.89,7.86-6.19,17.5-1.44,26.78-3.31V27a1279.41,1279.41,0,0,0-203.72,0"
                />
                <path
                    class="cls-2"
                    d="M217.26,55.72c.58-16,1.12-32,1.77-48.08.19-4.68,2.17-7,7.54-6.62a203.64,203.64,0,0,0,22.1.06C252.4,1,254,2.53,254,6c.07,7.16,0,14.33,0,21.4-8.39,1.65-16.55,3.11-24.63,4.9-8.36,1.85-8.62,2.29-9.84,10.72-.3,2.14-.54,4.31-.65,6.47s0,4.3,0,6.45l-1.63-.18"
                />
                <path
                    class="cls-2"
                    d="M462.6,27.24c0-7.39-.17-15.06.18-22.71.05-1.18,2.43-3.18,3.79-3.23q13.06-.44,26.15,0c1.37,0,3.62,2,3.82,3.29A158.12,158.12,0,0,1,498.49,24c.29,11,.08,22-.35,33-.44-5.31-1.39-10.65-1.18-15.93.2-5-2.39-7-6.41-7.86-9.1-2-18.24-3.9-27.95-5.95"
                />
                <path
                    class="cls-12"
                    d="M306.11,55.62c-.35-5.09,2.22-6.45,7.48-6.45,24.59,0,49.18-.49,73.77-.65,6.34,0,12.68.58,19,.77,4.8.14,3,4.28,4.23,6.33Z"
                />
                <path
                    class="cls-12"
                    d="M407.74,40.13H310.6c.17-2.77.17-2.94,3.51-3q36.9-.48,73.81-.79a132.09,132.09,0,0,1,15,.88c1.37.15,2.61,1.51,4.82,2.89"
                />
                <path
                    class="cls-51"
                    d="M358.5,84.41a10.08,10.08,0,0,1,10.19,10.17A10.35,10.35,0,1,1,348,94.29a10.21,10.21,0,0,1,10.5-9.88"
                />
                <g class="cls-153">
                    <rect
                        class="cls-154"
                        x="401.56"
                        y="58.18"
                        width="22.84"
                        height="48.6"
                    />
                </g>
                <g class="cls-155">
                    <rect
                        class="cls-156"
                        x="292.26"
                        y="58.49"
                        width="21.32"
                        height="48.07"
                    />
                </g>
                <path
                    class="cls-12"
                    d="M308.71,44.15a780.06,780.06,0,0,1,99.09,0v1.67H308.75c0-.56,0-1.11,0-1.67"
                />
                <path
                    class="cls-2"
                    d="M468.35,121.68c-8-.27-14-5.93-13.53-12.59s6.27-11.6,13.54-11.43,12.36,5.18,12.13,11.91c-.25,6.9-5.68,12.32-12.14,12.11m-.24-22.05c-5.6-.08-10.48,4.45-10.55,9.77-.06,4.87,4.94,10,9.9,10.15,5.18.17,10.71-4.79,10.87-9.75.17-5.3-4.64-10.09-10.22-10.17"
                />
                <path
                    class="cls-12"
                    d="M351.76,82.75c-1.77.9-3.52,2.53-5.31,2.56-13.67.22-27.35.12-41.07-.75,15.06-5.18,30.68-1.73,46-3.13.13.44.27.88.4,1.32"
                />
                <path
                    class="cls-12"
                    d="M412,85.43c-14.43,0-28,.09-41.47-.11-1.88,0-3.74-1.49-6.38-2.62C374.65,79.85,407,81.51,412,85.43"
                />
                <path
                    class="cls-2"
                    d="M239.5,118.73c-3.78-4.34-4.68-9.31-2.37-14.48,1.91-4.27,5.43-6.56,10.38-6.64,5.27-.08,9.7,1.2,12.17,6.24,2.36,4.8,1.8,9.4-1.48,13.65-4.11,1.09-8.16,2.56-12.34,3.11-2,.27-4.23-1.2-6.36-1.88m9-19.1c-5.58,0-10.52,4.76-10.35,10,.17,5,5.58,10.14,10.61,10s10.32-5.58,10.14-10.52-5.05-9.45-10.4-9.44"
                />
                <path
                    class="cls-12"
                    d="M296,105.31c1.14-.57,2.27-1.62,3.42-1.63q23.31-.17,46.62,0c1.46,0,2.91,1.28,3.93,2.82h-53.5c-.16-.4-.32-.8-.47-1.2"
                />
                <path
                    class="cls-12"
                    d="M420,106.53H366.81c-.16-.33-.33-.65-.49-1,1.52-.65,3-1.86,4.57-1.87,15.42-.14,30.84-.11,46.27,0,1.11,0,2.22.89,3.33,1.36-.17.5-.33,1-.49,1.5"
                />
                <g class="cls-27">
                    <g class="cls-157">
                        <path
                            class="cls-29"
                            d="M257.92,90.61c.18,2.22.31,3.83.46,5.8h9.25l-5.16,6.13c-3.73-5.47-8.84-8.74-15.8-7.86s-11.12,5.24-13.46,13c-.49-5.35-.86-9.3-1.3-14.19l26-2.89"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-158">
                        <path
                            class="cls-29"
                            d="M483.25,107.05c-5.7-14.89-19.26-16.64-29.14-4.61L449,96.66h9c.2-2,.36-3.56.61-6,7.67.93,15.37,1.7,23,3,1.12.18,2.52,2.7,2.61,4.21.16,2.79-.56,5.62-1,9.26"
                        />
                    </g>
                </g>
                <path
                    class="cls-12"
                    d="M299.79,95.05c2.45-3.08,41.66-3.51,45.3,0Z"
                />
                <path
                    class="cls-12"
                    d="M416.7,95.31H372.3l-.45-1.14c.88-.49,1.75-1.39,2.63-1.39,13.08-.09,26.17-.11,39.25,0,1.12,0,2.23,1.08,3.34,1.66-.12.28-.25.57-.37.86"
                />
                <g class="cls-27">
                    <g class="cls-159">
                        <path
                            class="cls-29"
                            d="M445.67,97.5c1.57,2.11,4.07,4,4.52,6.37a4.65,4.65,0,0,1-5.75,5.56c-2.26-.48-5.2-3.44-5.51-5.63-.27-1.84,2.81-4.17,4.41-6.28l2.33,0"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-160">
                        <path
                            class="cls-29"
                            d="M266.12,104.3c.08-3.9,2.06-5.7,5.59-5.89,4-.21,6.46,2.41,5.92,5.65-.36,2.15-3.52,4.91-5.83,5.38-3,.61-5.58-1.65-5.68-5.14"
                        />
                    </g>
                </g>
                <path
                    class="cls-12"
                    d="M399.4,33.64H317.07a687.37,687.37,0,0,1,82.33,0"
                />
                <g class="cls-27">
                    <g class="cls-161">
                        <path
                            class="cls-29"
                            d="M284,94.3H259.89c4.18-3.36,15.87-3.43,24.11,0"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-162">
                        <path
                            class="cls-29"
                            d="M456.22,94.22H433.75c7.43-2.63,14.91-3.47,22.43-1.29,0,.43,0,.86,0,1.29"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-163">
                        <path
                            class="cls-29"
                            d="M273.31,116.63l-15.17,5.51,5.79-9.64,9.38,4.13"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-164">
                        <path
                            class="cls-29"
                            d="M443.15,116.71l9.46-4.16c1.65,2.73,3.46,5.72,5.71,9.46l-15.17-5.3"
                        />
                    </g>
                </g>
                <path class="cls-12" d="M298.68,100.94h44.78v.43H298.68v-.43" />
                <path class="cls-12" d="M373.2,100.94h44.53v.38H373.2v-.38" />
                <path
                    class="cls-12"
                    d="M304,86.82h40c0,.12,0,.25,0,.37H304.13l-.15-.37"
                />
                <path class="cls-12" d="M412.67,87.26H372.32v-.38h40.35v.38" />
                <path
                    class="cls-12"
                    d="M342.33,91.33H302.77c0-.16,0-.33,0-.49h39.56v.49"
                />
                <rect
                    class="cls-12"
                    x="374.06"
                    y="90.77"
                    width="39.93"
                    height="0.49"
                />
                <g class="cls-27">
                    <g class="cls-165">
                        <path
                            class="cls-29"
                            d="M239.5,118.73c2.13.68,4.36,2.15,6.36,1.88,4.18-.55,8.23-2,12.34-3.11-4.46,6.26-12,6.76-18.7,1.23"
                        />
                    </g>
                </g>
                <path
                    class="cls-2"
                    d="M480,61.2c-12.92-1.37-26.35-2.82-39.79-4.18-3.65-.37-7.38-.17-11-.82-1.48-.26-3.53-1.83-3.89-3.19-1.49-5.61-2.39-11.38-3.6-17.07-.8-3.75,1-5,4.36-4.66,15.42,1.63,30.85,3.19,46.25,5.09a11.49,11.49,0,0,1,10.32,8.94c.93,3.54,2.07,7,2.83,10.6.85,4,.22,7-5.51,5.29m1.11-5.66-54.05-4.88-.65,1.59c1.46.73,2.86,1.93,4.38,2.11,16.85,2,33.71,3.83,50.58,5.68.25,0,.55-.3,1-.56-.38-1.22-.78-2.47-1.24-3.94m-2.9-9.11c.16-.72.31-1.44.47-2.16-17.72-4.24-36-3.64-54.41-5.05.83,1.51,2,2.72,3.28,2.85,8.12.81,16.27,1.37,24.4,2.06,8.76.74,17.51,1.53,26.26,2.3m-52.5-1.28c-.07.69-.13,1.39-.19,2.08l54.65,5,.18-1.78c-18.06-3.15-36.37-4.06-54.64-5.34m46.93-5.94.15-1.45-49.13-4.83c-.06.68-.13,1.36-.2,2l49.18,4.23"
                />
                <path
                    class="cls-2"
                    d="M235.53,60.89c-4.4,1.65-5.45-.79-4.59-4.41,1.11-4.68,2.11-9.48,4.05-13.84,2.8-6.27,9.22-6.63,14.95-7.31,12.91-1.53,25.87-2.68,38.81-4,5.44-.55,6.43.24,5.65,5.52-.84,5.59-2,11.14-3.29,16.64a4.25,4.25,0,0,1-2.83,2.71c-17.57,1.68-35.16,3.16-52.75,4.69m54.57-8.64-1-1.67c-16.76,1.62-33.51,3.3-50.27,4.78-3.14.28-5.15.85-4.14,4.64,4.11-.57,8.2-1.26,12.32-1.68,13.11-1.36,26.23-2.57,39.34-4,1.29-.15,2.48-1.36,3.71-2.08m-52.6-7,.55,1.36c4.07-.43,8.14-.93,12.22-1.27,13-1.09,25.93-2.08,38.88-3.27,1.21-.12,2.3-1.46,3.45-2.23-.3-.54-.6-1.09-.89-1.64-17.21,1.71-34.42,3.39-51.62,5.19-.92.09-1.73,1.22-2.59,1.86m-1.38,5.23c.07.6.13,1.21.2,1.81l54.49-5.07c-.08-.68-.15-1.37-.22-2.06-18.2,1.32-36.46,2.2-54.47,5.32M293,35l-.2-2.06L243.7,37.79l.14,1.43L293,35"
                />
                <g class="cls-27">
                    <g class="cls-166">
                        <path
                            class="cls-29"
                            d="M468.11,99.63c5.58.08,10.39,4.87,10.22,10.17-.16,5-5.69,9.92-10.87,9.75-5-.16-10-5.28-9.9-10.15.07-5.32,4.95-9.85,10.55-9.77"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-167">
                        <path
                            class="cls-29"
                            d="M248.54,99.63c5.35,0,10.22,4.41,10.4,9.44s-5.05,10.37-10.14,10.52-10.44-5-10.61-10c-.17-5.2,4.77-10,10.35-10"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-168">
                        <path
                            class="cls-29"
                            d="M481.14,55.54c.46,1.47.86,2.72,1.24,3.94-.43.26-.73.59-1,.56-16.86-1.85-33.73-3.69-50.58-5.68-1.52-.18-2.92-1.38-4.38-2.11l.65-1.59,54.05,4.88"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-169">
                        <path
                            class="cls-29"
                            d="M478.24,46.43c-8.75-.77-17.5-1.56-26.26-2.31-8.13-.68-16.28-1.24-24.4-2-1.28-.13-2.45-1.34-3.28-2.85,18.36,1.41,36.69.81,54.41,5.05-.16.72-.31,1.44-.47,2.16"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-170">
                        <path
                            class="cls-29"
                            d="M425.74,45.15c18.27,1.28,36.58,2.19,54.64,5.34l-.18,1.78-54.65-5c.06-.69.12-1.39.19-2.08"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-171">
                        <path
                            class="cls-29"
                            d="M472.67,39.21,423.49,35c.07-.69.14-1.37.2-2l49.13,4.83-.15,1.45"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-172">
                        <path
                            class="cls-29"
                            d="M290.1,52.25c-1.23.72-2.42,1.94-3.71,2.08-13.11,1.42-26.23,2.63-39.34,4-4.12.42-8.21,1.11-12.32,1.68-1-3.79,1-4.36,4.14-4.64,16.76-1.48,33.51-3.16,50.27-4.78l1,1.67"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-173">
                        <path
                            class="cls-29"
                            d="M237.5,45.23c.86-.64,1.67-1.77,2.59-1.86,17.2-1.8,34.41-3.48,51.62-5.19l.88,1.64c-1.14.77-2.23,2.11-3.44,2.23-12.95,1.19-25.92,2.18-38.88,3.27-4.08.34-8.15.84-12.22,1.27l-.55-1.36"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-174">
                        <path
                            class="cls-29"
                            d="M236.12,50.46c18-3.12,36.27-4,54.47-5.32.07.69.14,1.38.22,2.06l-54.5,5.07c-.06-.6-.13-1.21-.19-1.81"
                        />
                    </g>
                </g>
                <g class="cls-27">
                    <g class="cls-175">
                        <path
                            class="cls-29"
                            d="M293,35l-49.14,4.26-.14-1.43,49.08-4.89Z"
                        />
                    </g>
                </g>
                <path
                    class="cls-2"
                    d="M358.47,463.84q20.86,0,41.72,0c10.88,0,16.36,6,16.23,17-.18,14.07-.05,28.15.13,42.22.1,7.22-4.49,13.47-11.58,14.85a39.77,39.77,0,0,1-7.47.68q-39.21.07-78.42,0c-13.86,0-19.52-5.68-19.52-19.52,0-12.4,0-24.8,0-37.2s5.84-18.07,18.19-18q20.36,0,40.72,0m0,2.18c-14.08,0-28.15,0-42.23,0-9.07,0-14.15,4.09-14.48,13.07-.53,14.56-.51,29.15,0,43.71.29,8.91,5.38,13.42,14.31,13.47q42.23.23,84.45,0c8.87,0,14-4.72,14.28-13.51.42-14.39.44-28.82,0-43.21-.26-9.2-5.35-13.49-14.61-13.53-13.91-.06-27.82,0-41.72,0"
                />
                <path
                    class="cls-2"
                    d="M358.5,466c13.9,0,27.81,0,41.72,0,9.26,0,14.35,4.33,14.61,13.53.41,14.39.39,28.82,0,43.21-.27,8.79-5.41,13.46-14.28,13.51q-42.22.23-84.45,0c-8.93,0-14-4.56-14.31-13.47-.48-14.55-.5-29.15,0-43.7.33-9,5.41-13,14.48-13.08,14.08-.06,28.15,0,42.23,0"
                />
                <path
                    v-if="getStatus('capot')"
                    id="capot"
                    @click="openDetail('capot')"
                    :class="getColorStatus('capot')"
                    d="M348.38,252.59a10.75,10.75,0,1,1,10.75,10.75,10.76,10.76,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('capot')"
                    class="cls-176"
                    d="M348.38,252.59a10.75,10.75,0,1,1,10.75,10.75A10.76,10.76,0,0,1,348.38,252.59Z"
                />
                <path
                    v-if="getStatus('luz_trasera_izq')"
                    id="luz_trasera_izq"
                    @click="openDetail('luz_trasera_izq')"
                    :class="getColorStatus('luz_trasera_izq')"
                    d="M263,877.27A10.75,10.75,0,1,1,273.71,888,10.75,10.75,0,0,1,263,877.27"
                />
                <path
                    v-if="getStatus('luz_trasera_izq')"
                    class="cls-176"
                    d="M263,877.27A10.75,10.75,0,1,1,273.71,888,10.75,10.75,0,0,1,263,877.27Z"
                />
                <path
                    v-if="getStatus('luz_trasera_der')"
                    id="luz_trasera_der"
                    @click="openDetail('luz_trasera_der')"
                    :class="getColorStatus('luz_trasera_der')"
                    d="M430.22,877.27A10.75,10.75,0,1,1,441,888a10.75,10.75,0,0,1-10.75-10.75"
                />
                <circle
                    v-if="getStatus('luz_trasera_der')"
                    class="cls-176"
                    cx="440.97"
                    cy="877.27"
                    r="10.75"
                    transform="translate(-84.3 47.72) rotate(-5.65)"
                />
                <path
                    v-if="getStatus('panoramico')"
                    id="panoramico"
                    @click="openDetail('panoramico')"
                    :class="getColorStatus('panoramico')"
                    d="M348.38,373.33a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('panoramico')"
                    class="cls-176"
                    d="M348.38,373.33a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,348.38,373.33Z"
                />
                <path
                    v-if="getStatus('panoramico_trasero')"
                    id="panoramico_trasero"
                    @click="openDetail('panoramico_trasero')"
                    :class="getColorStatus('panoramico_trasero')"
                    d="M348.38,716.42a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('panoramico_trasero')"
                    class="cls-176"
                    d="M348.38,716.42a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,348.38,716.42Z"
                />
                <path
                    v-if="getStatus('guardafangos_delantero_izq')"
                    id="guardafangos_delantero_izq"
                    @click="openDetail('guardafangos_delantero_izq')"
                    :class="getColorStatus('guardafangos_delantero_izq')"
                    d="M87.55,328.44A10.75,10.75,0,1,1,98.3,339.19a10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('guardafangos_delantero_izq')"
                    class="cls-176"
                    d="M87.55,328.44A10.75,10.75,0,1,1,98.3,339.19,10.75,10.75,0,0,1,87.55,328.44Z"
                />
                <path
                    v-if="getStatus('puerta_conductor')"
                    id="puerta_conductor"
                    @click="openDetail('puerta_conductor')"
                    :class="getColorStatus('puerta_conductor')"
                    d="M82.47,443.79a10.75,10.75,0,1,1,10.75,10.75,10.76,10.76,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('puerta_conductor')"
                    class="cls-176"
                    d="M82.47,443.79a10.75,10.75,0,1,1,10.75,10.75A10.76,10.76,0,0,1,82.47,443.79Z"
                />
                <path
                    v-if="getStatus('vidrio_conductor')"
                    id="vidrio_conductor"
                    @click="openDetail('vidrio_conductor')"
                    :class="getColorStatus('vidrio_conductor')"
                    d="M166.34,473.73a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('vidrio_conductor')"
                    class="cls-176"
                    d="M166.34,473.73a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,166.34,473.73Z"
                />
                <path
                    v-if="getStatus('vidrio_trasero_izquierdo')"
                    id="vidrio_trasero_izquierdo"
                    @click="openDetail('vidrio_trasero_izquierdo')"
                    :class="getColorStatus('vidrio_trasero_izquierdo')"
                    d="M166.34,586.15a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('vidrio_trasero_izquierdo')"
                    class="cls-176"
                    d="M166.34,586.15a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,166.34,586.15Z"
                />
                <path
                    v-if="getStatus('vidrio_copiloto')"
                    id="vidrio_copiloto"
                    @click="openDetail('vidrio_copiloto')"
                    :class="getColorStatus('vidrio_copiloto')"
                    d="M528.14,473.73a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('vidrio_copiloto')"
                    class="cls-176"
                    d="M528.14,473.73a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,528.14,473.73Z"
                />
                <path
                    v-if="getStatus('vidrio_trasero_derecho')"
                    id="vidrio_trasero_derecho"
                    @click="openDetail('vidrio_trasero_derecho')"
                    :class="getColorStatus('vidrio_trasero_derecho')"
                    d="M528.14,586.15a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <circle
                    v-if="getStatus('vidrio_trasero_derecho')"
                    class="cls-176"
                    cx="538.89"
                    cy="586.15"
                    r="10.75"
                    transform="translate(-183.29 250.84) rotate(-22.5)"
                />
                <path
                    v-if="getStatus('puerta_trasera_izquierda')"
                    id="puerta_trasera_izquierda"
                    @click="openDetail('puerta_trasera_izquierda')"
                    :class="getColorStatus('puerta_trasera_izquierda')"
                    d="M82.47,587.58a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('puerta_trasera_izquierda')"
                    class="cls-176"
                    d="M82.47,587.58a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,82.47,587.58Z"
                />
                <path
                    v-if="getStatus('guardafangos_trasero_izq')"
                    id="guardafangos_trasero_izq"
                    @click="openDetail('guardafangos_trasero_izq')"
                    :class="getColorStatus('guardafangos_trasero_izq')"
                    d="M86.66,726.6a10.76,10.76,0,1,1,10.76,10.75A10.75,10.75,0,0,1,86.66,726.6"
                />
                <path
                    v-if="getStatus('guardafangos_trasero_izq')"
                    class="cls-176"
                    d="M86.66,726.6a10.76,10.76,0,1,1,10.76,10.75A10.75,10.75,0,0,1,86.66,726.6Z"
                />
                <path
                    v-if="getStatus('puerta_copiloto')"
                    id="puerta_copiloto"
                    @click="openDetail('puerta_copiloto')"
                    :class="getColorStatus('puerta_copiloto')"
                    d="M618.2,443.79A10.75,10.75,0,1,1,629,454.54a10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('puerta_copiloto')"
                    class="cls-176"
                    d="M618.2,443.79A10.75,10.75,0,1,1,629,454.54,10.75,10.75,0,0,1,618.2,443.79Z"
                />
                <path
                    v-if="getStatus('puerta_trasera_izquierda')"
                    id="puerta_trasera_izquierda"
                    @click="openDetail('puerta_trasera_izquierda')"
                    data-name="puerta_trasera_izquierda"
                    :class="getColorStatus('puerta_trasera_izquierda')"
                    d="M618.2,587.58A10.75,10.75,0,1,1,629,598.33a10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('puerta_trasera_izquierda')"
                    class="cls-176"
                    d="M618.2,587.58A10.75,10.75,0,1,1,629,598.33,10.75,10.75,0,0,1,618.2,587.58Z"
                />
                <path
                    v-if="getStatus('guardafangos_delantero_der')"
                    id="guardafangos_delantero_der"
                    @click="openDetail('guardafangos_delantero_der')"
                    :class="getColorStatus('guardafangos_delantero_der')"
                    d="M606.23,328.51A10.75,10.75,0,1,1,617,339.26a10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('guardafangos_delantero_der')"
                    class="cls-176"
                    d="M606.23,328.51A10.75,10.75,0,1,1,617,339.26,10.75,10.75,0,0,1,606.23,328.51Z"
                />
                <path
                    v-if="getStatus('estribo_izquierdo')"
                    id="estribo_izquierdo"
                    @click="openDetail('estribo_izquierdo')"
                    :class="getColorStatus('estribo_izquierdo')"
                    d="M23.32,502.32a10.75,10.75,0,1,1,10.75,10.76,10.75,10.75,0,0,1-10.75-10.76"
                />
                <path
                    v-if="getStatus('estribo_izquierdo')"
                    class="cls-176"
                    d="M23.32,502.32a10.75,10.75,0,1,1,10.75,10.76A10.75,10.75,0,0,1,23.32,502.32Z"
                />
                <path
                    v-if="getStatus('estribo_derecho')"
                    id="estribo_derecho"
                    @click="openDetail('estribo_derecho')"
                    :class="getColorStatus('estribo_derecho')"
                    d="M672,502.32a10.75,10.75,0,1,1,10.75,10.76A10.75,10.75,0,0,1,672,502.32"
                />
                <path
                    v-if="getStatus('estribo_derecho')"
                    class="cls-176"
                    d="M672,502.32a10.75,10.75,0,1,1,10.75,10.76A10.75,10.75,0,0,1,672,502.32Z"
                />
                <path
                    v-if="getStatus('guardafangos_trasero_der')"
                    id="guardafangos_trasero_der"
                    @click="openDetail('guardafangos_trasero_der')"
                    :class="getColorStatus('guardafangos_trasero_der')"
                    d="M615.42,728.25A10.75,10.75,0,1,1,626.17,739a10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('guardafangos_trasero_der')"
                    class="cls-176"
                    d="M615.42,728.25A10.75,10.75,0,1,1,626.17,739,10.75,10.75,0,0,1,615.42,728.25Z"
                />
                <path
                    v-if="getStatus('bomper_trasero')"
                    id="bomper_trasero"
                    @click="openDetail('bomper_trasero')"
                    :class="getColorStatus('bomper_trasero')"
                    d="M348.42,932.15a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('bomper_trasero')"
                    class="cls-176"
                    d="M348.42,932.15a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,348.42,932.15Z"
                />
                <path
                    v-if="getStatus('tapa_baul')"
                    id="tapa_baul"
                    @click="openDetail('tapa_baul')"
                    :class="getColorStatus('tapa_baul')"
                    d="M348.42,788.86a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('tapa_baul')"
                    class="cls-176"
                    d="M348.42,788.86a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,348.42,788.86Z"
                />
                <path
                    v-if="getStatus('techo')"
                    id="techo"
                    @click="openDetail('techo')"
                    :class="getColorStatus('techo')"
                    d="M348.42,596.5a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('techo')"
                    class="cls-176"
                    d="M348.42,596.5a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,348.42,596.5Z"
                />
                <path
                    v-if="getStatus('sunroof')"
                    id="sunroof"
                    @click="openDetail('sunroof')"
                    :class="getColorStatus('sunroof')"
                    d="M348.42,498.86a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('sunroof')"
                    class="cls-176"
                    d="M348.42,498.86a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,348.42,498.86Z"
                />
                <path
                    v-if="getStatus('stop_trasero')"
                    id="stop_trasero"
                    @click="openDetail('stop_trasero')"
                    :class="getColorStatus('stop_trasero')"
                    d="M348.42,671.44a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('stop_trasero')"
                    class="cls-176"
                    d="M348.42,671.44a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,348.42,671.44Z"
                />
                <path
                    v-if="getStatus('bomper_delantero')"
                    id="bomper_delantero"
                    @click="openDetail('bomper_delantero')"
                    :class="getColorStatus('bomper_delantero')"
                    d="M348.38,65.09a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('bomper_delantero')"
                    class="cls-176"
                    d="M348.38,65.09a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,348.38,65.09Z"
                />
                <path
                    v-if="getStatus('exploradora_izquierda')"
                    id="exploradora_izquierda"
                    @click="openDetail('exploradora_izquierda')"
                    :class="getColorStatus('exploradora_izquierda')"
                    d="M253.62,44.83a10.75,10.75,0,1,1,10.75,10.75,10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('exploradora_izquierda')"
                    class="cls-176"
                    d="M253.62,44.83a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,253.62,44.83Z"
                />
                <path
                    v-if="getStatus('exploradora_derecha')"
                    id="exploradora_derecha"
                    @click="openDetail('exploradora_derecha')"
                    :class="getColorStatus('exploradora_derecha')"
                    d="M444,44.83a10.76,10.76,0,1,1,10.76,10.75A10.75,10.75,0,0,1,444,44.83"
                />
                <path
                    v-if="getStatus('exploradora_derecha')"
                    class="cls-176"
                    d="M444,44.83a10.76,10.76,0,1,1,10.76,10.75A10.75,10.75,0,0,1,444,44.83Z"
                />
                <path
                    v-if="getStatus('luz_trasera_der')"
                    id="luz_trasera_der"
                    @click="openDetail('luz_trasera_der')"
                    :class="getColorStatus('luz_trasera_der')"
                    d="M263,103.42a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,263,103.42"
                />
                <path
                    v-if="getStatus('luz_trasera_der')"
                    class="cls-176"
                    d="M263,103.42a10.75,10.75,0,1,1,10.75,10.75A10.75,10.75,0,0,1,263,103.42Z"
                />
                <path
                    v-if="getStatus('farola_derecha')"
                    id="farola_derecha"
                    @click="openDetail('farola_derecha')"
                    :class="getColorStatus('farola_derecha')"
                    d="M430.22,102.21A10.75,10.75,0,1,1,441,113a10.75,10.75,0,0,1-10.75-10.75"
                />
                <path
                    v-if="getStatus('farola_derecha')"
                    class="cls-176"
                    d="M430.22,102.21A10.75,10.75,0,1,1,441,113,10.75,10.75,0,0,1,430.22,102.21Z"
                />
            </g>
        </g>
    </svg>
</template>

<script>
import exteriorJSON from "modules/backend/inspecciones/editar/center_panel/fields/exterior.json";
import {UPDATE_PROCESO_CHEQUEOCARD} from "store/store-constants";
import {UPDATE_CARPETA_CHEQUEOCARD} from 'store/store-constants';
export default {
    props: {
        isFront: {
            type: Boolean,
            default: false
        },
        isCarpeta: {
            type: Boolean,
            default: false
        } 
    },
    computed: {
        exteriorArray() {
            if(this.isCarpeta) {
                if(this.isFront){
                    return this.$store.state.fichaTecnica.vehiculo.tabs.inspeccion.exterior;
                }else{
                    return this.$store.state.adminventa_carpeta.consignacion.proceso.inspeccion_mecanica.inspeccion_resultado.exterior; 
                }
            }else {
                if(this.isFront){
                    return this.$store.state.fichaTecnica.vehiculo.tabs.inspeccion.exterior;
                }else{
                    return this.$store.state.proceso.proceso.inspeccion_mecanica.inspeccion_resultado.exterior; 
                }
            }
        }
    },
    methods: {
        getStatus(slug){
            var detail = this.exteriorArray[slug];
            if(detail.photo && detail.selector !== 'No Aplica'){
                return true;
            }else{
                return false;
            }
        },
        getColorStatus(slug){
            var detail = this.exteriorArray[slug];
            switch (detail.selector) {
                case 'Excelente':
                case 'Bueno':
                case 'Original':
                    return 'cls-147_green'
                case 'Pintado':
                case 'Sustituido':
                case 'Sumido':
                case 'Repintado':
                case 'Reparado':
                case 'Rayado':
                    return 'cls-147_yellow'
                case 'Golpe Medio':
                case 'Golpe Fuerte':
                case 'Malo':
                case 'Mal reparado':
                    return 'cls-147'
                default:
                    return 'cls-147'
            }
        },
        openDetail(slug) {
            var exteriorFields = exteriorJSON.exteriorFields.find(element => element.slug === slug);
            var detail = this.exteriorArray[slug];
            var data = {
                ...detail,
                title: exteriorFields.label
            }
            if(this.isCarpeta) {
                this.$store.commit(UPDATE_CARPETA_CHEQUEOCARD, data);
            }else {
                this.$store.commit(UPDATE_PROCESO_CHEQUEOCARD, data);
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.cls-1,
.cls-176 {
    fill: none;
}
.cls-2 {
    fill: #222220;
}
.cls-3 {
    fill: #d9d9d9;
}
.cls-4 {
    clip-path: url(#clip-path);
}
.cls-5 {
    fill: url(#Degradado_sin_nombre_28);
}
.cls-6 {
    clip-path: url(#clip-path-2);
}
.cls-7 {
    fill: url(#Degradado_sin_nombre_28-2);
}
.cls-8 {
    clip-path: url(#clip-path-3);
}
.cls-9 {
    fill: url(#Degradado_sin_nombre_28-3);
}
.cls-10 {
    clip-path: url(#clip-path-4);
}
.cls-11 {
    fill: url(#Degradado_sin_nombre_28-4);
}
.cls-12 {
    fill: #3e3e3d;
}
.cls-13 {
    clip-path: url(#clip-path-5);
}
.cls-14 {
    fill: url(#Degradado_sin_nombre_28-5);
}
.cls-15 {
    clip-path: url(#clip-path-6);
}
.cls-16 {
    fill: url(#Degradado_sin_nombre_28-6);
}
.cls-17 {
    clip-path: url(#clip-path-7);
}
.cls-18 {
    fill: url(#Degradado_sin_nombre_28-7);
}
.cls-19 {
    clip-path: url(#clip-path-8);
}
.cls-20 {
    fill: url(#Degradado_sin_nombre_28-8);
}
.cls-21 {
    clip-path: url(#clip-path-9);
}
.cls-22 {
    fill: url(#Degradado_sin_nombre_28-9);
}
.cls-23 {
    clip-path: url(#clip-path-10);
}
.cls-24 {
    fill: url(#Degradado_sin_nombre_28-10);
}
.cls-25 {
    clip-path: url(#clip-path-11);
}
.cls-26 {
    fill: url(#Degradado_sin_nombre_28-11);
}
.cls-27 {
    opacity: 0.5;
}
.cls-28 {
    clip-path: url(#clip-path-12);
}
.cls-29 {
    fill: #f7ea3a;
}
.cls-30 {
    clip-path: url(#clip-path-13);
}
.cls-31 {
    clip-path: url(#clip-path-14);
}
.cls-32 {
    fill: url(#Degradado_sin_nombre_28-12);
}
.cls-33 {
    clip-path: url(#clip-path-15);
}
.cls-34 {
    fill: url(#Degradado_sin_nombre_28-13);
}
.cls-35 {
    clip-path: url(#clip-path-16);
}
.cls-36 {
    fill: url(#Degradado_sin_nombre_28-14);
}
.cls-37 {
    clip-path: url(#clip-path-17);
}
.cls-38 {
    fill: url(#Degradado_sin_nombre_28-15);
}
.cls-39 {
    clip-path: url(#clip-path-18);
}
.cls-40 {
    fill: url(#Degradado_sin_nombre_28-16);
}
.cls-41 {
    clip-path: url(#clip-path-19);
}
.cls-42 {
    fill: url(#Degradado_sin_nombre_28-17);
}
.cls-43 {
    clip-path: url(#clip-path-20);
}
.cls-44 {
    fill: url(#Degradado_sin_nombre_28-18);
}
.cls-45 {
    clip-path: url(#clip-path-21);
}
.cls-46 {
    fill: url(#Degradado_sin_nombre_28-19);
}
.cls-47 {
    clip-path: url(#clip-path-22);
}
.cls-48 {
    fill: url(#Degradado_sin_nombre_28-20);
}
.cls-49 {
    clip-path: url(#clip-path-23);
}
.cls-50 {
    fill: url(#Degradado_sin_nombre_28-21);
}
.cls-51 {
    fill: #fff;
}
.cls-52 {
    clip-path: url(#clip-path-24);
}
.cls-53 {
    fill: url(#Degradado_sin_nombre_28-22);
}
.cls-54 {
    clip-path: url(#clip-path-25);
}
.cls-55 {
    fill: url(#Degradado_sin_nombre_28-23);
}
.cls-56 {
    clip-path: url(#clip-path-26);
}
.cls-57 {
    fill: url(#Degradado_sin_nombre_28-24);
}
.cls-58 {
    clip-path: url(#clip-path-27);
}
.cls-59 {
    fill: url(#Degradado_sin_nombre_28-25);
}
.cls-60 {
    clip-path: url(#clip-path-28);
}
.cls-61 {
    fill: url(#Degradado_sin_nombre_28-26);
}
.cls-62 {
    clip-path: url(#clip-path-29);
}
.cls-63 {
    fill: #c20d19;
}
.cls-64 {
    clip-path: url(#clip-path-30);
}
.cls-65 {
    clip-path: url(#clip-path-31);
}
.cls-66 {
    fill: url(#Degradado_sin_nombre_28-27);
}
.cls-67 {
    clip-path: url(#clip-path-32);
}
.cls-68 {
    fill: url(#Degradado_sin_nombre_28-28);
}
.cls-69 {
    clip-path: url(#clip-path-33);
}
.cls-70 {
    fill: url(#Degradado_sin_nombre_40);
}
.cls-71 {
    clip-path: url(#clip-path-34);
}
.cls-72 {
    fill: url(#Degradado_sin_nombre_40-2);
}
.cls-73 {
    clip-path: url(#clip-path-35);
}
.cls-74 {
    fill: url(#Degradado_sin_nombre_40-3);
}
.cls-75 {
    clip-path: url(#clip-path-36);
}
.cls-76 {
    fill: url(#Degradado_sin_nombre_40-4);
}
.cls-77 {
    clip-path: url(#clip-path-37);
}
.cls-78 {
    fill: url(#Degradado_sin_nombre_40-5);
}
.cls-79 {
    clip-path: url(#clip-path-38);
}
.cls-80 {
    fill: url(#Degradado_sin_nombre_40-6);
}
.cls-81 {
    clip-path: url(#clip-path-39);
}
.cls-82 {
    fill: url(#Degradado_sin_nombre_40-7);
}
.cls-83 {
    clip-path: url(#clip-path-40);
}
.cls-84 {
    fill: url(#Degradado_sin_nombre_40-8);
}
.cls-85 {
    clip-path: url(#clip-path-41);
}
.cls-86 {
    fill: url(#Degradado_sin_nombre_40-9);
}
.cls-87 {
    clip-path: url(#clip-path-42);
}
.cls-88 {
    clip-path: url(#clip-path-43);
}
.cls-89 {
    fill: url(#Degradado_sin_nombre_40-10);
}
.cls-90 {
    clip-path: url(#clip-path-44);
}
.cls-91 {
    clip-path: url(#clip-path-45);
}
.cls-92 {
    clip-path: url(#clip-path-46);
}
.cls-93 {
    clip-path: url(#clip-path-47);
}
.cls-94 {
    clip-path: url(#clip-path-48);
}
.cls-95 {
    fill: url(#Degradado_sin_nombre_51);
}
.cls-96 {
    clip-path: url(#clip-path-49);
}
.cls-97 {
    clip-path: url(#clip-path-50);
}
.cls-98 {
    fill: url(#Degradado_sin_nombre_40-11);
}
.cls-99 {
    clip-path: url(#clip-path-51);
}
.cls-100 {
    fill: url(#Degradado_sin_nombre_51-2);
}
.cls-101 {
    clip-path: url(#clip-path-52);
}
.cls-102 {
    fill: url(#Degradado_sin_nombre_51-3);
}
.cls-103 {
    clip-path: url(#clip-path-53);
}
.cls-104 {
    fill: url(#Degradado_sin_nombre_51-4);
}
.cls-105 {
    clip-path: url(#clip-path-54);
}
.cls-106 {
    fill: url(#Degradado_sin_nombre_51-5);
}
.cls-107 {
    clip-path: url(#clip-path-55);
}
.cls-108 {
    fill: url(#Degradado_sin_nombre_51-6);
}
.cls-109 {
    clip-path: url(#clip-path-56);
}
.cls-110 {
    fill: url(#Degradado_sin_nombre_51-7);
}
.cls-111 {
    clip-path: url(#clip-path-57);
}
.cls-112 {
    fill: url(#Degradado_sin_nombre_51-8);
}
.cls-113 {
    clip-path: url(#clip-path-58);
}
.cls-114 {
    fill: url(#Degradado_sin_nombre_51-9);
}
.cls-115 {
    clip-path: url(#clip-path-59);
}
.cls-116 {
    fill: url(#Degradado_sin_nombre_51-10);
}
.cls-117 {
    clip-path: url(#clip-path-60);
}
.cls-118 {
    clip-path: url(#clip-path-61);
}
.cls-119 {
    fill: url(#Degradado_sin_nombre_51-11);
}
.cls-120 {
    clip-path: url(#clip-path-62);
}
.cls-121 {
    clip-path: url(#clip-path-63);
}
.cls-122 {
    clip-path: url(#clip-path-64);
}
.cls-123 {
    clip-path: url(#clip-path-65);
}
.cls-124 {
    clip-path: url(#clip-path-66);
}
.cls-125 {
    clip-path: url(#clip-path-67);
}
.cls-126 {
    fill: url(#Degradado_sin_nombre_51-12);
}
.cls-127 {
    clip-path: url(#clip-path-68);
}
.cls-128 {
    clip-path: url(#clip-path-69);
}
.cls-129 {
    clip-path: url(#clip-path-70);
}
.cls-130 {
    clip-path: url(#clip-path-71);
}
.cls-131 {
    fill: url(#Degradado_sin_nombre_61);
}
.cls-132 {
    clip-path: url(#clip-path-72);
}
.cls-133 {
    fill: url(#Degradado_sin_nombre_61-2);
}
.cls-134 {
    clip-path: url(#clip-path-73);
}
.cls-135 {
    fill: url(#Degradado_sin_nombre_61-3);
}
.cls-136 {
    clip-path: url(#clip-path-74);
}
.cls-137 {
    clip-path: url(#clip-path-75);
}
.cls-138 {
    clip-path: url(#clip-path-76);
}
.cls-139 {
    fill: url(#Degradado_sin_nombre_61-4);
}
.cls-140 {
    clip-path: url(#clip-path-77);
}
.cls-141 {
    clip-path: url(#clip-path-78);
}
.cls-142 {
    clip-path: url(#clip-path-79);
}
.cls-143 {
    fill: url(#Degradado_sin_nombre_61-5);
}
.cls-144 {
    clip-path: url(#clip-path-80);
}
.cls-145 {
    fill: url(#Degradado_sin_nombre_61-6);
}
.cls-146 {
    clip-path: url(#clip-path-81);
}
.cls-147 {
    fill: #a21c26;
}
.cls-147_green {
    fill: #155724;
}
.cls-147_yellow {
    fill: #fff3cd;
}
.cls-148 {
    clip-path: url(#clip-path-82);
}
.cls-149 {
    clip-path: url(#clip-path-83);
}
.cls-150 {
    fill: url(#Degradado_sin_nombre_61-7);
}
.cls-151 {
    clip-path: url(#clip-path-84);
}
.cls-152 {
    fill: url(#Degradado_sin_nombre_61-8);
}
.cls-153 {
    clip-path: url(#clip-path-85);
}
.cls-154 {
    fill: url(#Degradado_sin_nombre_61-9);
}
.cls-155 {
    clip-path: url(#clip-path-86);
}
.cls-156 {
    fill: url(#Degradado_sin_nombre_61-10);
}
.cls-157 {
    clip-path: url(#clip-path-87);
}
.cls-158 {
    clip-path: url(#clip-path-88);
}
.cls-159 {
    clip-path: url(#clip-path-89);
}
.cls-160 {
    clip-path: url(#clip-path-90);
}
.cls-161 {
    clip-path: url(#clip-path-91);
}
.cls-162 {
    clip-path: url(#clip-path-92);
}
.cls-163 {
    clip-path: url(#clip-path-93);
}
.cls-164 {
    clip-path: url(#clip-path-94);
}
.cls-165 {
    clip-path: url(#clip-path-95);
}
.cls-166 {
    clip-path: url(#clip-path-96);
}
.cls-167 {
    clip-path: url(#clip-path-97);
}
.cls-168 {
    clip-path: url(#clip-path-98);
}
.cls-169 {
    clip-path: url(#clip-path-99);
}
.cls-170 {
    clip-path: url(#clip-path-100);
}
.cls-171 {
    clip-path: url(#clip-path-101);
}
.cls-172 {
    clip-path: url(#clip-path-102);
}
.cls-173 {
    clip-path: url(#clip-path-103);
}
.cls-174 {
    clip-path: url(#clip-path-104);
}
.cls-175 {
    clip-path: url(#clip-path-105);
}
.cls-176 {
    stroke: #868685;
    stroke-miterlimit: 10;
    stroke-width: 2px;
}
</style>
